<template>
  <div
    class="container addorder"
    :style="
      (FlodMsg && fullDiscountRule.discountenable == 1) ||
      (FlodMsg && discountrule.discountenable == 1) ||
      (FullGiftMsg && fullgiftrule.actstatus == 1)
        ? { 'padding-bottom': '1.05rem' }
        : {}
    "
  >
    <div class="fraud" v-if="fraud != '' && risktips && arg == ''">
      <img src="../../assets/images/bell.png" />
      <p>{{ fraud }}</p>
      <van-icon @click="risktips = false" name="cross" color="#F96A0E" size="0.13rem" />
    </div>
    <div v-if="addressVal.area && arg == ''" class="my_address" @click="address">
      <img src="../../assets/images/addressicon.png" class="addressicon" />
      <div class="addressML">
        <div class="my_main_address">
          <span>{{ addressVal.name }} {{ addressVal.mobile }}</span>
          <img v-if="addressVal.isdefault === '1'" src="../../assets/images/default.png" />
        </div>
        <div class="address">
          {{ addressVal.area + '' + addressVal.address }}
        </div>
        <p class="f11 color-FC0324 flex-ac" style="margin-top: 0.04rem" v-if="areatemp">
          <van-icon color="#FC0324" name="warning-o" size="0.11rem" />
          地址信息不准确，请尽快更正
        </p>
      </div>
      <van-icon name="arrow" />
    </div>
    <div v-if="!addressVal.area && arg == ''" class="no_address" @click="addaddress">
      <van-icon name="plus" />
      <p>添加收货地址</p>
    </div>

    <div class="cart_pro_list">
      <div v-if="changebuystatus == 1" class="changebuy" style="margin-top: 0" @click="goChangebuy">
        <div class="left">
          <img src="/static/images/changebuy/shopping-icon-bargain-2.png?v=1" />
          <p>购买该商品可参与超值换购</p>
        </div>
        <div class="right">
          <p>去换购</p>
          <van-icon name="arrow" size="0.1rem" color="#1D1E1E" />
        </div>
      </div>
      <div class="list">
        <pro-item
          v-for="(item, index) of list"
          :key="index"
          v-if="
            item.isintellrecommend != 1 &&
            (item.isbirthdaygift != 1 ||
              (item.isbirthdaygift == 1 && paymoney >= birthdaygift_paymoney))
          "
          :productItem="item"
        ></pro-item>
        <div v-if="productgify != null && productgify.hasOwnProperty('goodsinfo')">
          <pro-item
            v-for="(item, index) of [productgify.goodsinfo]"
            :key="list.length + index"
            :productItem="item"
            :isprogift="'1'"
          ></pro-item>
        </div>
        <div v-if="subscribegoodslist.length">
          <pro-item
            v-for="item of subscribegoodslist"
            :key="item.skuid"
            :productItem="item"
          ></pro-item>
        </div>
        <div v-if="buygiftlist && buygiftlist.length > 0">
          <pro-item
            v-for="(item, index) of buygiftlist"
            :key="list.length + index"
            :productItem="item"
            :isprogift="'1'"
          ></pro-item>
        </div>
      </div>
      <div class="numtotal">
        <span>
          共{{
            totalnumshow +
            (buygiftnum ? buygiftnum : 0) +
            (giftnum ? giftnum : 0) +
            (addgiftnum ? addgiftnum : 0) +
            (zonegiftnum ? zonegiftnum : 0) +
            (productgify ? [productgify.goodsinfo].length : 0) -
            (paymoney < birthdaygift_paymoney ? birthdaygifttotalnum : 0)
          }}件
        </span>
        <span v-if="iszg != 1">
          合计：
          <span class="totalprice">¥{{ inittotalmoneyshow }}</span>
        </span>
        <span v-else-if="iszg == 1">
          合计：
          <span class="totalprice">¥139.02</span>
        </span>
      </div>
    </div>
    <div class="cart_pro_list pt15 pb15 pl10 pr10 ck_group_welfare_bar" v-if="$route.query.acttype == 'ck_group'">
      <div class="ck_group_welfare_title color-fc0324 f14">正在福利购<br/> <span class="color-29">立即支付享受福利价</span></div>
      <div class="ck_group_avatar_row">
        <div
          class="ck_group_avatar_item f0"
          v-for="(item, index) in ck_group_avatar_list"
          :key="'ck_group_avatar_' + index"
        >
          <van-image
            class="f0"
            v-if="item.img"
            round
            width="0.44rem"
            height="0.44rem"
            fit="cover"
            :src="item.img"
            error-icon="/static/images/errorheadimg.png"
          ></van-image>
          <div class="ck_group_avatar_empty" v-else>?</div>
          <van-tag
            v-if="item.is_leader == 1 || index === ck_group_leader_index"
            type="danger"
            class="ck_group_leader_tag"
          >
            群主
          </van-tag>
        </div>
      </div>
    </div>
    <div
      class="cart_pro_list"
      v-if="collagen_reward.show == 1 && collagenitemlist.length"
    >
      <div class="changebuy mb0" v-if="collagen_reward.tipText">
        <div class="left">
          <p>{{ collagen_reward.tipText }}</p>
        </div>
      </div>
      <div class="list mt0">
        <div
          class="collagen_item_row flex-ac"
          v-for="(item, index) of collagenitemlist"
          :key="'collagen-' + index"
        >
          <van-checkbox
            class="collagen_item_check"
            v-model="item.ischoose"
            checked-color="#FC0324"
          ></van-checkbox>
          <div class="collagen_item_main">
            <pro-item :productItem="item"></pro-item>
            <div class="f10 color-FC0324 pr10 pt8" v-if="item.tipText">{{ item.tipText }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="cart_pro_list changebuylist"
      v-if="exchangestatus == 1 && exchangeitemlist.length > 0"
    >
      <div class="changebuy noMarBottom" style="margin-top: 0">
        <div class="left">
          <img src="/static/images/changebuy/shopping-icon-bargain-1.png?v=1" />
          <p>购买以上商品可参与超值加购</p>
        </div>
      </div>
      <div class="productList list">
        <div
          class="itemA"
          v-for="(item, index) in exchangeitemlist"
          v-if="!item.ishide"
          :key="index"
        >
          <div
            class="itemWrap"
            v-for="(itemB, indexB) in item.changebuylist"
            :key="itemB.skuid"
            :skuid="itemB.skuid"
          >
            <div class="item flex-ac">
              <van-checkbox
                v-model="itemB.ischoose"
                checked-color="#FC0324"
                @click="choice(index, indexB)"
              ></van-checkbox>
              <img v-lazy="itemB.img_path" @click.stop="godetail(itemB)" />
              <div class="rightBox" @click.stop="godetail(itemB)">
                <p class="name over-ell-1">{{ itemB.name }}</p>
                <p class="oldPrice">原价¥{{ itemB.cost_price }}</p>
                <div class="flex-js-ac">
                  <p class="currentPrice">
                    <span class="lable">加购价¥</span>
                    <span class="price">{{ itemB.changebuy_price }}</span>
                  </p>
                  <div class="stepBox flex-js-ac">
                    <div
                      :class="[itemB.num <= 1 ? 'can' : '', 'subtract stepBtn']"
                      @click.stop="addToCart(0, index, indexB, itemB)"
                    ></div>
                    <div class="num">{{ itemB.num }}</div>
                    <div
                      :class="[itemB.num < itemB.canbuycnt ? 'can' : '', 'add stepBtn']"
                      @click.stop="addToCart(1, index, indexB, itemB)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="tag mt5">
              <van-tag
                v-if="itemB.payfreight_tag == 1 || itemB.payfreight_tag == 2"
                class="tag_danger"
                type="danger"
                style="margin-top: 0.03rem; margin-right: 0.05rem; line-height: normal"
              >
                {{ itemB.payfreight_tag == 2 ? '固定运费' : '' }}不包邮
              </van-tag>
            </div>
            <div class="ysale" v-if="itemB.presaletime" style="padding-left: 0.1rem">
              <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>
              <img src="../../assets/images/presell.png" />
              <div class="txt">预售发货时间：{{ itemB.presaletime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="additional">
      <van-cell-group>
        <van-cell
          class="integral"
          title-class="integralTitle"
          :value="'¥' + freight"
          value-class="txt"
        >
          <template #title>
            <div class="grayCoupon integralTotal">
              <span class="custom-title">运费</span>
              <img
                v-if="freightrule"
                @click="freightruleShow = true"
                src="../../assets/images/integralrule.png"
              />
              <span v-if="weight_val">&nbsp;不包邮品共{{ weight_val }}kg</span>
            </div>
          </template>
        </van-cell>
        <van-cell
          :value="'-¥' + parseFloat(qtDiscount).toFixed(2)"
          title="团购专属优惠"
          v-if="parseFloat(qtDiscount) > 0"
          value-class="txt color-FC0324"
        />
        <van-cell
          class="integral cell"
          label-class="integralLab"
          title-class="integralTitle scoped_minW-82"
          v-if="usablecountdiscount > 0 && iszg != 1 && yl != 1 && ylact != 1 && ms != 1"
          value-class="integralVal"
        >
          <template slot="title">
            <div
              :class="{
                grayCoupon: !discountCouponChecked,
                integralTotal: true,
                'ai-fs': !discountCouponChecked && discountcouponMsg
              }"
            >
              <span class="custom-title" style="line-height: 0.2rem">折扣券</span>
              <b
                style="margin-left: 0.22rem"
                v-if="
                  (!discountcouponMsg && discountcouponstitle != '') ||
                  (discountcouponMsg && discountCouponChecked)
                "
              >
                {{ discountcouponstitle }}
              </b>
              <b
                class="color-FC0324"
                :class="{ 'ws-n': discountCouponChecked }"
                style="margin-left: 0.22rem"
              >
                {{
                  discountCouponChecked
                    ? discountcouponsmoney
                    : discountcouponMsg || discountcouponsmoney
                }}
              </b>
              <van-icon name="arrow" size="0.12rem" v-if="discountCouponChecked" color="#FC0324" />
            </div>
            <div
              v-if="discountcouponMsg && discountCouponChecked"
              class="color-FC0324 f10 ws-n"
              style="margin-left: 0.58rem"
            >
              {{ discountcouponMsg }}
            </div>
          </template>
          <!--          <template slot="label"></template>-->
          <van-switch
            :disabled="usablecountdiscount <= 0 && discountcouponstitle == ''"
            @change="switchDiscountCouponFn"
            size="0.2rem"
            v-model="discountCouponChecked"
          />
        </van-cell>
        <van-cell
          v-if="
            fullMinusRules.initactStatus == 1 &&
            fullMinusRules.initfullminusmoney - fullMinusRules.initextraMinusMoney > 0
          "
          :value="'-¥' + parseFloat(fullminusmoney - extraMinusMoney).toFixed(2)"
          value-class="txt color-FC0324"
        >
          <template #title>
            <span class="custom-title">全场满减</span>
            <van-tag class="tag_danger" type="danger">{{ fullMinusRules.actLabel }}</van-tag>
          </template>
        </van-cell>
        <van-cell
          v-if="fullMinusRules.initactStatus == 1 && fullMinusRules.initextraMinusMoney > 0"
          :value="'-¥' + parseFloat(extraMinusMoney).toFixed(2)"
          value-class="txt color-FC0324"
        >
          <template #title>
            <span class="custom-title color-FC0324">返场优惠</span>
            <van-tag class="tag_danger" type="danger">
              每满{{ parseFloat(fullMinusRules.fullMoney) }}再减{{
                parseFloat(fullMinusRules.extraMinusMoney)
              }}
            </van-tag>
          </template>
        </van-cell>
        <van-cell
          :value="'-¥' + parseFloat(birthdayDiscountRule.discountmoney).toFixed(2)"
          :title="birthdayDiscountRule.actlabel"
          v-if="parseFloat(birthdayDiscountRule.discountmoney) > 0"
          value-class="txt"
        />
        <van-cell
          :value="'-¥' + parseFloat(fullDiscountRule.fullDiscountmoney).toFixed(2)"
          :title="fullDiscountRuleTitle"
          v-if="parseFloat(fullDiscountRule.initfullDiscountmoney) > 0"
          value-class="txt"
        />
        <van-cell
          :value="'-¥' + parseFloat(directReductionmoney).toFixed(2)"
          title="直降"
          v-if="parseFloat(directReductionmoney) > 0"
          value-class="txt"
        />
        <van-cell
          :value="'-¥' + parseFloat(depositmoney).toFixed(2)"
          title="定金翻倍(含定金)"
          v-if="parseFloat(depositmoney) > 0"
          value-class="txt"
        />
        <van-cell
          :value="productcount > 0 && producttitle != '' ? producttitle : '不使用'"
          @click="showProduct"
          class="cell"
          is-link
          title="产品劵"
          v-if="
            productcount > 0 &&
            iszg != 1 &&
            ($route.query.acttype == 'vip35_welfare' || (yl != 1 && ylact != 1 && ms != 1))
          "
          value-class="txt"
        />
        <van-cell
          :value="'-¥' + parseFloat(morediscountsmoney).toFixed(2)"
          @click="showActDesc('morediscounts')"
          class="cell"
          is-link
          :title="morediscounts.discountlist[0].name || '多件立减'"
          v-if="
            parseFloat(morediscounts.initmorediscountsmoney) > 0 &&
            iszg != 1 &&
            yl != 1 &&
            ylact != 1
          "
          value-class="txt"
        />
        <van-cell
          :value="discountrule.name + ' -¥' + parseFloat(discountmoney).toFixed(2)"
          @click="showActDesc"
          class="cell"
          is-link
          title="活动"
          v-if="parseFloat(discountmoney) > 0 && iszg != 1 && yl != 1 && ylact != 1"
          value-class="txt"
        />
        <van-cell
          title="活动"
          value="折扣专区"
          value-class="txt"
          class="cell"
          v-if="ishalfprice == 1 && iszg != 1 && yl != 1 && ylact != 1"
        />
        <van-cell
          class="integral cell"
          label-class="integralLab"
          title-class="integralTitle"
          v-if="usablecount > 0 && iszg != 1 && yl != 1 && ylact != 1 && ms != 1"
          value-class="integralVal"
        >
          <template slot="title">
            <div :class="{ grayCoupon: !couponChecked, integralTotal: true }" @click="showCoupon">
              <span class="custom-title">现金券</span>
              <b style="margin-left: 0.22rem" v-if="couponChecked">
                {{ usablecount > 0 && couponstitle != '' ? couponstitle : '选择现金券' }}
              </b>
              <b style="margin-left: 0.22rem" v-else>
                {{ couponstitle != '' ? couponstitle : '选择现金券' }}
              </b>
              <b v-if="couponstitle != ''" class="color-FC0324" style="margin-left: 0.12rem">
                {{ couponsmoney ? ' -￥' + couponsmoney : '' }}
              </b>
              <van-icon name="arrow" size="0.12rem" v-if="couponChecked" color="#FC0324" />
            </div>
          </template>
          <!--          <template slot="label"></template>-->
          <van-switch
            :disabled="usablecount <= 0 && couponstitle == ''"
            @change="switchCouponFn"
            size="0.2rem"
            v-model="couponChecked"
          />
        </van-cell>
        <van-cell
          class="integral cell"
          label-class="integralLab"
          title-class="integralTitle"
          v-if="usablecount <= 0 && iszg != 1 && yl != 1 && ylact != 1 && ms != 1"
          value-class="integralVal"
        >
          <template slot="title">
            <div @click="showCoupon" class="integralTotal grayCoupon">
              <span class="custom-title">现金券</span>
            </div>
          </template>
          <div class="integralTotal grayCoupon" style="display: block">
            <b>{{ nocoupontext }}</b>
          </div>
        </van-cell>
        <van-cell
          class="integral"
          label-class="integralLab"
          title-class="integralTitle"
          v-if="iszg != 1 && yl != 1 && ylact != 1 && ms != 1"
          value-class="integralVal"
        >
          <template slot="title">
            <div :class="{ grayCoupon: !integralChecked, integralTotal: true }">
              <span class="custom-title">金币</span>
              <img src="../../assets/images/integralrule.png" @click="integralRule" />
              <b class="ml16" v-if="integerlist && integerlist.length > 0 && useIntegral > 0">
                <b>金币{{ parseInt(useIntegral) }}</b>
                <b>可抵扣{{ parseFloat(moneyByIntegral).toFixed(2) }}元</b>
              </b>
            </div>
          </template>
          <template slot="label" v-if="ispreferentialmutex == 1 && isUseBigCoupon != 1">
            <b>
              <i>现金券抵扣、金币抵扣，二选一</i>
            </b>
          </template>
          <div
            :class="{ grayCoupon: !integralChecked, integralTotal: true }"
            style="display: block"
            v-if="useIntegral <= 0"
          >
            <b>金币不可用</b>
          </div>
          <van-switch
            :disabled="integerlist && integerlist.length <= 0"
            @change="switchIntegralFn"
            size="0.2rem"
            v-if="useIntegral > 0"
            v-model="integralChecked"
          />
        </van-cell>
        <van-field
          class="field"
          maxlength="45"
          v-model="remark"
          label="订单备注"
          label-class="mr2"
          label-width="0.55rem"
          placeholder="选填，最多45字，请先和客服协商一致"
        />
      </van-cell-group>
    </div>
    <div class="cart_pro_list changebuylist recommenditemlist" v-if="recommenditemlist.length > 0">
      <div class="title f0 flex-ac">
        <img src="/static/images/recommend/group_1@2x.png" />
        <span class="f12">快来看看吧</span>
        <van-icon
          class="close"
          name="cross"
          color="#B3B3B3"
          size="0.14rem"
          @click="closeRecommend(0, 0, recommenditemlist[0])"
        />
      </div>
      <div class="productList list" style="padding-bottom: 0.05rem">
        <div class="itemA" v-for="(item, index) in recommenditemlist" :key="item.skuid">
          <div class="itemWrap">
            <div class="item flex-ac">
              <img :src="item.img_path" @click.stop="godetail(item, 'recommend')" />
              <div class="rightBox pb25" @click.stop="godetail(item, 'recommend')">
                <p class="name over-ell-2">{{ item.name }}</p>
                <p class="f11 over-ell-2" style="color: #6c6c6c; margin-top: 0.02rem">
                  {{ item.spec }}
                </p>
                <div class="flex-js-ac recommendPrice">
                  <p class="currentPrice">
                    <span class="label">¥</span>
                    <span class="price">{{ item.price }}</span>
                    <span class="oldPrice">¥{{ item.cost_price }}</span>
                  </p>
                  <div v-if="item.num > 0" class="stepBox flex-js-ac">
                    <div
                      :class="['subtract stepBtn']"
                      @click.stop="recommendAddToCart(0, index, item)"
                    ></div>
                    <div class="num">{{ item.num }}</div>
                    <div
                      :class="[
                        parseInt(item.num) < parseInt(item.canbuycnt) ? 'can' : '',
                        'add stepBtn'
                      ]"
                      @click.stop="recommendAddToCart(1, index, item)"
                    ></div>
                  </div>
                  <div class="stepBox0 f12" v-else @click.stop="recommendAddToCart(1, index, item)">
                    一键购买
                  </div>
                </div>
              </div>
            </div>
            <div class="tag mt0" style="margin-left: 0.87rem">
              <van-tag
                v-if="item.payfreight_tag == 1 || item.payfreight_tag == 2"
                class="tag_danger"
                type="danger"
                style="margin-top: 0.03rem; margin-right: 0.05rem; line-height: normal"
              >
                {{ item.payfreight_tag == 2 ? '固定运费' : '' }}不包邮
              </van-tag>
            </div>
            <div class="ysale" v-if="item.presaletime" style="padding-left: 0.1rem">
              <van-tag color="#FEE9E6" text-color="#F12A0E">预售</van-tag>
              <img src="../../assets/images/presell.png" />
              <div class="txt">预售发货时间：{{ item.presaletime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    折上折-->
    <div
      class="additemMsg footerIOS"
      v-if="
        FlodMsg && discountrule.discountenable == 1 && iszg != 1 && yl != 1 && ylact != 1 && ms != 1
      "
    >
      <div class="msg">
        <img src="../../assets/images/surprised.png" />
        <div class="txt" v-html="FlodMsg"></div>
      </div>
      <div
        class="btn"
        v-if="parseInt(discountGoodsnum) < parseInt(discountrule.discountlist[0].itemnum)"
        @click="goflod('flod')"
      >
        去凑单>
      </div>
    </div>
    <!--    限时折扣-->
    <div
      class="additemMsg footerIOS"
      v-else-if="
        FlodMsg &&
        fullDiscountRule.discountenable == 1 &&
        fullDiscountRule.switch == 1 &&
        iszg != 1 &&
        yl != 1 &&
        ylact != 1 &&
        ms != 1
      "
    >
      <div class="pb10 w-100 flex jc-sb ai-c">
        <div class="msg pb0">
          <img src="../../assets/images/surprised.png" />
          <div class="txt" v-html="FlodMsg"></div>
        </div>
        <div class="btn pb0" v-if="fullDiscountEnter == 1" @click="goflod('fulldiscount')">
          去凑单>
        </div>
      </div>
    </div>
    <!--    满赠-->
    <div
      class="additemMsg footerIOS"
      v-else-if="
        FullGiftMsg &&
        fullgiftrule.actstatus == 1 &&
        fullgiftrule.isaddon == 1 &&
        iszg != 1 &&
        yl != 1 &&
        ylact != 1 &&
        ms != 1
      "
    >
      <div class="msg">
        <img src="../../assets/images/surprised.png" />
        <div class="txt" v-html="FullGiftMsg"></div>
      </div>
      <div
        class="btn"
        v-if="parseFloat(currentfullgiftmoney) < parseFloat(fullgiftrule.rulelist[0].allmoney)"
        @click="gofullgift"
      >
        去凑单>
      </div>
    </div>
    <div class="sub_bar footerIOS">
      <div class="itemtxt">
        需付款：
        <span class="xprice">
          <sub>¥</sub>
          <b
            v-text="
              !isNaN(pay_money) ? String(pay_money).slice(0, String(pay_money).indexOf('.')) : '0'
            "
          ></b>
          <sup
            v-text="
              !isNaN(pay_money)
                ? String(pay_money).slice(String(pay_money).indexOf('.'), String(pay_money).length)
                : '.00'
            "
          ></sup>
        </span>
      </div>
      <div class="btton" @click="goNext">
        {{
          $route.query.acttype == 'hc_welfare' ||
          $route.query.acttype == 'hc_welfare_private' ||
          $route.query.acttype == 'vip35_welfare' ||
          $route.query.acttype == 'ck_group'
            ? '立即自提'
            : $route.query.yl == 1 && $route.query.qtid
              ? '立即提交'
              : '提交订单'
        }}
      </div>
    </div>
    <van-action-sheet v-model="showcoupon" title="选择现金券" show-action @cancel="closeCoupon">
      <div class="coupon">
        <div class="coupon_item" v-for="(item, index) in usecouponlist" :key="item.id">
          <div class="coupon_info" :class="{ isspecialbackground: item.isspecial == 1 }">
            <div class="f1">
              <span>{{ parseInt(item.price) }}</span>
              <span>{{ item.couponname }}</span>
            </div>
            <div class="f2">
              <span>{{ item.gettype }}</span>
              <span>
                <label>
                  {{
                    item.starttime.replace(/-/g, '.') + '-' + item.invalidtime.replace(/-/g, '.')
                  }}
                </label>
                <div
                  @click="chooseCoupon(index)"
                  class="f3 active closeChoose"
                  v-if="item.isChoose == true"
                >
                  取消选择
                </div>
                <div class="f3" v-else @click="chooseCoupon(index)">选择</div>
              </span>
            </div>
            <div class="coupon_tit">
              <div class="tit_info" v-if="item.details != ''">
                <div class="tit">详细信息</div>
                <van-icon
                  name="arrow-down"
                  @click="showCouponDesc(index, 'coupon')"
                  v-if="!item.isShowDesc"
                />
                <van-icon
                  name="arrow-up"
                  @click="showCouponDesc(index, 'coupon')"
                  v-if="item.isShowDesc"
                />
              </div>
            </div>
          </div>
          <div class="coupon_desc" v-if="item.isShowDesc">
            {{ item.details }}
          </div>
        </div>
        <div
          class="coupon_item nocoupon_item"
          v-for="(noItem, noIndex) in nousercouponlist"
          :key="parseInt('1' + noIndex)"
        >
          <div class="coupon_info">
            <div class="f1">
              <span>{{ parseInt(noItem.price) }}</span>
              <span>{{ noItem.couponname }}</span>
            </div>
            <div class="f2">
              <span>{{ noItem.gettype }}</span>
              <span>
                <label>{{ noItem.starttime + '-' + noItem.invalidtime }}</label>
              </span>
            </div>
            <div class="coupon_tit">
              <div class="tit_info" v-if="noItem.details != ''">
                <div class="tit">详细信息</div>
                <van-icon
                  name="arrow-down"
                  @click="showCouponDesc(noIndex, 'nocoupon')"
                  v-if="!noItem.isShowDesc"
                />
                <van-icon
                  name="arrow-up"
                  @click="showCouponDesc(noIndex, 'nocoupon')"
                  v-if="noItem.isShowDesc"
                />
              </div>
            </div>
          </div>
          <div class="coupon_desc" v-if="noItem.isShowDesc">
            {{ noItem.details }}
          </div>
        </div>
        <div class="coupon_btn" v-if="couponBtn" @click="comfrimCoupon">
          确认{{
            '可省¥' +
            (parseFloat(real_pay_money + couponsmoney) >= parseFloat(couponPrice)
              ? couponPrice
              : (real_pay_money + couponsmoney).toFixed(2)) +
            '元'
          }}
        </div>
      </div>
    </van-action-sheet>
    <van-action-sheet v-model="showproduct" title="选择产品劵" show-action @cancel="closeProduct">
      <div class="coupon">
        <div class="coupon_item product_item" v-for="(item, index) in productlist" :key="index">
          <div class="coupon_info product_info">
            <div class="f1 productf1">
              <img class="product" v-lazy="item.goodsinfo.img_path" />
              <!--              <span>{{parseInt(item.price)}}</span>-->
              <!--              <span>{{item.couponname}}</span>-->
            </div>
            <div class="f2">
              <span>{{ item.name }}</span>
              <span>
                <label>
                  {{ item.begin_time.replace(/-/g, '.') + '-' + item.end_time.replace(/-/g, '.') }}
                </label>
                <div
                  class="f3 active closeChoose"
                  v-if="item.isChoose == true"
                  @click="chooseProduct(index)"
                >
                  已选择
                </div>
                <div class="f3" v-else @click="chooseProduct(index)">选择</div>
              </span>
            </div>
            <div class="coupon_tit">
              <div class="tit_info" v-if="item.content != ''">
                <div class="tit">详细信息</div>
                <van-icon
                  name="arrow-down"
                  @click="showProductDesc(index)"
                  v-if="!item.isShowDesc"
                />
                <van-icon name="arrow-up" @click="showProductDesc(index)" v-if="item.isShowDesc" />
              </div>
            </div>
          </div>
          <div class="coupon_desc" v-if="item.isShowDesc">
            {{ item.content }}
          </div>
        </div>
        <div class="coupon_btn" v-if="productBtn" @click="comfrimProduct">确认</div>
      </div>
    </van-action-sheet>
    <!--活动服务-->
    <van-action-sheet v-model="showaction" title="活动介绍">
      <div class="van-action_model">
        <div class="van-item" v-for="(item, index) in msglist" :key="index">
          <div v-if="!item.desclist">
            <div class="tit">
              <van-tag color="#FEE9E6" text-color="#F12A0E">{{ item.actlabel }}</van-tag>
              {{ item.name }}
            </div>
            <div class="con">
              {{ item.desc }}
            </div>
          </div>
          <div v-else>
            <div class="tit">
              <van-tag color="#FEE9E6" text-color="#F12A0E">{{ item.desclist[0].name }}</van-tag>
              <div v-for="(itemSon, indexSon) of item.desclist" :key="indexSon">
                <div class="con">
                  {{ itemSon.discountdesc }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <van-button round type="danger" class="vanbtn" @click="showaction = false">
            确定
          </van-button>
        </div>
      </div>
    </van-action-sheet>
    <van-dialog
      v-model="showsubscribegoodsmsg"
      class="van-flod-dialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="floddialog" v-html="subscribegoodsrule.tips"></div>
      <div class="btn">
        <van-button round plain hairline class="van-btn-01" @click="handleShowsubscribegoodsOrder">
          放弃
        </van-button>
        <van-button round type="danger" class="van-btn-02" @click="handleCancelShowsubscribegoods">
          去凑单
        </van-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showFiveHundmsg"
      class="van-flod-dialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="floddialog">{{ couponstips.tips }}</div>
      <div class="btn">
        <van-button round plain hairline class="van-btn-01" @click="handleAddFiveHundOrder">
          不用了
        </van-button>
        <van-button round type="danger" class="van-btn-02" @click="handleCancelFiveHund">
          去凑单
        </van-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showEightHundmsg"
      class="van-flod-dialog"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="floddialog">{{ drawprizetips.tips }}</div>
      <div class="btn">
        <van-button round plain hairline class="van-btn-01" @click="handleAddEightHundOrder">
          不用了
        </van-button>
        <van-button round type="danger" class="van-btn-02" @click="handleCancelEightHund">
          去凑单
        </van-button>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showaddress"
      class="van-flod-dialog van-address-dialog"
      title="确认信息"
      :show-confirm-button="false"
      :show-cancel-button="false"
    >
      <div class="addressdialog">
        <ul>
          <li class="flex">
            <span>收货人：</span>
            <p class="flex-1">{{ addressVal.name }}</p>
          </li>
          <li class="flex">
            <span>手机号：</span>
            <p class="flex-1">{{ addressVal.mobile }}</p>
          </li>
          <li class="flex">
            <span>收货地址：</span>
            <p class="over-ell-2 flex-1">
              {{ addressVal.area + '' + addressVal.address }}
            </p>
          </li>
          <li class="flex upd" v-if="areatemp">
            <span></span>
            <div class="flex-1">
              <p class="f15">地址推荐更正为：</p>
              <p class="f15 color-FC0324">{{ areatemp + addresstemp }}</p>
              <div class="flex-js-ac" style="margin-top: 0.04rem">
                <p></p>
                <van-button
                  @click="editaddressFn"
                  class="updbtn"
                  color="#FC0324"
                  plain
                  round
                  size="mini"
                  type="primary"
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;更正&nbsp;&nbsp;&nbsp;&nbsp;
                </van-button>
              </div>
            </div>
          </li>
          <li class="flex">
            <span>商品数量：</span>
            <p class="num flex-1">
              {{
                totalnum +
                (buygiftnum ? buygiftnum : 0) +
                (giftnum ? giftnum : 0) +
                (addgiftnum ? addgiftnum : 0) +
                (zonegiftnum ? zonegiftnum : 0) +
                (productgify ? [productgify.goodsinfo].length : 0) -
                (paymoney < birthdaygift_paymoney ? birthdaygifttotalnum : 0) +
                (exchangetotalnum || 0)
              }}
            </p>
          </li>
          <li class="flex">
            <span>需付款：</span>
            <p class="money flex-1">¥{{ pay_money ? pay_money : '0.00' }}</p>
          </li>
        </ul>
        <p class="f12 color-FC0324" style="margin-top: 0.1rem" v-if="isareacode == 0">
          为保证包裹派件正确，请重新更正地址
        </p>
      </div>
      <div class="btn areacodebtn" v-if="isareacode == 0">
        <van-button round type="danger" class="van-btn-02" @click="handleEditorAddress">
          修改
        </van-button>
      </div>
      <div class="btn" v-else>
        <van-button round plain hairline class="van-btn-01" @click="handleAddress">修改</van-button>
        <van-button round type="danger" class="van-btn-02" @click="handlePay">
          {{
            $route.query.acttype == 'hc_welfare' ||
            $route.query.acttype == 'hc_welfare_private' ||
            $route.query.acttype == 'vip35_welfare' ||
            $route.query.acttype == 'ck_group'
              ? '去自提'
              : '去支付'
          }}
        </van-button>
      </div>
    </van-dialog>
    <van-dialog
      :show-cancel-button="false"
      :show-confirm-button="false"
      class="van-flod-dialog temp_dialog"
      v-model="showPayTemp"
    >
      <div class="floddialog">
        尊敬的用户，因近日微信支付正在调试，请前往【创客云商商城APP】使用支付宝支付~
        <br />
        您的订单已在创客云商商城APP“我的订单>>待支付订单”等你哦！
      </div>
      <div class="btn">
        <van-button @click="showPayTemp = false" class="van-btn-01" hairline plain round>
          取消
        </van-button>
        <van-button class="van-btn-02" round type="danger">
          前往APP商城
          <wx-open-launch-app
            @error="error"
            @launch="launch"
            appid="wx997fa1bb80ec9278"
            extinfo="your-extinfo"
            id="launch-btn"
          >
            <script type="text/wxtag-template">
              <style>.btn {
                      color: #ffffff;
                      font-size: 14px;
                      background: transparent;
                      border-width: 0;
                      line-height: 32px;
                      height: 32px;
                      }</style>
                      <button class="btn"></button>
            </script>
          </wx-open-launch-app>
        </van-button>
      </div>
    </van-dialog>
    <van-overlay :show="showtemp" z-index="3000"></van-overlay>
    <div class="sharecontainer" v-if="showtemp === true">
      <img src="../../assets/images/showtemp.png" />
      <van-button @click="showtemp = false" class="know" plain round type="danger">
        我知道了
      </van-button>
    </div>
    <van-dialog
      v-model="ismobile"
      title="温馨提示"
      :before-close="(action, done) => done(false)"
      @confirm="confirm"
      @cancel="cancel"
      show-cancel-button
      cancel-button-color="#fc0324"
      cancel-button-text="放弃福利"
      class="signin_button_alert collect_button_alert"
    >
      <p class="f15" style="color: #444; padding: 0 0.23rem 0.1rem">
        买{{
          is_50vipentranceName || is_beauty50vipentranceName
        }}会送您升级成为50VIP的权利，请输入您要成为50VIP的手机号码
      </p>
      <ul>
        <li class="flex">
          <input type="tel" v-model="mobile" placeholder="请输入手机号" />
          <img class="del-btn" src="/static/wx/img/close3.png" v-if="mobile" @click="mobile = ''" />
        </li>
        <li class="flex">
          <input type="text" v-model="code" placeholder="图片验证码" />
          <img class="del-btn" src="/static/wx/img/close3.png" v-if="code" @click="code = ''" />
          <img ref="codeImg" :src="codeImg" alt="" @click="getCodeImg" />
        </li>
        <li class="flex">
          <input type="tel" v-model="sms" placeholder="验证码" />
          <img class="del-btn" src="/static/wx/img/close3.png" v-if="sms" @click="sms = ''" />
          <i class="countdown" v-if="time == 60" @click="sendAgain">获取验证码</i>
          <i class="countdown" v-else-if="time != 0">{{ time }}s后重新发送</i>
          <i class="countdown sendAgain" v-else-if="time == 0" @click="sendAgain">重新发送</i>
        </li>
      </ul>
    </van-dialog>
    <van-overlay :lock-scroll="false" :show="freightruleShow" z-index="99999">
      <div class="wrapper freightrule_box">
        <div class="block" @click.stop style="height: 70%; width: 90%">
          <div>
            <p style="padding-bottom: 0.1rem">运费规则说明</p>
            <div class="freightrule f13" v-html="freightrule"></div>
          </div>
          <van-icon @click="freightruleShow = false" name="close" />
        </div>
      </div>
    </van-overlay>

    <van-overlay
      :show="exchangeShow && exchangeitemlist.length"
      z-index="999"
      @click="exchangeCloseHandle"
    >
      <div class="exchangeActivityBox w-100 f0 ta-c" @click.stop>
        <div class="exchangeActivity pos-r" v-if="exchangeitemlist.length">
          <swiper id="activityBanner" :options="exchangeSwiper" style="height: 100%">
            <template v-for="(item, index) in exchangeitemlist" v-if="!item.ishide" :key="index">
              <swiper-slide
                class="bg-F radius-8px over-h"
                ref="exchangeItem"
                v-for="(itemB, indexB) of item.changebuylist"
                :key="index"
              >
                <div class="pos-r">
                  <van-icon
                    size="0.25rem"
                    class="pos-a r0 t0 mr10 mt10"
                    @click="exchangeCloseHandle"
                    name="clear"
                    color="#978D92"
                  />
                  <img class="main-img" v-lazy="itemB.img_path" />
                </div>
                <div class="pl10 pr10 pt10 pb10">
                  <p class="f13 color-29 over-ell-1 fw-b">{{ itemB.name }}</p>
                  <div class="flex jc-sb mt6">
                    <div class="color-FC0324 f10">
                      加购价¥{{ itemB.changebuy_price }}&nbsp;
                      <span class="td-lt color-6 f10">¥{{ itemB.cost_price }}</span>
                    </div>
                    <van-checkbox
                      v-model="itemB.ischoose"
                      checked-color="#FC0324"
                      @click="choice(index, indexB)"
                    ></van-checkbox>
                  </div>
                </div>
              </swiper-slide>
            </template>
          </swiper>
          <div class="swiper-pagination" id="exchangeSwiperPagination"></div>
        </div>
        <van-button
          @click="exchangeShow = false"
          round
          class="mt15"
          style="width: 2rem"
          size="small"
          :color="exchangeGrayBtn ? '#BCBCBC' : 'linear-gradient( 90deg, #FC0324 0%, #FF144F 100%)'"
        >
          一键加购
        </van-button>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { fullDiscountHandle, discountHandle } from './js/addOrder'
import proItem from '../common/cart_pro_item'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import Vue from 'vue'
import '../../../static/wx/css/mobilePop.css'
import {
  appid,
  isWeixin,
  fenxiang,
  isApp,
  encryption,
  clone,
  downloadshoppath,
  downloadpath,
  basepath,
  random_string,
  discernFunc
} from '../../assets/common/js/config'
import { Switch, Tag } from 'vant'
Vue.config.ignoredElements = ['wx-open-launch-app']

Vue.use(Switch).use(VueAwesomeSwiper /* { default global options } */)
export default {
  name: 'addOrder',
  data: function () {
    return {
      iszg: this.$route.query.iszg,
      yl: this.$route.query.yl || 0 /**引流活动 */,
      ylact: this.$route.query.ylact || 0 /**引流活动专区 */,
      ms: this.$route.query.ms || 0 /**秒杀活动 */,
      lb: this.$route.query.lb || 0 /**钜惠店主.创客 礼包活动 */,
      ann: this.$route.query.ann || 0 /**周年庆活动 */,
      anncc: this.$route.query.anncc || 0 /**周年庆29.9 */,
      showaddress: false,
      showFiveHundmsg: false,
      showEightHundmsg: false,
      showaction: false,
      discountaddress: 0,
      msglist: [],
      value: 1,
      radio: 0,
      remark: '',
      radio1: null,
      list: [],
      listtemp: '' /**商品数据临时存储 */,
      addressList: [],
      fraud: '' /**下单风险提示 */,
      risktips: true,
      allItemids: [] /**所有商品ID集合，用于优惠分摊显示规则 */,
      totalmoney: 0 /**合计金额不参与定金计算 */,
      inittotalmoneyshow: '0.00' /**合计金额显示 */,
      inittotalmoney: 0 /**合计金额（参与定金计算）最终合计金额 */,
      mtacttotalmoney: 0 /**N件打包活动 合计金额 */,
      totalprice: 0 /**实付金额 */,
      real_pay_money: 0 /**实付金额【使用大额券，未置为0前的最终实付金额（可为负数）】 */,
      pay_money: '0.00' /**最终实付金额 */,
      totalnum: 0 /**商品数量 */,
      totalnumshow: 0 /**合计商品数量显示 */,
      objitem: '' /**商品重组 */,
      goodscouponrule: [] /**当前下单商品匹配到产品券集合 */,
      showcoupon: false,
      showCouponDialog: false /**现金券-下单大额券弹窗提示是否已弹 */,
      couponBtn: false,
      addressVal: {},
      /**Start 折扣券 */
      discountcouponlist: [] /**折扣券列表 */,
      usediscountcouponlist: [] /**可使用折扣券列表 */,
      discountcouponPrice: 0 /**折扣券 弹窗确认按钮抵扣金额显示 */,
      chooseUseDiscountCouponIndex: null,
      localDiscountCoupon: null,
      discountCouponChecked: false,
      discountcouponstitle: '',
      usablecountdiscount: '',
      discountcouponsmoney: '' /**折扣券抵扣金额显示 */,
      discountcouponmoney: 0 /**折扣券抵扣金额 */,
      /**折扣券 全场折扣，限时折扣，全场满减，N件立减，不能与生日折扣同时享受提示信息 */
      discountcouponMsg: '',
      usecouponFromDiscountcoupon: 1 /**是否使用现金券 */,
      useintegralFromDiscountcoupon: 1 /**是否使用积分 */,
      isDiscountcouponMsgHandle: 0 /**提示信息是否已处理，0否 1是 */,
      /**End */
      /**Start 现金券 */
      couponlistrule: [] /**可使用优惠券列表 */,
      usablecount: 0,
      couponChecked: false,
      localCoupon: null,
      couponlist: [] /**优惠券列表 */,
      usecouponlist: [] /**可用优惠券 */,
      nousercouponlist: [] /**不可用优惠券 */,
      chooseUseCouponIndex: null,
      couponPrice: 0 /**券列表-确认按钮可省n元 */,
      couponstitle: '',
      nocoupontext: '',
      couponsmoney: '' /**当前使用券金额 */,
      couponmoney: 0 /**现金券抵扣金额 */,
      isUseBigCoupon: 0 /**是否使用大额券 */,
      /**可用券列表第一个匹配项·活动匹配-用于匹配折扣券+优惠券与活动+优惠券之间的对比 */
      choose_coupon_act_vs: {},
      /**可用券列表第一个匹配项·折扣券匹配-用于匹配折扣券+优惠券与活动+优惠券之间的对比 */
      choose_coupon_discount_vs: {},
      /**End */
      productcount: 0,
      producttitle: '',
      showproduct: false,
      productBtn: false,
      productlist: [],
      productgify: null,
      productPrice: 0,
      chooseProductIndex: null,
      jfchecked: false,
      /**积分预埋开始 */
      integerrule: null /**积分规则信息 */,
      integralChecked: false,
      isintegral: '',
      useIntegral: '' /**可用积分 */,
      totalIntegral: '' /**总积分 */,
      interate: '' /**积分占比 */,
      integralrule: [],
      integerlist: [] /**可用积分 */,
      integerAllList: [] /**积分 */,
      nouseIntegerlist: [] /**不可用积分 */,
      moneyByIntegral: '' /**积分抵扣金额 */,
      integralmoney: 0 /**金币抵扣金额 */,
      /**积分预埋结束 */
      ispreferentialmutex: 0 /**现金券与积分使用互斥 */,
      useintegralitemjson: '' /**后台用 可使用金币商品json */,
      /**折上折 */
      showFlod: false,
      discountGoodsnum: 0,
      FlodMsg: '',
      discountrule: {} /**折上折活动规则 */,
      couponstips: {} /**提交订单满额送券提示 */,
      drawprizetips: {},
      isdiscount: 0,
      currentdiscountIndex: -1,
      currentdiscountdata: 0,
      flodnum: 0,
      flodtxt: '',
      FullGiftMsg: '',
      fullgiftrule: {} /**满赠活动规则 */,
      currentfullgiftmoney: 0,
      fullgiftrulenew: [] /**满赠 */,
      fullgift: {} /**满赠新规则 */,
      giftmoney: 0 /**满赠商品加购总价 */,
      giftactid: '' /**满赠ID */,
      addgiftid: '' /**满赠加赠ID */,
      giftitem: '' /**满赠商品skuid */,
      giftnum: 0 /**满赠商品数量 */,
      addgiftnum: 0 /**满赠商品加赠商品数量 */,
      zonefullgift: [] /**专区满赠规则 */,
      zonegiftnum: 0 /**专区满赠商品数量 */,
      isgiftpop: 0 /**是否弹出按钮 */,
      halfprice: {},
      ishalfprice: 0 /**5折专区标识 */,
      freight: 0,
      isFreight: 0,
      orderid: null,
      jumplink: '',
      isSwitch: null,
      arg: isApp(),
      changebuystatus: 0 /**换购活动状态 换购入口是否开启 */,
      exchangestatus: 0 /**加购活动状态 加购入口是否开启 */,
      depositmoney: 0,
      showPayTemp: false,
      showtemp: false,
      exchangeGrayBtn: true /**加购活动灰色按钮 */,
      exchangeShow: false /**加购活动 显示加购商品弹窗 */,
      exchangeSwiper: {
        centeredSlides: true,
        centeredSlidesBounds: true,
        spaceBetween: 15,
        observer: true,
        observeParents: true,
        slidesPerView: 2.1,
        slidesPerGroup: 1,
        pagination: {
          el: '#exchangeSwiperPagination',
          type: 'bullets'
        }
      },
      exchangeitemlist: [] /**订单加购list */,
      collagen_reward: { show: 0, roleType: 0, tipText: '' },
      collagenitemlist: [],
      collagen_actid: '',
      exchangeitemlisttemp: '' /**订单加购list数据临时存储 */,
      exchangechooseitemlist: [] /**已选中的加购商品 */,
      exchangetotalmoney: 0 /**已选加购商品的总金额 */,
      exchangetotalnum: 0 /**已选加购商品的总数量 */,
      directReductionmoney: 0,
      ischeckaddress: false,
      fullDiscountRule: {} /**限时折扣 满N件打XX折活动 */,
      fullDiscountRuleTitle: '' /**限时折扣-规则标题,单规则取当前规则名称，多规则为“限时折扣” */,
      fullDiscountRuleList: [] /**限时折扣-多规则匹配规则合集 */,
      fullDiscount: {} /**限时折扣 满N件打XX折活动  参与的折扣 {规则编号:享受折扣} */,
      fullDiscountChooseNums: {} /**限时折扣 满N件打XX折活动  参与的折扣 {规则编号:数量}*/,
      fullDiscountEnter: -1 /**限时折扣 入口显示 */,
      fulldiscountGoodsnum: 0 /**限时折扣 参与的商品数量 */,
      recommenditemlist: [] /**智能推荐 */,
      recommendmoney: 0 /**智能推荐金额 */,
      recommendnumber: 0 /**智能推荐数量 */,
      birthdaygift_paymoney: 0 /**会员中心权益-生日盲盒门槛金额 */,
      birthdaygifttotalnum: 0 /**会员中心权益-生日盲盒数量 */,
      morediscounts: {} /**n件立减-规则 */,
      morediscountsmoney: 0 /**n件立减优惠金额 */,
      fullMinusRules: {} /**满减活动规则 */,
      fullminusmoney: 0 /**满减活动金额 + 满减返场活动金额 */,
      extraMinusMoney: 0 /**满减返场活动金额 */,
      fullminustotalmoney: 0 /**参与满减活动的商品总金额 */,
      fullMinusMsg: '' /**满减活动描述 */,
      is_50vipentrance: 0 /**是否显示50vip入口 */,
      is_50vipentranceName: '',
      is_beauty50vipentranceName: '',
      ismobile: false,
      mobile: '',
      code: '',
      sms: '',
      codeImg: null /**图片验证码 */,
      timeout: null /**事件随机码 */,
      imgCodeValue: '' /**图片验证码-值 */,
      time: 60,
      isareacode: -1,
      ck_group_avatar_list: [],
      ck_group_leader_index: 0,
      showsubscribegoodsmsg: false /**38预约活动-弹窗提示 */,
      subscribegoodsrule: {} /**38预约活动-规则 */,
      subscribegoodslist: [] /**38预约活动商品 */,
      subscribegoods_totalmoney: 0 /**38预约活动-参与活动商品总金额 */,
      buygiftrule: {} /**买赠活动 */,
      buygiftlist: [] /**买赠活动已选赠品页面显示集合 */,
      buygiftlist_submit: [] /**买赠活动已选赠品提交下单参数 */,
      buygiftorigoods: [] /**买赠活动已选赠品原商品 */,
      buygiftnum: 0 /**买赠商品数量 */,
      areatemp: '',
      areaidtemp: '',
      addresstemp: '',
      freightrule: '',
      freightruleShow: false,
      weight_val: '' /**不包邮品克重（kg） */,
      birthdayDiscountRule: {} /**生日折扣规则 */,
      changebuyList: [] /**换购商品列表 */,
      qtDiscount: '0.00', /**团购专属优惠 */
      qtDialogShow: 1 /**团购专属优惠弹窗 */
    }
  },
  components: {
    proItem,
    [Tag.name]: Tag
  },
  computed: {
    currentdiscount: function () {
      var that = this
      var currentdiscount = 1
      var discountGoodsnum = 0
      that.list.forEach(function (item) {
        if (item.isdiscount == 1) {
          discountGoodsnum += parseInt(item.num)
        }
      })
      if (that.discountrule && that.discountrule.discountenable == 1) {
        var discountlist = that.discountrule.discountlist
        if (parseInt(discountGoodsnum) == 0) {
          currentdiscount = 1
        } else if (parseInt(discountGoodsnum) >= parseInt(discountlist[0].itemnum)) {
          let discount = discountlist[0].discount
          currentdiscount = discount
        } else {
          try {
            discountlist.forEach(function (item, index) {
              if (parseInt(discountGoodsnum) >= parseInt(item.itemnum)) {
                let discount1 = item.discount
                currentdiscount = discount1
                throw new Error()
              }
            })
          } catch (e) {
            return currentdiscount
          }
        }
      }
      return currentdiscount
    },
    discountmoney: function () {
      this.discountFn()
      var that = this,
        money1 = 0,
        discountGoodsnum = 0
      that.list.forEach(function (item) {
        if (item.isdiscount == 1) {
          discountGoodsnum += parseInt(item.num)
          money1 += parseFloat(item.price) * parseInt(item.num)
        }
      })
      if (that.discountrule && that.discountrule.discountenable == 1) {
        var discountlist = that.discountrule.discountlist
        try {
          discountlist.forEach(function (item, index) {
            if (parseInt(discountGoodsnum) >= parseInt(item.itemnum)) {
              that.currentdiscountIndex = index
              throw new Error()
            }
          })
        } catch (e) {}
      }
      if (money1 > 0 && that.currentdiscountdata > 0) {
        return money1 * (1 - that.currentdiscountdata)
      } else {
        return 0
      }
    },
    itemidsAddress: function () {
      var that = this
      if (that.addressVal && JSON.stringify(that.addressVal) != '{}') {
        var ids = [],
          buynum = []
        var freights = 0
        freightsFn(that.list, 0)

        if (that.exchangechooseitemlist && that.exchangechooseitemlist.length)
          freightsFn(that.exchangechooseitemlist, 1)

        if (that.buygiftlist && that.buygiftlist.length) freightsFn(that.buygiftlist, 1)

        if (that.productgify && that.productgify.goodsinfo)
          freightsFn([that.productgify.goodsinfo], 1)

        if (that.subscribegoodslist && that.subscribegoodslist.length)
          freightsFn(that.subscribegoodslist, 1)

        function freightsFn(list, type) {
          list.forEach(function (item, index) {
            ids.push(item.skuid ? item.skuid : item.itemid)
            buynum.push(item.num)
            if (type == 0) {
              if (item.ispayfreight == 1) {
                freights = 1
              } else if (
                that.$route.query.yl == 1 ||
                that.$route.query.ms == 1 ||
                that.$route.query.ylact == 1
              ) {
                freights = 1
              }
            } else {
              freights = 1
            }
          })
        }
        if (freights == 1) {
          return ids.join(',') + '|' + that.addressVal.id + '|' + buynum.join(',')
        } else {
          that.isFreight = 1
        }
      } else {
        that.isFreight = 1
      }
      return ''
    },
    paymoney: function () {
      /**实付金额 +活动抵扣 不含运费 用于活动折扣计算 */
      var m = parseFloat(this.totalprice) + parseFloat(this.giftmoney)
      m = m - this.exchangeGoodsIshide(m)
      this.exchangeitemlisttemp = JSON.stringify(this.exchangeitemlist)
      m = m - (this.morediscountsmoney + this.fullminusmoney)
      this.real_pay_money = parseFloat((m + parseFloat(this.freight)).toFixed(2))
      this.pay_money = (this.real_pay_money > 0 ? this.real_pay_money : 0).toFixed(2)
      m =
        this.localCoupon && this.localCoupon.coupontype == 3 && this.couponChecked
          ? m + this.couponsmoney
          : m
      return m.toFixed(2)
    }
  },
  watch: {
    itemidsAddress: function (val) {
      var that = this
      that.freight = 0
      var ids = val.split('|')[0],
        addressid = val.split('|')[1],
        buynums = val.split('|')[2]
      if (that.$route.query.acttype == 'hc_welfare' || that.$route.query.acttype == 'ck_group') {
        that.freight = 0
        that.isFreight = 1
      } else {
        if (ids.length > 0 && addressid > 0) {
          var urlFreight
          if (
            that.$route.query.yl == 1 &&
            that.$route.query.newperson != 1 &&
            that.$route.query.ylcc != 9 &&
            that.$route.query.lb != 1 &&
            that.$route.query.ann != 1 &&
            that.$route.query.anncc != 1 &&
            that.$route.query.mtact != 1 &&
            that.$route.query.prize != 1 &&
            that.$route.query.defectivegood != 1 &&
            that.$route.query.ztpay != 1 &&
            that.$route.query.acttype != 'hc_welfare_private' &&
            that.$route.query.acttype != 'vip35_welfare' &&
            that.$route.query.acttype != 'ck_group'
          ) {
            urlFreight =
              that.$ajax.calculateActFreight_URL +
              '?activitytype=' +
              (that.$route.query.yl == 1 ? 7 : that.$route.query.ms == 1 ? 8 : '') +
              '&addressid=' +
              addressid
          } else if (
            that.$route.query.yl == 1 &&
            that.$route.query.ylcc == 9 &&
            that.$route.query.mtact != 1 &&
            that.$route.query.acttype != 'hc_welfare_private' &&
            that.$route.query.acttype != 'vip35_welfare' &&
            that.$route.query.acttype != 'ck_group'
          ) {
            urlFreight =
              that.$ajax.calculateActFreight_URL + '?activitytype=11' + '&addressid=' + addressid
          } else {
            urlFreight =
              that.$ajax.calculateFreight_URL +
              '?itemid=' +
              ids +
              '&addressid=' +
              addressid +
              '&buynum=' +
              buynums
          }
          that
            .$customRequestAjax(urlFreight)
            .then(function (res) {
              if (res.data.code === 200) {
                that.weight_val = res.data.weight_val
                if (res.data.freight && parseFloat(res.data.freight) > 0) {
                  that.freight = res.data.freight
                }
              }
              that.isFreight = 1
            })
            .catch(() => {
              that.isFreight = 1
            })
        } else {
          that.isFreight = 1
        }
      }
    },
    totalmoney: function (val) {
      var that = this,
        mtacttotalmoney = 0
      that.inittotalmoney = 0
      that.mtacttotalmoney = 0
      that.inittotalmoneyshow = '0.00'
      var depositmoney = 0
      that.list.map(function (item) {
        if (item.iszonefullgift == 1) return
        if (item.isdeposit == 1 && item.depositmoney) {
          depositmoney += parseFloat(item.depositmoney)
        }
        mtacttotalmoney += parseFloat(item.price) * parseInt(item.num || 1)
      })
      mtacttotalmoney =
        that.directReductionmoney > 0
          ? mtacttotalmoney + that.directReductionmoney
          : mtacttotalmoney
      that.mtacttotalmoney = parseFloat(mtacttotalmoney).toFixed(2)
      that.mtacttotalmoney += depositmoney
      that.inittotalmoney =
        that.discountrule.discountenable == 1
          ? parseFloat(that.totalmoney) +
            parseFloat(that.discountmoney) +
            parseFloat(that.giftmoney)
          : parseFloat(that.totalmoney) + parseFloat(that.giftmoney)
      that.inittotalmoney += depositmoney
      that.inittotalmoney =
        that.directReductionmoney > 0
          ? that.inittotalmoney + that.directReductionmoney
          : that.inittotalmoney
      that.inittotalmoney = parseFloat(that.inittotalmoney).toFixed(2)
      that.inittotalmoneyshow = (
        (that.mtacttotalmoney ? that.mtacttotalmoney : that.inittotalmoney) - that.recommendmoney
      ).toFixed(2)
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({ path: 'addorder' })
    }
    this.getData('init')
    var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
    if (shopConfirmResult.choose_discount_coupon) {
      let coupon = shopConfirmResult.choose_discount_coupon
      this.localDiscountCoupon = coupon
      this.discountcouponmoney = parseFloat(this.localDiscountCoupon.price)
      this.discountCouponChecked = this.localDiscountCoupon.checked
      this.discountcouponstitle = this.localDiscountCoupon.couponname
      this.discountcouponsmoney = ' -￥' + parseFloat(this.localDiscountCoupon.price)
    } else if (typeof shopConfirmResult.discountCouponChecked === 'boolean') {
      this.discountCouponChecked = shopConfirmResult.discountCouponChecked
    }
    if (sessionStorage.getItem('choose_integral')) {
      let integral = JSON.parse(sessionStorage.getItem('choose_integral'))
      this.integralmoney = parseFloat(integral.integermoney)
      this.radio = integral.radio
      this.integralChecked = integral.checked
    }
    if (sessionStorage.getItem('choose_coupon')) {
      let coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
      this.localCoupon = coupon
      this.couponChecked = this.localCoupon.checked
      this.couponstitle = this.localCoupon.couponname
      this.couponsmoney = this.couponmoney = parseFloat(this.localCoupon.price)
    } else if (typeof shopConfirmResult.couponChecked === 'boolean') {
      this.couponChecked = shopConfirmResult.couponChecked
    }
    localStorage.removeItem('showsubscribegoods')
    localStorage.removeItem('fivehundred')
    localStorage.removeItem('eighthundred')
    /**挂载完成后，判断浏览器是否支持popstate */
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', this.goBack, false)
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
    window.removeEventListener('popstate', this.goBack, false)
  },
  beforeRouteEnter: function (to, from, next) {
    if (from.path == '/pay' || from.path == '/payResult' || from.path == '/orderdetails') {
      next(function (vm) {
        vm.$router.go(-1)
      })
    } else {
      next()
    }
  },
  methods: {
    groupQuery: function (extra) {
      var query = extra || {}
      if (this.$route.query.actgroupid) {
        query.actgroupid = this.$route.query.actgroupid
      }
      if (this.$route.query.isShowIndex == 0 || this.$route.query.isShowIndex == 1) {
        query.isShowIndex = this.$route.query.isShowIndex
      }
      if (this.$route.query.newpersonhide) {
        query.newpersonhide = this.$route.query.newpersonhide
      }
      return query
    },
    initCollagenItemlistHandle: function (list) {
      return (list || []).map(function (item) {
        return Object.assign({}, item, { ischoose: true })
      })
    },
    getSelectedCollagenItemlistHandle: function () {
      return (this.collagenitemlist || []).filter(function (item) {
        return item && (item.ischoose === true || item.ischoose === 1 || item.ischoose === '1')
      })
    },
    appendCollagenOrderParamsHandle: function (data) {
      if (!data || this.$route.query.prize == 1) return data
      var selected = this.getSelectedCollagenItemlistHandle()
      if (
        !this.collagen_reward ||
        this.collagen_reward.show != 1 ||
        !selected.length
      ) {
        return data
      }
      data.roleType = this.collagen_reward.roleType
      if (this.collagen_reward.roleType == 1) {
        var ids = []
        selected.forEach(function (item) {
          if (item.collagenTierIds) ids.push(item.collagenTierIds)
          else if (item.collagenTierId) ids.push(item.collagenTierId)
        })
        if (ids.length) data.collagenClaimTierIds = ids.join(',')
      } else if (this.collagen_reward.roleType == 2) {
        var count = 0
        selected.forEach(function (item) {
          count += parseInt(item.num, 10) || 0
        })
        data.collagenClaimCount = count
      }
      if (this.collagen_actid) data.collagenActId = this.collagen_actid
      return data
    },
    /**shopConfirmResult.totalmoney 缓存总金额=现销售价(item.price*item.num)的合计金额 */
    async getData(type) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (type == 'init' || !this.addressVal.id) {
        await this.checkAddress()
      }
      var urlOrder =
        this.$route.query.acttype == 'ck_group'
          ? this.$ajax.getCkGroupOrderInit_URL
          : this.$ajax.getConfirmItems_URL
      if (this.$route.query.acttype == 'vip35_welfare') {
        urlOrder = this.$ajax.getConfirmItemsVip35Welfare_URL
      }
      if (this.$route.query.qtid) {
        urlOrder = this.$ajax.getConfirmItemsByGroupBuy_URL
      }
      urlOrder +=
        '?fullDiscountRuleNew=1&skuids=' +
        shopConfirmResult.skuidArr.join() +
        '&live_ids=' +
        (shopConfirmResult.liveId ? shopConfirmResult.liveId.join() : '') +
        '&room_id=' +
        (shopConfirmResult.roomId ? shopConfirmResult.roomId.join() : '') +
        '&from=' +
        shopConfirmResult.from +
        '&item_num=' +
        shopConfirmResult.itemNum.join() +
        '&newBuygift=1' +
        '&addressid=' +
        this.addressVal.id
      if (this.$route.query.np == 1) {
        urlOrder += '&type=1'
      } else if (this.$route.query.ms == 1) {
        urlOrder += '&limitid=' + shopConfirmResult.limitid
      } else {
        urlOrder +=
          '&communityid=' +
          (shopConfirmResult.communityid != undefined ? shopConfirmResult.communityid : '')
      }
      if (shopConfirmResult.recommendskuid) {
        urlOrder +=
          '&recommendskuid=' +
          shopConfirmResult.recommendskuid +
          '&recommendnum=' +
          shopConfirmResult.recommendnum
      }
      if (shopConfirmResult.changebuyskuids) {
        urlOrder +=
          '&changebuyskuids=' +
          shopConfirmResult.changebuyskuids.join() +
          '&changebuynums=' +
          shopConfirmResult.changebuynums.join()
      }
      if (shopConfirmResult.actgroupid) {
        urlOrder += '&actgroupid=' + shopConfirmResult.actgroupid
      }
      if (this.$route.query.acttype == 'hc_welfare_private') {
        urlOrder += '&paymethods=2'
        if (sessionStorage.getItem('ck_utoken')) {
          urlOrder += '&ck_utoken=' + sessionStorage.getItem('ck_utoken')
        }
      }
      if (this.$route.query.qtid) {
        if (!sessionStorage.getItem('qt_token')) {
          this.$toast('请先登录')
          setTimeout(() => {
            this.$app.argStaticLink('/static/wx/html/enterprise-group-buy/login.html?qtid=' + encodeURIComponent(this.$route.query.qtid))
          }, 600)
          return
        }
        urlOrder += '&qt_token=' + sessionStorage.getItem('qt_token')
        urlOrder += '&qtid=' + this.$route.query.qtid
      }
      if (this.$route.query.acttype == 'ck_group') {
        urlOrder +=
          '&groupid=' +
          encodeURIComponent(this.$route.query.groupid || shopConfirmResult.groupid || '')
        if (sessionStorage.getItem('ck_utoken')) {
          urlOrder += '&ck_utoken=' + sessionStorage.getItem('ck_utoken')
        }
      }
      this.depositmoney = 0
      var that = this
      that.$customRequestAjax(urlOrder).then(function (res) {
        if (res.data.code === 200) {
          if (res.data.couponmsg) {
            that.$toast({
              message: res.data.couponmsg,
              icon: require('../../assets/images/succ.png'),
              duration: 0,
              className: 'get_coupon_toast'
            })
          }
          that.freightrule = res.data.freightrule || ''
          that.weight_val = res.data.weight_val || ''
          if (that.$route.query.acttype == 'ck_group') {
            that.parseCkGroupAvatarList(res.data)
          }

          /**是否显示50vip入口 */
          that.is_50vipentrance = res.data.is_50vipentrance || res.data.is_beauty50vipentrance || 0
          that.is_50vipentranceName = res.data.is_50vipentranceName || ''
          /**美丽说-是否显示50vip入口 */
          that.is_beauty50vipentranceName = res.data.is_beauty50vipentranceName || ''
          /**现金券与金币使用是否互斥 */
          that.ispreferentialmutex = res.data.ispreferentialmutex || 0
          /**可使用金币商品json */
          that.useintegralitemjson = res.data.useintegralitemjson || ''
          /**换购入口是否开启 */
          that.changebuystatus = res.data.changebuystatus || 0
          /**加购入口是否开启 */
          that.exchangestatus = res.data.exchangestatus || 0
          that.collagen_reward = res.data.collagenReward || { show: 0, roleType: 0, tipText: '' }
          that.collagenitemlist = that.initCollagenItemlistHandle(res.data.collagenitemlist || [])
          that.collagen_actid =
            that.$route.query.actId || that.$route.query.actid || that.collagen_actid || ''
          /**生日盲盒门槛金额 */
          that.birthdaygift_paymoney = parseFloat(res.data.birthdaygift_paymoney || 0) || 0
          /**38预约活动-规则 */
          that.subscribegoodsrule = res.data.subscribegoodsrule || {}
          /**n件立减-规则 */
          that.morediscounts = res.data.morediscounts || {}
          if (that.morediscounts.morediscountsmoney) {
            that.morediscounts = {
              ...that.morediscounts,
              initdiscountlist: that.morediscounts.discountlist,
              initmorediscountsmoney: that.morediscounts.morediscountsmoney
            }
          }
          /**n件立减优惠金额 */
          if (that.morediscounts.morediscountsmoney) {
            that.morediscountsmoney = parseFloat(that.morediscounts.morediscountsmoney)
          }
          /**已选中的换购列表 */
          that.changebuyList = res.data.changebuylist || []
          if (that.exchangestatus == 1) {
            /**加购列表 */
            that.exchangeitemlist =
              shopConfirmResult.exchangeitemlist && shopConfirmResult.exchangeitemlist != '[]'
                ? JSON.parse(shopConfirmResult.exchangeitemlist)
                : res.data.exchangeitemlist || []
          }
          for (let i = 0; i < that.exchangeitemlist.length; i++) {
            let changebuytip = that.exchangeitemlist[i].changebuytip,
              changebuylist = that.exchangeitemlist[i].changebuylist

            changebuytip = changebuytip.replace(/[\r\n]/g, '&')
            that.exchangeitemlist[i].tipLable = changebuytip.substring(0, changebuytip.indexOf('&'))
            that.exchangeitemlist[i].tipTime = changebuytip.substring(changebuytip.indexOf('&') + 1)

            for (let j = 0; j < changebuylist.length; j++) {
              changebuylist[j].num = 1
              // if (that.exchangeitemlist[i].maxcanbuycnt == 100000) {
              //   changebuylist[j].num = 1
              // } else {
              //   if (changebuylist[j].num <= 0) changebuylist[j].num = changebuylist[j].canbuycnt
              // }
            }
          }
          if (that.exchangeitemlist.length) {
            that.exchangeitemlisttemp = JSON.stringify(that.exchangeitemlist)
            if (!shopConfirmResult.exchangePopShow) {
              that.exchangeShow = true
              shopConfirmResult.exchangePopShow = 1
            }
          }
          that.recommenditemlist =
            shopConfirmResult.recommendclose == 1 ? [] : res.data.recommenditemlist || []
          if (that.recommenditemlist.length) {
            that.recommenditemlist[0].num = parseInt(that.recommenditemlist[0].num)
            that.recommenditemlist[0].canbuycnt = parseInt(that.recommenditemlist[0].canbuycnt)
            shopConfirmResult.recommendskuid = that.recommenditemlist[0].skuid
            shopConfirmResult.recommendnum = that.recommenditemlist[0].num
            that.recommendnumber = parseInt(that.recommenditemlist[0].num)
            that.recommendmoney =
              parseFloat(that.recommenditemlist[0].price) * parseInt(that.recommenditemlist[0].num)
          }
          /**团购专属优惠 */
          that.qtDiscount = res.data.qtDiscount || '0.00'
          /**满赠新规则 */
          that.fullgift = res.data.fullgiftrulenew || {}
          /**专区满赠 */
          that.zonefullgift = res.data.zonefullgift || []
          /**限时折扣 满N件打XX折活动 */
          that.fullDiscountRule = res.data.fullDiscountRule || {}
          if (that.fullDiscountRule.discountenable) {
            that.fullDiscountRule.initfullDiscountmoney = that.fullDiscountRule.fullDiscountmoney
            that.fullDiscountRule.initdiscountenable = that.fullDiscountRule.discountenable
          }
          that.birthdayDiscountRule = res.data.birthdayDiscountRule || {}
          if (shopConfirmResult.gift_list) {
            /**满赠新规则 规则集合 */
            that.fullgiftrulenew = JSON.parse(shopConfirmResult.gift_list)
            var list = that.fullgift.list,
              index = null
            for (var i = 0; i < list.length; i++) {
              if (list[i].giftid == that.fullgiftrulenew[0].giftid) {
                index = i
                break
              }
            }
            list.splice(index, 1, that.fullgiftrulenew[0])
            that.fullgift.list = list
          } else {
            /**满赠新规则 规则集合 */
            that.fullgiftrulenew =
              String(that.fullgift) != '{}' && that.fullgift.list && that.fullgift.list.length
                ? that.fullgift.list
                : []
          }
          /**满减活动规则 */
          that.fullMinusRules = res.data.fullMinusRules || {}
          if (that.fullMinusRules.actStatus == 1) {
            that.fullMinusRules.initactStatus = that.fullMinusRules.actStatus
            that.fullMinusRules.initfullminusmoney = that.fullminusmoney
            that.fullMinusRules.initextraMinusMoney = that.fullMinusRules.extraMinusMoney
          }
          /**买赠规则 */
          that.buygiftrule = res.data.buygiftrule || {}

          let itemlist = res.data.itemlist || []
          if (
            that.$route.query.yl == 1 ||
            that.$route.query.ms == 1 ||
            that.$route.query.ylact == 1
          ) {
            var arr = [],
              temp1 = 0
            itemlist.map(function (item) {
              if (item.ishalfprice && !temp1) {
                temp1 = 1
                that.ishalfprice = item.ishalfprice
              }
              /**
               * 预售付定金活动商品
               * 后端接口定义
               *  key: price, 销售价格
               *  key: finalpaymentmoney, 尾款价格
               * 前端定义
               *  new key: finalprice = price, 销售价格
               *  key: price = finalpaymentmoney, 尾款价格
               * */
              if (item.isdeposit == 1) {
                item.finalprice = item.price
                item.price = item.finalpaymentmoney
                that.depositmoney += parseFloat(item.depositmoney)
              }

              item.isdiscount = 0
              item.isfullgift = 0
              if (item.isgift != 1) {
                arr.push(item)
              }
              if (item.isbirthdaygift == 1) {
                arr.push(item)
              }
              /**
               * activity: 69元任选3件
               * cteatetime: 20230222
               * creater: gao en hui
               * scene：69元任选三件商品单价显示原价，可直接赋值销售价字段，该活动最终实付金额固定为￥69.00
               * */
              if (that.$route.query.mtact == 1 && item.isbirthdaygift != 1) {
                item.price = item.cost_price
              }
            })
            that.list = arr
          } else {
            var temp1 = 0
            that.subscribegoods_totalmoney = 0
            itemlist.map(function (item) {
              if (item.ishalfprice && !temp1) {
                temp1 = 1
                that.ishalfprice = item.ishalfprice
              }
              /**
               * 预售付定金活动商品
               * 后端接口定义
               *  key: price, 销售价格
               *  key: finalpaymentmoney, 尾款价格
               * 前端定义
               *  new key: finalprice = price, 销售价格
               *  key: price = finalpaymentmoney, 尾款价格
               * */
              if (item.isdeposit == 1) {
                item.finalprice = item.price
                item.price = item.finalpaymentmoney
                that.depositmoney += parseFloat(item.depositmoney)
              }
              /**
               * activity: 38预约活动商品
               * cteatetime: 20230216
               * creater: gao en hui
               * scene：只考虑正品下单参与活动的商品（换购、加购等活动不考虑是否参与情况）
               * */
              if (Object.keys(that.subscribegoodsrule).length) {
                if (
                  (',' + that.subscribegoodsrule.notitems + ',').indexOf(',' + item.skuid + ',') <=
                  -1
                ) {
                  that.subscribegoods_totalmoney += parseFloat(
                    parseFloat(item.price) * parseInt(item.num)
                  )
                }
              }
            })
            that.list = itemlist
          }
          /**下单风险提示 */
          that.fraud = res.data.risktips || ''
          /**满赠活动规则 */
          that.fullgiftrule = res.data.fullgiftrule || {}
          /**折上折活动规则 */
          that.discountrule = res.data.discountrule || {}
          /**提交订单满额送券提示 */
          that.couponstips = res.data.couponstips || {}
          /**提交订单抽奖提示 */
          that.drawprizetips = res.data.drawprizetips || {}
          that.halfprice = {
            halfpricestatus: res.data.halfpricestatus || 0 /**5折活动开启状态 */,
            halfpricedesc: res.data.halfpricedesc || '' /**5折活动描述 */,
            halfactname: res.data.halfactname || '' /**5折活动名称 */,
            halfactlabel: res.data.halfactlabel || '' /**5折活动标签内容 */
          }

          if (
            that.$route.query.acttype != 'vip35_welfare' &&
            (that.$route.query.iszg == 1 ||
            that.$route.query.yl == 1 ||
            that.$route.query.ylact == 1 ||
              that.$route.query.ms == 1)
          ) {
            res.data.integer = {
              allinteger: 0,
              integerlist: [],
              integeruserate: 0,
              integral_rule: [],
              integermoneyrule: [],
              ispreferentialmutex: 0
            }
            res.data.couponlist = []
            res.data.discountcouponlist = []
            res.data.goodscouponrule = []
          }
          /**积分规则信息 */
          that.integerrule = res.data.integer || {}
          if (res.data.couponlist) that.nocoupontext = res.data.couponlist.length > 0 ? '现金券不可用' : '无可用现金券'
          /**可使用现金券列表 */
          that.couponlistrule = res.data.couponlist || []
          /**可使用折扣券列表 */
          if (res.data.discountcouponlist && res.data.discountcouponlist.length) {
            let money = 0,
              discount = parseFloat(res.data.discountcouponlist[0].discountRatio)
            that.list.forEach((item) => {
              if (item.ifspecial == 'no') {
                that.loaddiscountcouponsCheck({
                  couponItem: res.data.discountcouponlist[0],
                  item,
                  success: () => {
                    const money1 =
                      parseFloat(item.original_price || 0) * discount * parseInt(item.num || 1)
                    const money2 = parseFloat(item.price || 0) * parseInt(item.num || 1)
                    money += money2 - money1
                  }
                })
              }
            })
            that.discountcouponlist = [
              { ...res.data.discountcouponlist[0], price: parseFloat(money.toFixed(2)) }
            ]
            that.usecouponFromDiscountcoupon = res.data.discountcouponlist[0].couponsEnable
            that.useintegralFromDiscountcoupon = res.data.discountcouponlist[0].integralEnable
            that.isDiscountcouponMsgHandle = 0
          }
          /**当前下单商品匹配到产品券集合 */
          that.goodscouponrule = res.data.goodscouponrule || []
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
          that.count('init')
        }
      })
    },
    discountFn: function () {
      var that = this
      let discountlist = [],
        discount_rule = {}
      that.discountGoodsnum = 0
      that.fulldiscountGoodsnum = 0
      that.currentdiscountdata = 0
      that.list.forEach((item) => {
        if (item.isdiscount == 1) {
          that.discountGoodsnum += parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        } else if (item.isFullDiscount == 1 && this.fullDiscountRule.ruleObj && Object.keys(this.fullDiscountRule.ruleObj).length == 1) {
          that.fulldiscountGoodsnum += parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        }
      })
      fullDiscountHandle(that)
      discountHandle(that, { discountlist, discount_rule })
      this.fullminusdiscountFn()
      this.fullgiftFn()
    },
    fullgiftFn: function () {
      var that = this
      /**满赠 */
      if (this.fullgiftrule && parseInt(this.fullgiftrule.actstatus) == 1 && !this.FlodMsg) {
        if (this.fullgiftrule.rulelist && this.fullgiftrule.rulelist.length > 0) {
          var rulelist = this.fullgiftrule.rulelist
          this.fullGiftMoneyFn('fullgiftFn')
          if (!isNaN(Number(that.currentfullgiftmoney))) {
            if (
              parseFloat(that.currentfullgiftmoney) == 0 ||
              parseFloat(that.currentfullgiftmoney) <
                parseFloat(rulelist[rulelist.length - 1].allmoney)
            ) {
              let m = !isNaN(Number(rulelist[rulelist.length - 1].allmoney))
                ? parseFloat(
                    Number(rulelist[rulelist.length - 1].allmoney) -
                      Number(that.currentfullgiftmoney)
                  ).toFixed(2)
                : '0.00'
              let m1 = !isNaN(parseFloat(rulelist[rulelist.length - 1].senditemprice))
                ? parseFloat(rulelist[rulelist.length - 1].senditemprice).toFixed(2)
                : '0.00'
              that.FullGiftMsg =
                '惊喜！还差<span>' +
                m +
                '</span>元，即送价值<span>' +
                (parseFloat(m1) > 0
                  ? m1
                  : parseFloat(rulelist[rulelist.length - 1].itemprice).toFixed(2)) +
                '</span>元' +
                rulelist[rulelist.length - 1].senditemname
            } else if (parseFloat(that.currentfullgiftmoney) >= parseFloat(rulelist[0].allmoney)) {
              let m = !isNaN(parseFloat(rulelist[0].allmoney))
                ? parseFloat(rulelist[0].allmoney).toFixed(2)
                : '0.00'
              let m1 = !isNaN(parseFloat(rulelist[0].senditemprice))
                ? parseFloat(rulelist[0].senditemprice).toFixed(2)
                : '0.00'
              that.FullGiftMsg =
                '惊喜！已满<span>' +
                m +
                '</span>元，送价值<span>' +
                (parseFloat(m1) > 0 ? m1 : parseFloat(rulelist[0].itemprice).toFixed(2)) +
                '</span>元' +
                rulelist[0].senditemname
            } else {
              try {
                rulelist.forEach(function (item, index) {
                  if (parseFloat(that.currentfullgiftmoney) >= parseFloat(item.allmoney)) {
                    let m = !isNaN(parseFloat(rulelist[index].allmoney))
                      ? parseFloat(Number(rulelist[index].allmoney)).toFixed(2)
                      : '0.00'
                    let m1 = !isNaN(parseFloat(rulelist[index].senditemprice))
                      ? parseFloat(rulelist[index].senditemprice).toFixed(2)
                      : '0.00'
                    that.FullGiftMsg =
                      '惊喜！已满<span>' +
                      m +
                      '</span>元，送价值<span>' +
                      (parseFloat(m1) > 0 ? m1 : parseFloat(rulelist[index].itemprice).toFixed(2)) +
                      '</span>元' +
                      rulelist[index].senditemname
                    let m2 = !isNaN(parseFloat(rulelist[index - 1].allmoney))
                      ? parseFloat(
                          Number(rulelist[index - 1].allmoney) - Number(that.currentfullgiftmoney)
                        ).toFixed(2)
                      : '0.00'
                    let m3 = !isNaN(parseFloat(rulelist[index - 1].senditemprice))
                      ? parseFloat(rulelist[index - 1].senditemprice).toFixed(2)
                      : '0.00'
                    that.FullGiftMsg +=
                      '，再加<span>' +
                      m2 +
                      '</span>元，奖品升级为价值<span>' +
                      (parseFloat(m3) > 0
                        ? m3
                        : parseFloat(rulelist[index - 1].itemprice).toFixed(2)) +
                      '</span>元' +
                      rulelist[index - 1].senditemname
                    throw new Error()
                  }
                })
              } catch (e) {}
            }
          }
        }
        if (that.FullGiftMsg != '') {
          that.FullGiftMsg += '（' + this.fullgiftrule.actname + '）'
        }
      }
    },
    /**参与满赠的商品金额 */
    fullGiftMoneyFn: function(type) {
      var that = this
      var choose_coupon = JSON.parse(sessionStorage.getItem('choose_coupon') || '{}')
      let isFullGiftCoupon = true // 满赠活动门槛金额比较是否需要抵扣现金券 true是 false否
      if (this.fullgiftrule.couponids && that.couponChecked) {
        let couponids = this.fullgiftrule.couponids.split(',')
        if (couponids.includes(choose_coupon && choose_coupon.coupontype != 3 && choose_coupon.couponid ? choose_coupon.couponid : '')) {
          isFullGiftCoupon = false
        }
      }
      this.couponsdiscountPrice()
      this.integraldiscountPrice()
      if (this.allItemids.length) {
        this.fullminusdiscountFn()
      }
      let fullGiftTotalMoney = 0
      that.allItemids.forEach(function (item) {
        if (item.isfullgift == 1) {
          let itemprice = item.price * item.num
          fullGiftTotalMoney += itemprice -
            (item.birthdaydiscountmoney +
              (isFullGiftCoupon ? item.couponsdiscountmoney : 0) +
              item.discountcouponmoney +
              item.fulldiscountmoney +
              item.fullminusmoney +
              item.moredismoney +
              (item.isdiscount == 1 ? (itemprice * (1 -that.currentdiscountdata)) : 0))
        }
      })
      var integral = JSON.parse(sessionStorage.getItem('choose_integral') || '{}')
      var integermoney = parseFloat(integral.checked ? parseFloat(integral.integermoney || 0) : 0)
      that.currentfullgiftmoney = parseFloat(fullGiftTotalMoney - integermoney).toFixed(2)
    },
    fullminusdiscountFn: function () {
      var that = this
      that.fullminustotalmoney = 0
      that.list.map(function (item) {
        if (item.isfullMinus == 1) {
          that.fullminustotalmoney +=
            parseFloat(item.price) * parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        }
      })
      /**满减 */
      if (that.fullMinusRules.actStatus == 1) {
        if (that.fullMinusRules.isSuperpose == 1 && that.fullminustotalmoney > 0) {
          let variable = Math.floor(
            that.fullminustotalmoney / parseFloat(that.fullMinusRules.fullMoney)
          )
          variable = variable + 1
          that.fullminusmoney = parseFloat(that.fullMinusRules.minusMoney) * (variable - 1)
          that.extraMinusMoney = parseFloat(that.fullMinusRules.extraMinusMoney) * (variable - 1)
          that.fullminusmoney = that.fullminusmoney + that.extraMinusMoney
        } else if (that.fullminustotalmoney > 0) {
          if (that.fullminustotalmoney >= that.fullMinusRules.fullMoney) {
            that.fullminusmoney = parseFloat(that.fullMinusRules.minusMoney)
            that.extraMinusMoney = parseFloat(that.fullMinusRules.extraMinusMoney)
            that.fullminusmoney = that.fullminusmoney + that.extraMinusMoney
          }
        }
        that.fullMinusRules.initfullminusmoney = that.fullminusmoney
        that.list.map(function (item) {
          if (item.isfullMinus == 1) {
            let price =
              parseFloat(item.price) * parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
            item.fullminusmoney = parseFloat(
              price * (that.fullminusmoney / that.fullminustotalmoney)
            ).toFixed(2)
            item.initfullminusmoney = parseFloat(
              price * (that.fullMinusRules.initfullminusmoney / that.fullminustotalmoney)
            ).toFixed(2)
            that.allItemids.forEach(function (item1) {
              if (item1.id == item.skuid) {
                item1.fullminusmoney = item.fullminusmoney ? parseFloat(item.fullminusmoney) : 0
                item1.initfullminusmoney = item.initfullminusmoney
                  ? parseFloat(item.initfullminusmoney)
                  : 0
              }
            })
          }
        })
      }
    },
    /**折扣券-优惠金额分摊（主要计算券的使用抵扣）
     * @param {*} init 1: 虚拟活动匹配的可用券列表-用于匹配折扣券+优惠券与活动+优惠券之间的对比
     */
    discountCouponPrice(item, { init = 0 } = {}) {
      let discountcouponmoney = 0
      let shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (item.ifspecial == 'no' && shopConfirmResult.choose_discount_coupon && (this.discountCouponChecked || init == 1)) {
        let discountcoupon = shopConfirmResult.choose_discount_coupon
          ? shopConfirmResult.choose_discount_coupon
          : {}

        this.loaddiscountcouponsCheck({
          couponItem: discountcoupon,
          item,
          success: () => {
            if (discountcoupon.discountWay == 1) {
              discountcouponmoney =
                parseFloat(item.price) -
                parseFloat(item.original_price) * discountcoupon.discountRatio
            }
            discountcouponmoney *= item.num
          },
          error: () => {
            discountcouponmoney = 0
          }
        })
      } else {
        discountcouponmoney = 0
      }
      return discountcouponmoney > 0 ? discountcouponmoney : 0
    },
    /**生日折扣-优惠金额分摊（主要计算券的使用抵扣） */
    birthdayDiscountPrice(item) {
      let rule = this.birthdayDiscountRule
      if (
        rule &&
        rule.discountenable == 1 &&
        rule.discountmoney &&
        parseFloat(rule.discountmoney) > 0 &&
        item.isBirthdayDiscount == 1
      ) {
        let m = (item.price - item.original_price * (rule.discount || 1)) * item.num
        return m > 0 ? m : 0
      } else {
        return 0
      }
    },
    /**限时折扣-优惠金额分摊（主要计算券的使用抵扣）
     * @param {*} init 1: 虚拟活动匹配的可用券列表-用于匹配折扣券+优惠券与活动+优惠券之间的对比
     */
    fullDiscountPrice(item, { init = 0 } = {}) {
      let rule = this.fullDiscountRule
      let discountEnable = rule[init == 1 ? 'initdiscountenable' : 'discountenable']
      let fullDiscountMoney = rule[init == 1 ? 'initfullDiscountmoney' : 'fullDiscountmoney']
      if (
        rule &&
        discountEnable == 1 &&
        fullDiscountMoney &&
        parseFloat(fullDiscountMoney) > 0 &&
        item.fullDiscountRuleId &&
        rule.ruleObj &&
        rule.ruleObj[item.fullDiscountRuleId].rulelist &&
        rule.ruleObj[item.fullDiscountRuleId].rulelist.length &&
        item.isFullDiscount == 1
      ) {
        let m =
          (item.price - item.original_price * (this.fullDiscount[item.fullDiscountRuleId] || 1)) *
          item.num
        return m > 0 ? m : 0
      } else {
        return 0
      }
    },
    /**n件立减-优惠金额分摊（主要计算券的使用抵扣）
     * @param {*} init 1: 虚拟活动匹配的可用券列表-用于匹配折扣券+优惠券与活动+优惠券之间的对比
     */
    morediscountsPrice(item, { init = 0 } = {}) {
      let moredismoney = 0
      if (item.ismorediscounts == 1 && item.num >= item.morediscountsitemnum) {
        if (item.issuperposition != 0) {
          moredismoney =
            parseFloat(item.morediscountsmoney) * parseInt(item.num / item.morediscountsitemnum)
        } else {
          moredismoney = parseFloat(item.morediscountsmoney)
        }
      }
      let moreDiscountsMoney =
        init == 1 ? parseFloat(this.morediscounts.initmorediscountsmoney) : this.morediscountsmoney
      if (moreDiscountsMoney > 0) {
        return moredismoney || 0
      } else {
        return 0
      }
    },
    /**现金券抵扣金额 */
    couponsdiscountPrice() {
      if (!this.localCoupon || !this.localCoupon.checked) {
        this.allItemids.forEach((item) => {
          item.couponsdiscountmoney = 0
        })
        return
      }
      let allMoney = 0
      this.allItemids.forEach((item) => {
        this.loadcouponsCheck({
          couponItem: this.localCoupon,
          item,
          callback: () => {
            let itemmoney = item.price * item.num
            let itemdismoney = item.moredismoney
              + item.fullminusmoney
              + item.fulldiscountmoney
              + item.birthdaydiscountmoney
              + (item.isdiscount == 1 ? (itemmoney * (1 - this.currentdiscountdata)) : 0)
              + item.discountcouponmoney
            allMoney += itemmoney - itemdismoney
          }
        })
      })
      this.allItemids.forEach((item) => {
        item.couponsdiscountmoney = 0
        this.loadcouponsCheck({
          couponItem: this.localCoupon,
          item,
          callback: () => {
            let itemmoney = item.price * item.num
            let itemdismoney = item.moredismoney
              + item.fullminusmoney
              + item.fulldiscountmoney
              + item.birthdaydiscountmoney
              + (item.isdiscount == 1 ? (itemmoney * (1 - this.currentdiscountdata)) : 0)
              + item.discountcouponmoney
            if (this.localCoupon.coupontype != 3)
              item.couponsdiscountmoney = ((itemmoney - itemdismoney) / allMoney) * this.localCoupon.price
          }
        })
      })
    },
    /**金币抵扣金额分摊，按可使用金币商品的销售价*数量写入 allItemids.integraldiscountmoney */
    integraldiscountPrice() {
      var integral = JSON.parse(sessionStorage.getItem('choose_integral') || '{}')
      var choose_coupon = JSON.parse(sessionStorage.getItem('choose_coupon') || '{}')
      var integermoney = integral.checked && this.integralChecked ? parseFloat(integral.integermoney || 0) : 0
      var cash_coupon_on =
        this.couponChecked &&
        choose_coupon.coupontype != 3 &&
        (choose_coupon.couponid || choose_coupon.id)
      var mutex = this.ispreferentialmutex == 1 && cash_coupon_on
      var moneyFn = function (item) {
        if (parseInt(item.useInteger) != 1) return 0
        var itemmoney = parseFloat(item.price || 0) * parseFloat(item.num || 0)
        return itemmoney > 0 ? itemmoney : 0
      }
      if (!(integermoney > 0) || mutex) {
        this.allItemids.forEach(function (item) {
          item.integraldiscountmoney = 0
        })
        return
      }
      var allmoney = 0
      this.allItemids.forEach(function (item) {
        allmoney += moneyFn(item)
      })
      this.allItemids.forEach(function (item) {
        var itemmoney = moneyFn(item)
        item.integraldiscountmoney = allmoney > 0 && itemmoney > 0 ? (itemmoney / allmoney) * integermoney : 0
      })
    },
    /**所有品的活动优惠分摊商品列表 */
    allItemIdsFunc({ item }) {
      let obj = {
        id: item.skuid,
        num: item.num && parseInt(item.num) >= 0 ? item.num : 1,
        price: item.changebuy_price || item.price || 0,
        isdiscount: item.isdiscount,
        moredismoney: this.morediscountsPrice(item),
        initmoredismoney: this.morediscountsPrice(item, { init: 1 }),
        fullminusmoney: 0,
        initfullminusmoney: 0,
        fulldiscountmoney: this.fullDiscountPrice(item),
        initfulldiscountmoney: this.fullDiscountPrice(item, { init: 1 }),
        birthdaydiscountmoney: this.birthdayDiscountPrice(item),
        discountcouponmoney: this.discountCouponPrice(item),
        initdiscountcouponmoney: this.discountCouponPrice(item, { init: 1 }),
        isfullgift: item.isfullgift || 0,
        fullDiscountRuleId: item.fullDiscountRuleId,
        ismorediscounts: item.ismorediscounts || 0,
        couponsenable: item.couponsenable || 0,
        isFullDiscount: item.isFullDiscount || 0,
        useInteger: parseInt(item.useInteger) == 1 ? 1 : 0,
        integraldiscountmoney: 0
      }
      if (this.allItemids.some((i) => i.id == item.skuid)) {
        const index = this.allItemids.findIndex((i) => i.id == item.skuid)
        if (index !== -1) {
          this.allItemids[index] = obj
        }
        return
      }
      this.allItemids.push(obj)
    },
    /**初始化金额计算 */
    initmoney: function (type) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult')),
        that = this,
        totalmoney = 0
      that.totalnum = 0
      that.totalnumshow = 0
      that.birthdaygifttotalnum = 0
      that.directReductionmoney = 0
      that.allItemids = []
      /**功能说明Start：
       * 生日折扣与限时折扣同时进行时，
       * 因除购物车以外的商品相关接口价格与订单确认商品接口价格不符，
       * 所以需要重新计算总金额（执行次数为1），
       * 否则，
       * 购物车以外的商品相关接口返回的商品金额*数量之和与订单确认商品接口返回的商品金额*数量之和不一致，
       * 导致总金额计算错误 */
      if (
        !shopConfirmResult.init_totalmoney_data &&
        this.iszg != 1 &&
        this.yl != 1 &&
        this.ylact != 1 &&
        this.ms != 1
      ) {
        shopConfirmResult.init_totalmoney_data = 1
        let moneyTemp = 0
        this.list.map(function (item) {
          if (
            shopConfirmResult.skuidArr.indexOf(item.skuid) >= 0 ||
            shopConfirmResult.recommendskuid == item.skuid
          ) {
            moneyTemp += parseFloat(item.price) * parseInt(item.num)
          }
        })
        if (moneyTemp > 0) {
          shopConfirmResult.totalmoney = moneyTemp
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
        }
      }
      /**End */
      if (!sessionStorage.getItem('choose_coupon') && !shopConfirmResult.init_coupon_data) {
        shopConfirmResult.init_coupon_data = 0 /**初始化自动匹配现金券数据 0用户未选择，需匹配； 1用户主动已选择 */
        localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      }
      if (
        !shopConfirmResult.choose_discount_coupon &&
        !shopConfirmResult.init_discount_coupon_data
      ) {
        shopConfirmResult.init_discount_coupon_data = 0 /**初始化自动匹配现金券数据 0用户未选择，需匹配； 1用户主动已选择 */
        localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      }
      if (shopConfirmResult.changebuy_list) {
        var changebuylist = JSON.parse(shopConfirmResult.changebuy_list)
        changebuylist.map((item) => {
          if (item.directReductionPrice && item.directReductionPrice > 0) {
            that.directReductionmoney += item.directReductionPrice * item.num
            item.new_price = parseFloat(
              parseFloat(item.price) + parseFloat(item.directReductionPrice)
            ).toFixed(2)
          }
          item.price = item.changebuy_price
          item.ischangebuy = 1
          let i = that.changebuyList.findIndex((listItem) => listItem.skuid === item.skuid)
          if (i > -1) {
            that.changebuyList[i] = Object.assign({}, item, that.changebuyList[i])
          }
          totalmoney += parseFloat(item.price) * parseInt(item.num)
        })
        if (type == 'init') that.list = that.list.concat(that.changebuyList)
      }
      fullDiscountHandle(that)
      // that.halfprice.inithalfpricemoney = 0
      that.list.map(function (item) {
        if (item.isgift != 1 && item.isgiftproduct != 1) {
          that.allItemIdsFunc({ item })
        }
        if (item.directReductionPrice && item.directReductionPrice > 0) {
          that.directReductionmoney += item.directReductionPrice * item.num
          item.new_price = parseFloat(
            parseFloat(item.price) + parseFloat(item.directReductionPrice)
          ).toFixed(2)
        }
        if (item.isgiftproduct != 1) {
          that.totalnum =
            that.totalnum + parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        }
        if (item.isintellrecommend != 1 && item.isgiftproduct != 1) {
          that.totalnumshow =
            that.totalnumshow + parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        }
        if (item.isbirthdaygift == 1) {
          that.birthdaygifttotalnum += parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
        }
      })
      that.totalmoney =
        parseFloat(shopConfirmResult.totalmoney) +
        totalmoney -
        that.discountmoney -
        parseFloat(that.birthdayDiscountRule.discountmoney || 0) +
        that.exchangetotalmoney
      that.totalprice = that.totalmoney
      if (type == 'init') that.listtemp = JSON.stringify(that.list)
    },

    getRule: function (integer, couponlist) {
      this.useIntegerlist = []
      this.nouseIntegerlist = []
      this.couponlist = []
      var that = this
      if (integer) {
        that.integerAllList = integer.integerlist
        that.totalIntegral = integer.allinteger
        that.interate = integer.integeruserate
        that.integralrule = integer.integral_rule
      }
      that.couponlist = couponlist
      that.exchangeRuleItemids()
      that.getjifen()
      that.loadcoupons()
      that.saveIntegral(that.integralChecked, 0)
      that.checkProduct()
    },
    showActDesc: function (type) {
      var that = this
      var isdiscount = 0
      var isfullgift = 0
      that.list.map(function (item) {
        if (item.isdiscount == 1) {
          isdiscount = 1
        }
        if (item.isfullgift == 1) {
          isfullgift = 1
        }
      })
      var obj = {
        isdiscount: isdiscount,
        isfullgift: isfullgift
      }
      that.msglist = []
      if (type != 'morediscounts') {
        if (
          that.discountrule &&
          that.discountrule.discountenable == 1 &&
          that.discountrule.discountlist &&
          obj.isdiscount == 1
        ) {
          var msg = []
          that.discountrule.discountlist.forEach(function (item, index) {
            var txt =
              (item.discount * 100) % 10 == 0 ? (item.discount * 100) / 10 : item.discount * 100
            msg.push(item.itemnum + '件' + txt + '折')
          })
          var discountruledesc = '满' + msg.join(',')
          that.msglist.push({
            enable: that.discountrule.discountenable,
            shortdesc: discountruledesc,
            desc: that.discountrule.discountdesc,
            name: that.discountrule.name,
            actlabel: that.discountrule.actlabel
          })
        }
        if (
          that.fullgiftrule &&
          that.fullgiftrule.actstatus == 1 &&
          that.fullgiftrule.rulelist &&
          obj.isfullgift == 1
        ) {
          that.msglist.push({
            enable: that.fullgiftrule.actstatus,
            shortdesc: that.fullgiftrule.actdesc,
            desc: that.fullgiftrule.actdesc,
            name: that.fullgiftrule.actname,
            actlabel: that.fullgiftrule.actlabel
          })
        }
        try {
          if (that.fullgift && String(that.fullgift) != '{}' && that.fullgift.list.length > 0) {
            that.fullgift.actstatus = 1
            that.msglist.push({
              enable: that.fullgift.actstatus,
              shortdesc: that.fullgift.actdesc,
              desc: that.fullgift.actdesc,
              name: that.fullgift.actname,
              actlabel: ''
            })
          }
        } catch (e) {}
        if (that.halfprice.halfpricestatus == 1) {
          that.msglist.push({
            enable: that.halfprice.halfpricestatus,
            shortdesc: that.halfprice.halfpricedesc,
            desc: that.halfprice.halfpricedesc,
            name: that.halfprice.halfactname,
            actlabel: that.halfprice.halfactlabel
          })
        }
      } else {
        if (!that.morediscounts.discountenable == 1) {
          that.msglist.push({
            enable: parseFloat(that.morediscountsmoney) > 0 ? 1 : 0,
            shortdesc: that.morediscounts.discountdesc ? that.morediscounts.discountdesc : '',
            desclist: that.morediscounts.discountdesc ? null : that.morediscounts.discountlist ? that.morediscounts.discountlist : [],
            desc: that.morediscounts.discountdesc || '',
            name: '',
            actlabel: that.morediscounts.name || that.morediscounts.discountlist[0].name || '多件立减'
          })
        }
      }
      that.showaction = true
    },
    /**2期加购活动 */
    /**商品数量加减 */
    addToCart(type, index, indexB, item) {
      if (
        this.exchangeitemlist[index].exchangetotalNumber + 1 >
          this.exchangeitemlist[index].maxcanbuycnt &&
        type == 1
      ) {
        this.$toast('超出最大可加购数量')
        return
      }
      let num = parseInt(item.num),
        max = parseInt(item.canbuycnt)
      if (type) {
        if (num >= max) {
          this.$toast('最多可购买' + max + '件')
          return
        }
        num += 1
      } else {
        if (num <= 1) {
          this.$toast('不能再减了')
          return
        }
        num += -1
      }
      this.exchangeitemlist[index].changebuylist[indexB].num = num
      this.exchangeitemlisttemp = JSON.stringify(this.exchangeitemlist)
      this.count()
    },

    recommendAddToCart(type, index, item, isclose) {
      let num = parseInt(item.num),
        max = parseInt(item.canbuycnt),
        shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (type) {
        if (num >= max) {
          this.$toast('最多可购买' + max + '件')
          return
        }
        num += 1
        shopConfirmResult.totalmoney =
          parseFloat(shopConfirmResult.totalmoney) + parseFloat(this.recommenditemlist[index].price)
        shopConfirmResult.totalnum = shopConfirmResult.totalnum + 1
      } else {
        num += -1
        shopConfirmResult.totalmoney =
          parseFloat(shopConfirmResult.totalmoney) - parseFloat(this.recommenditemlist[index].price)
        shopConfirmResult.totalnum = shopConfirmResult.totalnum - 1
      }
      this.recommenditemlist[index].num = num
      this.recommendnumber = this.recommenditemlist[index].num
      this.recommendmoney =
        parseFloat(this.recommenditemlist[index].price) *
        parseInt(this.recommenditemlist[index].num)
      if (this.recommenditemlist.length) {
        if (isclose == 1) shopConfirmResult.recommendclose = 1
        shopConfirmResult.recommendnum = this.recommenditemlist[index].num
        localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      }
      this.getData()
    },

    closeRecommend(type, index, item) {
      let num = this.recommenditemlist[index].num - 1,
        shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.totalmoney =
        parseFloat(shopConfirmResult.totalmoney) -
        parseFloat(this.recommenditemlist[index].price) * num
      shopConfirmResult.totalnum = shopConfirmResult.totalnum - num
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.recommenditemlist[index].num = 1
      this.recommendAddToCart(type, index, item, 1)
    },
    /**
     * 关闭加购弹窗
     */
    exchangeCloseHandle() {
      this.exchangeitemlist.forEach((item) => {
        item.changebuylist.forEach((changebuyitem) => {
          changebuyitem.ischoose = 0
        })
      })
      this.exchangeitemlisttemp = JSON.stringify(this.exchangeitemlist)
      this.count()
      this.exchangeShow = false
    },
    /**选择/取消选择 */
    choice(index, indexB) {
      let exchangetotalnumtemp = 0
      this.exchangeitemlist[index].changebuylist.map((item, idx) => {
        if (item.ischoose && idx != indexB && item.singlechoose == 1) {
          item.ischoose = 0
        } else if (
          this.exchangeitemlist[index].changebuylist[indexB].ischoose &&
          this.exchangeitemlist[index].changebuylist[indexB].singlechoose == 1 &&
          idx != indexB
        ) {
          item.ischoose = 0
        }
        if (item.ischoose) {
          exchangetotalnumtemp += parseInt(item.num)
        }
      })
      if (
        exchangetotalnumtemp > this.exchangeitemlist[index].maxcanbuycnt &&
        this.exchangeitemlist[index].changebuylist[indexB].ischoose
      ) {
        this.exchangeitemlist[index].changebuylist[indexB].ischoose = 0
        this.$toast('超出最大可加购数量')
        return
      }
      this.exchangeitemlist[index].changebuylist[indexB].ischoose = this.exchangeitemlist[index]
        .changebuylist[indexB].ischoose
        ? 1
        : 0
      this.exchangeitemlisttemp = JSON.stringify(this.exchangeitemlist)
      this.count()
    },
    /**加购活动规则 */
    exchangeRule() {
      let list = this.exchangeitemlist,
        notbuygift_changebuy_money = 0,
        shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult')),
        exchange_morediscountsmoney = 0,
        exchangeGray = true
      this.exchangechooseitemlist = []
      this.exchangetotalmoney = 0
      this.exchangetotalnum = 0
      if (shopConfirmResult) {
        shopConfirmResult.notbuygift_changebuy_money = 0
      }
      for (let i = 0; i < list.length; i++) {
        list[i].exchangetotalNumber = 0
        list[i].exchangetotalmoney = 0
        let changebuylist = list[i].changebuylist
        if (!list[i].ishide) {
          for (let j = 0; j < changebuylist.length; j++) {
            if (changebuylist[j].ischoose) {
              exchangeGray = false
              this.exchangechooseitemlist.push(changebuylist[j])
              list[i].exchangetotalNumber += parseInt(changebuylist[j].num)
              this.exchangetotalnum += parseInt(changebuylist[j].num)
              list[i].exchangetotalmoney +=
                parseInt(changebuylist[j].num) * parseFloat(changebuylist[j].changebuy_price)
              this.exchangetotalmoney +=
                parseInt(changebuylist[j].num) * parseFloat(changebuylist[j].changebuy_price)
              if (changebuylist[j].isfullgift != 1 && shopConfirmResult) {
                notbuygift_changebuy_money +=
                  changebuylist[j].num * changebuylist[j].changebuy_price
              }
              if (
                changebuylist[j].ismorediscounts &&
                changebuylist[j].num >= changebuylist[j].morediscountsitemnum
              ) {
                if (changebuylist[j].issuperposition != 0) {
                  exchange_morediscountsmoney =
                    parseFloat(changebuylist[j].morediscountsmoney) *
                    parseInt(changebuylist[j].num / changebuylist[j].morediscountsitemnum)
                } else {
                  exchange_morediscountsmoney = parseFloat(changebuylist[j].morediscountsmoney)
                }
              }
            }
          }
        }
      }
      try {
        this.morediscountsmoney =
          parseFloat(this.morediscounts.morediscountsmoney || 0) + exchange_morediscountsmoney
      } catch (e) {}
      this.exchangeGrayBtn = exchangeGray
      shopConfirmResult.notbuygift_changebuy_money = notbuygift_changebuy_money
      this.exchangeitemlisttemp = JSON.stringify(list)
      shopConfirmResult.exchangeitemlist = JSON.stringify(list)
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
    },
    /**满足条件的加购规则显示 */
    exchangeGoodsIshide(m) {
      let choose_coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
      let couponPriceTemp = 0
      /**coupontype = 3
       * 大额券只抵扣实付金额，这里需将抵扣的金额加回后判断加购品条件 */
      if (
        sessionStorage.getItem('choose_coupon') &&
        this.couponChecked &&
        choose_coupon.coupontype == 3
      ) {
        couponPriceTemp = parseFloat(choose_coupon.price)
      }
      let exchangetotalmoney = 0
      this.exchangeitemlist.map((item) => {
        if (
          parseFloat(
            parseFloat(
              m +
                couponPriceTemp -
                this.morediscountsmoney -
                this.exchangetotalmoney -
                this.fullminusmoney
            ).toFixed(2)
          ) < parseFloat(item.exchangepaymoney)
        ) {
          item.ishide = true
          exchangetotalmoney += item.exchangetotalmoney || 0
        } else {
          item.ishide = false
        }
      })
      return exchangetotalmoney
    },
    exchangeRuleItemids() {
      var that = this,
        noexchangechooseitemlist = []
      that.exchangechooseitemlist = []
      /**实付金额 +活动抵扣 不含运费 用于活动折扣计算 */
      var m = parseFloat(this.totalprice) + parseFloat(this.giftmoney)

      this.exchangeGoodsIshide(m)

      this.exchangeitemlisttemp = JSON.stringify(this.exchangeitemlist)
      this.exchangeitemlist.map((item) => {
        let changebuylist = item.changebuylist
        if (!item.ishide) {
          changebuylist.map((goodsitem) => {
            if (goodsitem.ischoose) {
              that.exchangechooseitemlist.push(goodsitem)
            } else {
              noexchangechooseitemlist.push(goodsitem)
            }
          })
        } else {
          changebuylist.map((goodsitem) => {
            noexchangechooseitemlist.push(goodsitem)
          })
        }
      })
      var choose_coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
      that.exchangechooseitemlist.forEach(function (item) {
        let allIndex = -1
        that.allItemids.forEach((goodsitem, goodsindex) => {
          if (goodsitem.id == item.skuid) {
            allIndex = goodsindex
            return
          }
        })
        if (allIndex == -1) {
          that.allItemIdsFunc({ item })
        }
      })
      noexchangechooseitemlist.forEach((item) => {
        let allIndex = -1
        that.allItemids.forEach((goodsitem, goodsindex) => {
          if (goodsitem.id == item.skuid) {
            allIndex = goodsindex
            return
          }
        })
        if (allIndex != -1) {
          that.allItemids.splice(allIndex, 1)
        }
      })
    },
    /**计算已选中的商品数量 */
    count(type) {
      this.exchangeRule()
      this.initmoney(type)
      if (type == 'init') {
        this.checkdiscountcouponsPKact()
      }
      this.totalmoney -= parseFloat(this.fullDiscountRule.fullDiscountmoney || 0)
      this.totalprice = this.totalmoney
      this.getRule(this.integerrule, this.couponlistrule)
      this.giftAct()
      this.getBuygiftRule()
      this.checkdiscountcouponsPKact()
      if (type == 'init') {
        this.couponCheckedHandle()
        this.totalMoney()
        this.isDiscountcouponMsgHandle = 1
      }
    },
    /**买赠活动 */
    getBuygiftRule: function () {
      this.buygiftlist = []
      this.buygiftnum = 0
      let ruleList = this.buygiftrule.ruleList || []
      let isgobuygift = 0 /**多买赠活动 赠品存在多选一的情况 0否 1是 */
      let isShowChangeDialog = 0 /**规则中是否存在允许更换赠品的项 0否 1是（决定首次是否弹窗引导用户选择） */
      let shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      /**规则对象归一化：无 goodsList 时用平铺字段构造（兼容旧缓存），并计算正品关联 Id */
      var normalizeRule = function (item) {
        if (!item.goodsList || !item.goodsList.length) {
          item.goodsList = [
            {
              itemid: item.itemid,
              name: item.name,
              num: item.num,
              spec: item.spec,
              img_path: item.img_path
            }
          ]
        }
        /**规则级 itemid 统一取 goodsList 各 itemid 逗号拼接串（后端约定规则级 itemid 即 goodsList[0] 的 itemid，无条件覆盖保证实时与缓存两侧 key 一致） */
        if (item.goodsList.length) {
          item.itemid = item.goodsList
            .map(function (g) {
              return g.itemid
            })
            .join(',')
        }
        /**origoodsId 与规则级 itemid 同源（均已归一化为 goodsList 拼接串） */
        item.origoodsId = item.itemid
        /**规则级 showChangeEntry 冗余自子赠品（业务约定：同规则下 buygiftlist 各子项 showChangeEntry 相同） */
        if (item.buygiftlist && item.buygiftlist.length) {
          item.showChangeEntry = item.buygiftlist[0].showChangeEntry
        }
        return item
      }
      ruleList.map(normalizeRule)
      if (
        shopConfirmResult.buygiftrule &&
        shopConfirmResult.buygiftrule.ruleList &&
        shopConfirmResult.buygiftrule.ruleList.length
      ) {
        shopConfirmResult.buygiftrule.ruleList.map(normalizeRule)
      }
      if (ruleList.length > 0) {
        // 只要存在多买赠活动 赠品存在多选一的情况 isgobuygift=1；同时统计是否存在允许更换赠品的规则 isShowChangeDialog
        ruleList.map((item) => {
          if (item.buygiftlist.length > 1) isgobuygift = 1
          if (item.showChangeEntry == '1') isShowChangeDialog = 1
        })

        if (
          (shopConfirmResult.isgiftpoponce == 1 && !shopConfirmResult.isbuygiftpoponce) ||
          isgobuygift != 1
        ) {
          shopConfirmResult.buygiftlist = []
          shopConfirmResult.buygiftlist_submit = []
          shopConfirmResult.buygiftorigoods = []
        }
        // 每个赠品规则，如果只有一个赠品时，则自动匹配上
        if (isgobuygift != 1) {
          ruleList.map((item) => {
            /**买赠正品只赠一个赠品时 */
            if (item.buygiftlist.length == 1) {
              /**买赠 首次逻辑的写入 */
              if (
                (shopConfirmResult.isgiftpoponce == 1 && !shopConfirmResult.isbuygiftpoponce) ||
                isgobuygift != 1
              ) {
                item.buygiftlist[0].num = Math.min(Number(item.buygiftnum), Number(item.buygiftlist[0].limitNum))
                item.choosegiftnum = item.buygiftlist[0].num
                item.buygiftlist[0].isbuygift = 1
                shopConfirmResult.buygiftlist.push(item.buygiftlist[0])
                    shopConfirmResult.buygiftlist_submit.push({
                  itemid: item.buygiftlist[0].itemid,
                  num: item.buygiftlist[0].num
                    })
                    shopConfirmResult.buygiftorigoods.push({
                      itemid: item.origoodsId
                    })
              }
            }
          })
        }
        /**买赠 首次逻辑的写入 */
        if (
          (shopConfirmResult.isgiftpoponce == 1 && !shopConfirmResult.isbuygiftpoponce) ||
          isgobuygift != 1
        ) {
          this.buygiftrule.ruleList = ruleList
          shopConfirmResult.buygiftrule = this.buygiftrule
          this.buygiftlist = shopConfirmResult.buygiftlist
          this.buygiftlist_submit = shopConfirmResult.buygiftlist_submit
          this.buygiftorigoods = shopConfirmResult.buygiftorigoods
        }
        if (isgobuygift == 1) {
          /**买赠 首次逻辑的写入 */
          /**弹窗优先级 满赠活动开启未弹先弹满赠，后弹买赠 只弹一次 */
          if (shopConfirmResult.isgiftpoponce == 1 && !shopConfirmResult.isbuygiftpoponce) {
            shopConfirmResult.isbuygiftpoponce = 1
            var func = () => {
              /**默认匹配 */
              shopConfirmResult.buygiftlist = []
              shopConfirmResult.buygiftlist_submit = []
              shopConfirmResult.buygiftorigoods = []
              ruleList.map((item) => {
                /**默认匹配 按库存顺延分配：第一个赠品库存不足时剩余自动分配给下一个赠品 */
                let remainnum = Number(item.buygiftnum)
                item.buygiftlist.map((giftitem) => {
                  giftitem.num = Math.min(remainnum, Number(giftitem.limitNum) || remainnum)
                  if (giftitem.num > 0) {
                    remainnum -= giftitem.num
                    giftitem.isbuygift = 1
                    if (item.buygiftlist.length > 1 && item.showChangeEntry == '1') giftitem.isgolist = 1
                    shopConfirmResult.buygiftlist.push(giftitem)
                    shopConfirmResult.buygiftlist_submit.push({
                      itemid: giftitem.itemid,
                      num: giftitem.num
                    })
                    shopConfirmResult.buygiftorigoods.push({
                      itemid: item.origoodsId
                    })
                  }
                })
                item.choosegiftnum = Number(item.buygiftnum) - remainnum
              })
              this.buygiftrule.ruleList = ruleList
              shopConfirmResult.buygiftrule = this.buygiftrule
              this.buygiftlist = shopConfirmResult.buygiftlist
              this.buygiftlist_submit = shopConfirmResult.buygiftlist_submit
              this.buygiftorigoods = shopConfirmResult.buygiftorigoods
              this.buygiftlist.map((item) => {
                if (item.num) this.buygiftnum += Number(item.num)
              })
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
            }
            if (isShowChangeDialog == 1) {
              /**存在允许更换赠品的规则 → 弹窗引导用户选择 */
              this.$dialog
                .confirm({
                  message: '恭喜您获得买赠机会，快去选择您想要的赠品吧',
                  className: 'collect_button_alert',
                  cancelButtonColor: '#FC0324',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '去选择',
                  cancelButtonText: '取消',
                  closeOnPopstate: true
                })
                .then(() => {
                  func()
                  this.$router.replace({
                    path: '/freegiftzone_buygift',
                    query: {
                      path: encryption(this.$route.fullPath)
                    }
                  })
                })
                .catch(() => {
                  func()
                })
            } else {
              /**所有规则均不允许更换赠品 → 不弹窗，直接按默认分配 */
              func()
            }
          } else {
            this.buygiftlist = shopConfirmResult.buygiftlist
            var func = (list) => {
              let tempObj = {}
              list.map((item, index) => {
                let tempgiftitemid = [],
                  tempgiftnum = []
                item.buygiftlist.map((giftitem) => {
                  tempgiftitemid.push(giftitem.itemid)
                  tempgiftnum.push(giftitem.num)
                })
                tempObj[item.itemid] = {
                  buygiftnum: item.buygiftnum,
                  giftitemid: tempgiftitemid,
                  giftnum: tempgiftnum,
                  origoodsId: item.origoodsId,
                  index: index
                }
              })
              return tempObj
            }
            /************************************************************* */
            /**缓存 买赠规则数据 */
            let local_buygiftrulelist = func(shopConfirmResult.buygiftrule.ruleList)
            /**实时 买赠规则数据 */
            let buygiftrulelist = func(this.buygiftrule.ruleList)

            this.buygiftrule.ruleList.map((item) => {
              if (!local_buygiftrulelist.hasOwnProperty(item.itemid)) {
                shopConfirmResult.buygiftrule.ruleList.push(item)
              }
            })
            local_buygiftrulelist = func(shopConfirmResult.buygiftrule.ruleList)

            shopConfirmResult.buygiftrule.ruleList = shopConfirmResult.buygiftrule.ruleList.filter(
              (item) => buygiftrulelist.hasOwnProperty(item.itemid)
            )
            local_buygiftrulelist = func(shopConfirmResult.buygiftrule.ruleList)

            /**同步实时赠品库存 limitNum 至缓存规则，缓存所选数量超实时库存时按库存截断 */
            this.buygiftrule.ruleList.map((realitem) => {
              shopConfirmResult.buygiftrule.ruleList.map((item) => {
                if (item.itemid == realitem.itemid) {
                  let choosegiftnum = 0
                  item.buygiftlist.map((giftitem) => {
                    realitem.buygiftlist.map((realgift) => {
                      if (realgift.itemid == giftitem.itemid) {
                        giftitem.limitNum = realgift.limitNum
                        if (
                          giftitem.limitNum &&
                          giftitem.num &&
                          giftitem.num > Number(giftitem.limitNum)
                        ) {
                          giftitem.num = Number(giftitem.limitNum)
                          shopConfirmResult.buygiftlist_submit.map((submititem) => {
                            if (submititem.itemid == giftitem.itemid) {
                              submititem.num = giftitem.num
                            }
                          })
                        }
                      }
                    })
                    choosegiftnum += Number(giftitem.num || 0)
                  })
                  item.choosegiftnum = choosegiftnum
                }
              })
            })

            shopConfirmResult.buygiftlist = shopConfirmResult.buygiftlist.filter((item) => {
              for (let key in local_buygiftrulelist) {
                if (local_buygiftrulelist[key].giftitemid.indexOf(item.itemid) >= 0) {
                  return item
                }
              }
            })
            shopConfirmResult.buygiftlist_submit = shopConfirmResult.buygiftlist_submit.filter(
              (item) => {
                for (let key in local_buygiftrulelist) {
                  if (local_buygiftrulelist[key].giftitemid.indexOf(item.itemid) >= 0) {
                    return item
                  }
                }
              }
            )
            shopConfirmResult.buygiftorigoods = shopConfirmResult.buygiftorigoods.filter((item) => {
              for (let key in local_buygiftrulelist) {
                if (local_buygiftrulelist[key].origoodsId == item.itemid) {
                  return item
                }
              }
            })
            shopConfirmResult.buygiftrule.ruleList.map((item) => {
              if (
                /**无选择总数时，说明giftitem.num数量均为0，默认取第一个赠品进行数量递增 */
                !item.choosegiftnum
              ) {
                /**默认匹配 按库存顺延分配：第一个赠品库存不足时剩余自动分配给下一个赠品 */
                let remainnum = Number(item.buygiftnum)
                item.buygiftlist.map((giftitem) => {
                  giftitem.num = Math.min(remainnum, Number(giftitem.limitNum) || remainnum)
                  if (giftitem.num > 0) {
                    remainnum -= giftitem.num
                    giftitem.isbuygift = 1
                    if (item.buygiftlist.length > 1 && giftitem.showChangeEntry == '1') giftitem.isgolist = 1
                    shopConfirmResult.buygiftlist.push(giftitem)
                    shopConfirmResult.buygiftlist_submit.push({
                      itemid: giftitem.itemid,
                      num: giftitem.num
                    })
                    shopConfirmResult.buygiftorigoods.push({
                      itemid: item.origoodsId
                    })
                  }
                })
                item.choosegiftnum = Number(item.buygiftnum) - remainnum
              } else {
                /**反之 判断实时赠品数量是否与缓存赠品数量一致，不一致则遍历赠品逐个递减赠品数量 */
                if (item.buygiftnum != buygiftrulelist[item.itemid].buygiftnum) {
                  /**tempbuygiftnum 为正：正品数量增；为负：正品数量减 */
                  let balance = buygiftrulelist[item.itemid].buygiftnum - item.buygiftnum
                  item.choosegiftnum = Number(buygiftrulelist[item.itemid].buygiftnum)
                  item.buygiftnum = buygiftrulelist[item.itemid].buygiftnum
                  let templist = item.buygiftlist
                  for (let i = templist.length - 1; i >= 0; i--) {
                    if (templist[i].num && templist[i].num > 0) {
                      templist[i].num = templist[i].num + balance
                      if (templist[i].num < 0) {
                        balance = templist[i].num
                        templist[i].num = 0
                      } else if (
                        templist[i].limitNum &&
                        templist[i].num > Number(templist[i].limitNum)
                      ) {
                        /**增量超过赠品库存时截断，剩余数量继续分配给前一个赠品 */
                        balance = templist[i].num - Number(templist[i].limitNum)
                        templist[i].num = Number(templist[i].limitNum)
                      } else {
                        balance = 0
                      }
                    }
                  }
                  item.buygiftlist = templist
                  /**按库存截断后重算已选总数，避免 choosegiftnum 失真导致买赠页无法补选 */
                  item.choosegiftnum = 0
                  templist.map((tempitem) => {
                    item.choosegiftnum += Number(tempitem.num || 0)
                  })
                  templist.map((tempitem) => {
                    shopConfirmResult.buygiftlist.map((giftitem) => {
                      if (tempitem.itemid == giftitem.itemid) {
                        giftitem.num = tempitem.num
                      }
                    })
                    shopConfirmResult.buygiftlist_submit.map((giftitem) => {
                      if (tempitem.itemid == giftitem.itemid) {
                        giftitem.num = tempitem.num
                      }
                    })
                  })
                }
                shopConfirmResult.buygiftlist = shopConfirmResult.buygiftlist.filter(
                  (item) => item.num && item.num > 0
                )
                /**同步过滤正品集合，避免下标错位 */
                let temporigoods = []
                shopConfirmResult.buygiftlist_submit = shopConfirmResult.buygiftlist_submit.filter(
                  (item, index) => {
                    if (item.num && item.num > 0) {
                      temporigoods.push(shopConfirmResult.buygiftorigoods[index])
                      return true
                    }
                    return false
                  }
                )
                shopConfirmResult.buygiftorigoods = temporigoods
              }
            })
            this.buygiftlist = shopConfirmResult.buygiftlist
            this.buygiftlist_submit = shopConfirmResult.buygiftlist_submit
            this.buygiftorigoods = shopConfirmResult.buygiftorigoods
            /************************************************************* */
          }
        }

        this.buygiftlist.map((item) => {
          if (item.num) this.buygiftnum += Number(item.num)
        })
      }
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
    },
    /**积分预埋开始 */
    getjifen: function () {
      var that = this
      that.integerlist = []
      that.nouseIntegerlist = []
      var totalprice, choose, coupon
      if (sessionStorage.getItem('choose_integral')) {
        choose = JSON.parse(sessionStorage.getItem('choose_integral'))
        if (sessionStorage.getItem('choose_coupon') && that.couponChecked) {
          coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
          totalprice = that.totalPrice(that.totalmoney, 0, coupon.price)
        } else {
          totalprice = that.totalPrice(that.totalmoney, 0)
        }
      } else {
        if (sessionStorage.getItem('choose_coupon') && that.couponChecked) {
          coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
          totalprice = that.totalPrice(that.totalmoney, 0, coupon.price)
        } else {
          totalprice = that.totalmoney
        }
      }
      if (that.integerAllList.length > 0) {
        /**积分规则修改 */
        that.integerlist = that.integerAllList
        that.nouseIntegerlist = []
        if (sessionStorage.getItem('choose_integral')) {
          that.radio = choose.radio
          that.moneyByIntegral = choose.integermoney
          that.useIntegral = choose.limitinteger
        } else {
          /**总积分和最高档次的积分数进行比较，小的话则将最低档次使用的积分数显示到界面，说明情况 */
          if (that.integerlist && that.integerlist.length > 0) {
            if (
              parseFloat(that.totalIntegral) >=
              parseFloat(that.integerlist[that.integerlist.length - 1].limitinteger)
            ) {
              that.useIntegral = that.integerlist[that.integerlist.length - 1].limitinteger
              that.moneyByIntegral = that.integerlist[that.integerlist.length - 1].integermoney
              that.radio = that.integerlist.length - 1
            }
          }
        }
      }
      this.totalMoney()
    },
    switchIntegralFn: function (checked, ismutex) {
      this.saveIntegral(checked, ismutex)
      this.checkProduct()
    },
    integralRule: function () {
      var rule = ''
      this.integralrule.map(function (item, index) {
        rule = rule + parseInt(index + 1) + '.' + item + '\r'
      })

      this.$dialog
        .alert({
          title: '金币使用规则',
          message: rule,
          className: 'percen_button_alert integral_button_alert',
          confirmButtonColor: '#FFFCFC',
          confirmButtonText: '我知道了',
          closeOnPopstate: false
        })
        .then(function () {})
    },
    saveIntegral: function (check, ismutex) {
      var integralObj = {}
      if (check && this.radio != null) {
        this.moneyByIntegral = this.integerlist[this.radio].integermoney
        this.useIntegral = this.integerlist[this.radio].limitinteger
        integralObj = {
          checked: check,
          radio: this.radio,
          limitinteger: this.integerlist[this.radio].limitinteger,
          integermoney: this.integerlist[this.radio].integermoney
        }
        sessionStorage.setItem('choose_integral', JSON.stringify(integralObj))
      } else if (!check && this.radio != null) {
        sessionStorage.removeItem('choose_integral')
      }
      var choose_coupon = sessionStorage.getItem('choose_coupon')
        ? JSON.parse(sessionStorage.getItem('choose_coupon'))
        : {}
      this.isUseBigCoupon = choose_coupon && choose_coupon.coupontype == 3 ? 1 : 0
      if (this.useintegralFromDiscountcoupon == 0 && ismutex != 0 && this.discountCouponChecked) {
        this.discountCouponChecked = false
        this.discountCouponFn(0)
      } else if (
        this.isUseBigCoupon == 0 &&
        this.ispreferentialmutex == 1 &&
        ismutex != 0 &&
        this.couponChecked
      ) {
        this.couponChecked = false
        this.couponFn(0)
      } else {
        this.totalMoney()
        this.exchangeRuleItemids()
        this.getjifen()
        this.loadcoupons()
      }
    },
    /**满赠活动 */
    giftAct: function () {
      if (
        this.fullgift &&
        JSON.stringify(this.fullgift) != '{}' &&
        this.fullgift.list &&
        this.fullgift.list.length
      ) {
        if (this.fullgiftrulenew && this.fullgiftrulenew.length) {
          this.giftruleCalculate()
        }
        if (this.isgiftpop == 1) {
          this.giftpopup()
        } else {
          var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
          shopConfirmResult.isgiftpoponce = 1
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
        }
      } else {
        var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
        shopConfirmResult.isgiftpoponce = 1
        localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      }
    },
    giftpopup: function () {
      var that = this
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (this.fullgift.actpopdesc) {
        if (!shopConfirmResult.isgiftpoponce) {
          shopConfirmResult.isgiftpoponce = 1
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
          this.$dialog
            .confirm({
              message: '恭喜您获得满赠机会，快去选择您想要的赠品吧',
              className: 'collect_button_alert',
              cancelButtonColor: '#FC0324',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去选择',
              cancelButtonText: '取消',
              closeOnPopstate: true
            })
            .then(function () {
              shopConfirmResult.isbuygiftpoponce = 1
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              that.$router.replace({
                path: '/freeGiftZone',
                query: {
                  path: encryption(that.$route.fullPath)
                }
              })
            })
            .catch(function () {
              shopConfirmResult.isbuygiftpoponce = 1
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
              that.getBuygiftRule() /**买赠活动 */
            })
        } else {
          var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
          shopConfirmResult.isbuygiftpoponce = 1
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
        }
      }
    },
    /**满赠活动计算匹配 */
    giftruleCalculate: function () {
      var that = this
      var ischoose = 0
      that.giftmoney = 0
      that.isgiftpop = 0
      that.giftactid = ''
      that.addgiftid = ''
      that.giftitem = ''
      that.giftnum = 0
      that.addgiftnum = 0
      if (that.listtemp) that.list = JSON.parse(that.listtemp)
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      var list = that.fullgift.list ? that.fullgift.list : []

      that.fullGiftMoneyFn('giftruleCalculate')
      for (var i = list.length - 1; i >= 0; i--) {
        /**总金额是否满足当前满赠档位 */
        if (
          parseFloat(list[i].allmoney) <= that.currentfullgiftmoney) {
          var itemlist = list[i].giftlist,
            addgiftnum = 0,
            addgiftlist = list[i].addgiftlist || []
          var additemlist = addgiftlist.map((item) => {
            addgiftnum += parseInt(item.num || 0)
            item.isgiftproduct = 1
            return item
          })
          if (shopConfirmResult.gift_list && JSON.parse(shopConfirmResult.gift_list)) {
            var giftlist = JSON.parse(shopConfirmResult.gift_list)[0]
            if (giftlist.giftid != list[i].giftid) {
              shopConfirmResult.gift_choose_skuid = ''
            }
          }
          shopConfirmResult.gift_list = JSON.stringify([list[i]])
          for (var j = 0; j < itemlist.length; j++) {
            /**判断是否有选中的skuid */
            if (!shopConfirmResult.gift_choose_skuid) {
              if (itemlist[j].ischoose == 1) {
                ischoose = 1
                shopConfirmResult.gift_choose_skuid = itemlist[j].skuid
                itemlist[j].isgiftproduct = 1
                itemlist[j].gift_act_name = that.fullgift.actdesc
                if (itemlist.length > 1) {
                  itemlist[j].isgolist = 1
                } else {
                  itemlist[j].isgolist = 0
                }
                that.giftmoney = that.giftmoney + itemlist[j].price * itemlist[j].num
                that.giftactid = list[i].giftid
                that.addgiftid = list[i].addgiftid
                that.giftitem = itemlist[j].skuid
                that.giftnum = parseInt(itemlist[j].num)
                that.addgiftnum = addgiftnum
                that.list.push(itemlist[j])
                if (additemlist.length) that.list = [...that.list, ...additemlist]
                if (itemlist.length > 1) {
                  that.isgiftpop = 1
                }
                break
              }
            } else {
              if (
                shopConfirmResult.gift_choose_skuid == itemlist[j].skuid &&
                itemlist[j].ischoose == 1
              ) {
                ischoose = 1
                itemlist[j].isgiftproduct = 1
                itemlist[j].gift_act_name = that.fullgift.actdesc
                if (itemlist.length > 1) {
                  itemlist[j].isgolist = 1
                } else {
                  itemlist[j].isgolist = 0
                }
                that.giftmoney = that.giftmoney + itemlist[j].price * itemlist[j].num
                that.giftactid = list[i].giftid
                that.addgiftid = list[i].addgiftid
                that.giftitem = itemlist[j].skuid
                that.giftnum = parseInt(itemlist[j].num)
                that.addgiftnum = addgiftnum
                that.list.push(itemlist[j])
                if (additemlist.length) that.list = [...that.list, ...additemlist]
                if (itemlist.length > 1) {
                  that.isgiftpop = 1
                }
                break
              }
            }
          }
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
          break
        } else {
          ischoose = 0
          if (shopConfirmResult.hasOwnProperty('gift_list')) {
            delete shopConfirmResult['gift_list']
          }
          if (shopConfirmResult.hasOwnProperty('gift_choose_skuid')) {
            delete shopConfirmResult['gift_choose_skuid']
          }
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
        }
        if (ischoose == 1) {
          break
        }
      }
      if (ischoose != 1) {
        var index = null
        that.list.map(function (item, i) {
          if (item.isgiftproduct == 1) {
            index = i
          }
        })
        if (index != null) {
          that.list.splice(index, 1)
          that.totalmoney = that.totalmoney - that.giftmoney
          that.totalprice = that.totalmoney
          that.giftmoney = 0
        }
        that.totalnum = 0
        that.totalnumshow = 0
        that.birthdaygifttotalnum = 0
        that.allItemids = []
        that.list.map(function (item) {
          if (item.isgift != 1) {
            that.allItemIdsFunc({ item })
          }
          that.totalnum =
            that.totalnum + parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
          if (item.isintellrecommend != 1) {
            that.totalnumshow =
              that.totalnumshow + parseInt(item.num && parseInt(item.num) >= 0 ? item.num : 1)
          }
          if (item.isbirthdaygift == 1) {
            that.birthdaygifttotalnum += parseInt(
              item.num && parseInt(item.num) >= 0 ? item.num : 1
            )
          }
        })
        that.exchangeRuleItemids()
        if (that.allItemids.length) {
          that.fullminusdiscountFn()
        }
      }
      that.zoneFullgiftFn()
    },
    /**专区满赠：按专区 sku 实付匹配最高档，赠品插入商品列表 */
    zoneFullgiftFn: function () {
      var that = this
      that.zonegiftnum = 0
      this.couponsdiscountPrice()
      this.integraldiscountPrice()
      if (!that.zonefullgift || !that.zonefullgift.length) return
      that.zonefullgift.forEach(function (zone) {
        var sku_map = {}
        String(zone.skuids || '')
          .split(',')
          .forEach(function (id) {
            if (String(id).trim() !== '') sku_map[String(id).trim()] = 1
          })
        if (!Object.keys(sku_map).length) return
        var money = 0
        var hit = 0
        that.allItemids.forEach(function (item) {
          if (!sku_map[String(item.id)]) return
          hit = 1
          var itemprice = parseFloat(item.price || 0) * parseFloat(item.num || 0)
          money +=
            itemprice -
            (parseFloat(item.birthdaydiscountmoney || 0) +
              parseFloat(item.couponsdiscountmoney || 0) +
              parseFloat(item.discountcouponmoney || 0) +
              parseFloat(item.fulldiscountmoney || 0) +
              parseFloat(item.fullminusmoney || 0) +
              parseFloat(item.moredismoney || 0) +
              (item.isdiscount == 1 ? itemprice * (1 - that.currentdiscountdata) : 0) +
              parseFloat(item.integraldiscountmoney || 0))
        })
        if (!hit) return
        var rulelist = zone.list || []
        for (var i = rulelist.length - 1; i >= 0; i--) {
          if (parseFloat(rulelist[i].allmoney) <= money) {
            ;(rulelist[i].giftlist || []).forEach(function (gift) {
              var copy = JSON.parse(JSON.stringify(gift))
              copy.iszonefullgift = 1
              copy.isgiftproduct = 1
              copy.gift_act_name = zone.actdesc
              that.zonegiftnum += parseInt(copy.num && parseInt(copy.num) >= 0 ? copy.num : 1)
              that.list.push(copy)
            })
            break
          }
        }
      })
    },
    /**产品劵显示 */
    checkProduct: function () {
      var that = this,
        choose_product_couponid = '',
        isremove = 0,
        money = 0
      this.productlist = []
      if (sessionStorage.getItem('choose_product')) {
        choose_product_couponid = JSON.parse(sessionStorage.getItem('choose_product')).id
      }
      this.couponsdiscountPrice()
      this.integraldiscountPrice()
      this.goodscouponrule.forEach((item) => {
        item.isChoose = false
        money = 0
        this.list.forEach((listItem) => {
          if (listItem.isgift != 1 && listItem.isgiftproduct != 1) {
            const idsitem = this.allItemids.find((ids) => ids.id == listItem.skuid)
            let itemdismoney = 0,
              isdiscount = 0
            if (idsitem) {
              itemdismoney =
                idsitem.moredismoney +
                idsitem.fullminusmoney +
                idsitem.fulldiscountmoney +
                idsitem.birthdaydiscountmoney +
                idsitem.discountcouponmoney +
                (idsitem.couponsdiscountmoney || 0)
              isdiscount = idsitem.isdiscount
            }

            let itemmoney = listItem.price * listItem.num
            if (
              (item.items == '' && item.notitems.split(',').indexOf(listItem.skuid) < 0) ||
              (item.notitems == '' && item.items.split(',').indexOf(listItem.skuid) >= 0)
            ) {
              money =
                money + (itemmoney - itemdismoney) * (isdiscount == 1 ? this.currentdiscount : 1)
            }
          }
        })
        /**活动折扣后的总订单金额-金币抵扣金额 >= 门槛金额 */
        /**金币抵扣金额 */
        const integralMoney =
          this.moneyByIntegral && this.integralChecked ? this.moneyByIntegral : 0
        if (money - integralMoney >= parseFloat(item.useprice)) {
          that.productlist.push(item)
        } else {
          if (choose_product_couponid == item.id && !isremove) {
            isremove = 1
          }
        }
      })
      sessionStorage.removeItem('choose_product')
      that.getProduct()
    },
    getProduct: function () {
      var that = this
      if (sessionStorage.getItem('choose_product')) {
        var chooseproduct = JSON.parse(sessionStorage.getItem('choose_product'))
        var index = null
        that.productgify = chooseproduct
        try {
          // that.totalnum = that.totalnum + [that.productgify.goodsinfo].length
        } catch (e) {}
        that.producttitle = JSON.parse(sessionStorage.getItem('choose_product')).name
        for (var i = 0; i < that.productlist.length; i++) {
          if (chooseproduct.id == that.productlist[i].id) {
            index = i
            break
          }
        }
        that.chooseProduct(index)
      } else {
        that.chooseProduct(0)
        that.comfrimProduct()
      }
      that.productcount = that.productlist.length > 0 ? that.productlist.length : 0
    },
    showProduct: function () {
      var that = this
      this.showproduct = true
      setTimeout(function () {
        that.productBtn = true
      }, 500)
    },
    closeProduct: function () {
      this.showproduct = false
      this.productBtn = false
    },
    chooseProduct: function (index) {
      var items = []
      var that = this
      that.productlist.forEach(function (item, i) {
        if (i === index) {
          if (item.isChoose) {
            item.isChoose = false
            that.productPrice = 0
            that.chooseProductIndex = null
          } else {
            item.isChoose = true
            that.chooseProductIndex = i
          }
        } else {
          item.isChoose = false
        }
        items.push(item)
      })
      that.productlist = items
    },
    showProductDesc: function (index) {
      var productShowList = []
      this.productlist.map(function (item, i) {
        if (index == i) {
          item.isShowDesc = !item.isShowDesc
        }
        productShowList.push(item)
      })
      this.productlist = productShowList
    },
    comfrimProduct: function () {
      this.showproduct = false
      var product = this.productlist[this.chooseProductIndex]
      if (product != undefined && product != '' && product != null) {
        sessionStorage.setItem('choose_product', JSON.stringify(product))
        this.productgify = product
        try {
          // this.totalnum = this.totalnum + [this.productgify.goodsinfo].length
          // this.totalnumshow = this.totalnumshow + [this.productgify.goodsinfo].length
        } catch (e) {}
        this.producttitle = product.name
      } else {
        sessionStorage.removeItem('choose_product')
        // this.totalnum = this.totalnum - (this.productgify ? [this.productgify.goodsinfo].length : 0)
        // this.totalnumshow =
        //   this.totalnumshow - (this.productgify ? [this.productgify.goodsinfo].length : 0)
        this.productgify = null
        this.producttitle = ''
      }
    },
    /**现金券开关 */
    switchCouponFn: function (ismutex) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.init_coupon_data = 1
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.couponFn(ismutex)
    },
    couponFn: function (ismutex) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.couponChecked =
        this.couponChecked /**无选择的现金券时按钮开关状态需缓存至shopConfirmResult */
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      if (this.localCoupon) {
        this.localCoupon.checked = this.couponChecked
        if (this.couponChecked) {
          this.couponPrice = this.localCoupon.price
        } else {
          this.couponPrice = 0
        }
        sessionStorage.setItem('choose_coupon', JSON.stringify(this.localCoupon))
        this.usecouponFromDiscountcoupon = this.localCoupon.useforDiscoutCoupon == 1 ? 1 : 0
      }
      var choose_coupon = sessionStorage.getItem('choose_coupon')
        ? JSON.parse(sessionStorage.getItem('choose_coupon'))
        : {}
      this.isUseBigCoupon = choose_coupon && choose_coupon.coupontype == 3 ? 1 : 0
      if (this.usecouponFromDiscountcoupon == 0 && ismutex != 0 && this.discountCouponChecked) {
        this.discountCouponChecked = false
        this.discountCouponFn(0)
      } else if (
        this.isUseBigCoupon == 0 &&
        this.ispreferentialmutex == 1 &&
        ismutex != 0 &&
        this.integralChecked
      ) {
        this.integralChecked = false
        this.switchIntegralFn(this.integralChecked, 0)
      } else {
        this.totalMoney()
        this.exchangeRuleItemids()
        this.getjifen()
        this.loadcoupons()
      }
      this.checkProduct()
    },
    /**折扣券、现金券校验 */
    loadcouponsCheck({ couponItem, item, callback }) {
      /**rangetype
       * 0全场商品
       * --全场商品匹配券时
       * --如果可用券的品集合为空时，仅需判断不可用券的品集合中不包含该品
       * --如果可用券的品集合不为空时，先判断不可用券的品集合中不包含该品，再判断可用品包含该品（避免相同的品可用和不可用券都配置的情况）
       * 1指定商品
       * --指定商品匹配券时
       * --如果可用券的品集合不为空时，仅需判断可用券的品集合中包含该品
       * */
      if (
        (
          couponItem.rangetype == 1 && couponItem.items.split(',').indexOf(item.id) > -1
        ) ||
        (
          couponItem.rangetype == 0 &&
          (
            (
              couponItem.items == '' && couponItem.notitems.split(',').indexOf(item.id) <= -1
            ) ||
            (
              couponItem.items != '' && couponItem.notitems.split(',').indexOf(item.id) <= -1 &&
              couponItem.items.split(',').indexOf(item.id) > -1
            )
          )
        )
      ) {
        let discountPrice = 0
        if (item.isdiscount == 1 && this.currentdiscountdata > 0) {
          discountPrice += Number(item.price) * parseInt(item.num) * Number(this.currentdiscountdata)
        }
        if (
          (
            couponItem.coupontype == 3 ||
            (
              (
                item.ismorediscounts != 1 ||
                item.moredismoney <= 0 ||
                (
                  item.ismorediscounts == 1 && item.couponsenable == 1
                )
              ) &&
              (
                item.isFullDiscount != 1 ||
                (
                  item.isFullDiscount == 1 &&
                  (
                    item.fullDiscountRuleId &&
                    (
                      item.fulldiscountmoney <= 0 || this.fullDiscountRule.ruleObj[item.fullDiscountRuleId].couponenable == 1
                    )
                  )
                )
              ) &&
              (
                item.fullminusmoney <= 0 ||
                (
                  this.fullMinusRules.actStatus == 1 && this.fullMinusRules.fullMinusCouponEnable == 1
                )
              ) &&
              (
                this.discountrule.couponsenable == 1 || discountPrice <= 0
              ) &&
              (
                (
                  couponItem.useforDiscoutCoupon == 1 && this.discountCouponChecked
                ) ||
                !this.discountCouponChecked
              ) &&
              (
                (
                  this.ispreferentialmutex != 1 && this.integralChecked
                ) ||
                !this.integralChecked
              )
            )
          )
        ) {
          if (typeof callback == 'function') callback()
        }
      }
    },
    /**匹配券-实付金额
     * @param {*} init 1: 虚拟活动匹配的可用券列表-用于匹配折扣券+优惠券与活动+优惠券之间的对比
     */
    loadcouponpaymoneyCheck({ init = 0 } = {}) {
      var money = 0,
        integral
      if (sessionStorage.getItem('choose_integral')) {
        integral = JSON.parse(sessionStorage.getItem('choose_integral'))
      }
      /**销售品集合遍历 */
      for (let j = 0; j < this.allItemids.length; j++) {
        /**销售单品分摊的活动折扣金额 */
        let itemdismoney =
          this.allItemids[j][(init == 1 ? 'initmoredismoney' : 'moredismoney')] +
          this.allItemids[j][(init == 1 ? 'initfullminusmoney' : 'fullminusmoney')] +
          this.allItemids[j][(init == 1 ? 'initfulldiscountmoney' : 'fulldiscountmoney')] +
          this.allItemids[j].birthdaydiscountmoney
        /**销售单品销售价*数量 */
        let itemmoney = this.allItemids[j].price * this.allItemids[j].num
        /**销售品参与活动折扣分摊金额减掉之后的商品金额 */
        for(let k = 0; k < this.usecouponlist.length; k++) {
          this.loadcouponsCheck({
            couponItem: this.usecouponlist[k],
            item: this.allItemids[j],
            callback: () => {
              money =
                money +
                (itemmoney - itemdismoney) * (this.allItemids[j].isdiscount == 1 ? this.currentdiscount : 1)
            }
          })
        }
      }
      /**金币开关开启时，总金额减金币抵扣金额 */
      if (integral && integral.checked == true) {
        money = money - parseFloat(integral.integermoney)
      }
      return money + parseFloat(this.freight)
    },
    /**券排序
     * @param {*} init 1: 虚拟活动匹配的可用券列表-用于匹配折扣券+优惠券与活动+优惠券之间的对比
     */
    xierSort: function (arr, { init = 0 } = {}) {
      var money = parseFloat((this.loadcouponpaymoneyCheck({ init }) || 0).toFixed(2))
      // 筛选出coupontype = 3的数组
      var type3Arr = arr.filter((item) => item.coupontype == 3)
      // 筛选出coupontype != 3的数组
      var otherTypeArr = [],
        useforDiscoutCouponArr = []
      if (this.usediscountcouponlist.length) {
        useforDiscoutCouponArr = arr.filter(
          (item) => item.useforDiscoutCoupon == 1 && item.coupontype != 3
        )
        otherTypeArr = arr.filter((item) => item.useforDiscoutCoupon != 1 && item.coupontype != 3)
      } else {
        otherTypeArr = arr.filter((item) => item.coupontype != 3)
      }

      // 对type3Arr中price >= money的部分按price从小到大排序
      var part1 = type3Arr
        .filter((item) => parseFloat(item.price) >= money)
        .sort((a, b) => parseFloat(a.price) - parseFloat(b.price))
      // 对type3Arr中price < money的部分按price从大到小排序
      var part2 = type3Arr
        .filter((item) => parseFloat(item.price) < money)
        .sort((a, b) => parseFloat(b.price) - parseFloat(a.price))

      // 同金额时 fullgiftrule.couponids 内的券优先
      var giftCouponIdSet = null
      if (this.fullgiftrule && this.fullgiftrule.couponids) {
        giftCouponIdSet = {}
        this.fullgiftrule.couponids.split(',').forEach(function (cid) {
          var t = String(cid).trim()
          if (t) giftCouponIdSet[t] = true
        })
      }
      var inGiftCouponIds = function (item) {
        if (!giftCouponIdSet) return false
        if (
          item.couponid != null &&
          item.couponid !== '' &&
          giftCouponIdSet[String(item.couponid).trim()]
        )
          return true
        if (item.id != null && item.id !== '' && giftCouponIdSet[String(item.id).trim()])
          return true
        return false
      }
      // useforDiscoutCouponArr < money的部分按price从大到小排序
      var part4 = useforDiscoutCouponArr
        .filter((item) => parseFloat(item.price) < money)
        .sort((a, b) => {
          var diff = parseFloat(b.price) - parseFloat(a.price)
          if (diff !== 0) return diff
          var aIn = inGiftCouponIds(a)
          var bIn = inGiftCouponIds(b)
          if (aIn === bIn) return 0
          return aIn ? -1 : 1
        })

      // 对otherTypeArr中price < money的部分按price从大到小排序；同金额时 fullgiftrule.couponids 内的券优先
      var part3 = otherTypeArr
        .filter((item) => parseFloat(item.price) < money)
        .sort((a, b) => {
          var diff = parseFloat(b.price) - parseFloat(a.price)
          if (diff !== 0) return diff
          var aIn = inGiftCouponIds(a)
          var bIn = inGiftCouponIds(b)
          if (aIn === bIn) return 0
          return aIn ? -1 : 1
        })

      // 合并排序后的数组
      return part1
        .concat(part2)
        .concat(part4)
        .concat(part3)
        .concat(otherTypeArr.filter((item) => parseFloat(item.price) >= money))
    },
    loadcoupons() {
      this.$watch(
        'isFreight',
        (newVal) => {
          if (newVal === 1) {
            /**
             * usecouponlist_act_vs 虚拟活动匹配的可用券列表-用于匹配折扣券+优惠券与活动+优惠券之间的对比
             * usecouponlist_discount_vs 虚拟折扣券匹配的可用券列表-用于匹配折扣券+优惠券与活动+优惠券之间的对比
             * */
            let chooseCoupon,
              integral,
              usecouponlist_act_vs = [],
              usecouponlist_discount_vs = []
            this.usecouponlist = []
            this.nousercouponlist = []
            if (sessionStorage.getItem('choose_coupon') && this.couponChecked) {
              chooseCoupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
            }
            if (sessionStorage.getItem('choose_integral')) {
              integral = JSON.parse(sessionStorage.getItem('choose_integral'))
            }
            // /**折上折活动开启并且券开关关闭（针对全场）时，金额清零，不匹配券（不用考虑不参与折上折品是否可用券的情况） */
            // if (
            //   this.discountrule.discountenable == 1 &&
            //   (
            //     (
            //       chooseCoupon && chooseCoupon.coupontype == 3 && this.couponChecked
            //     ) ||
            //     this.discountrule.couponsenable == 0
            //   )
            // ) {
            //   this.couponlist = []
            // }
            /**当获取的优惠券列表存在，进行逻辑处理 */
            if (this.couponlist.length > 0) {
              /**进行所有优惠券的循环遍历筛选 */
              for (let i = 0; i < this.couponlist.length; i++) {
                let hascount = 0 /**是否存在购买商品 */
                let money = 0 /**商品总金额 */
                let money_act_vs = 0 /**商品总金额·活动-用于匹配折扣券+优惠券与活动+优惠券之间的对比 */
                let money_discount_vs = 0 /**商品总金额·折扣券-用于匹配折扣券+优惠券与活动+优惠券之间的对比 */
                /**销售品集合遍历 */
                for (let j = 0; j < this.allItemids.length; j++) {
                  /**销售单品分摊的活动折扣金额 */
                  let itemdismoney =
                    this.allItemids[j].moredismoney +
                    this.allItemids[j].fullminusmoney +
                    this.allItemids[j].fulldiscountmoney +
                    this.allItemids[j].birthdaydiscountmoney +
                    (this.usecouponFromDiscountcoupon == 1
                      ? this.allItemids[j].discountcouponmoney
                      : 0)
                  /**销售单品分摊的活动折扣金额·活动-用于匹配折扣券+优惠券与活动+优惠券之间的对比 */
                  let itemdismoney_act_vs =
                    this.allItemids[j].initmoredismoney +
                    this.allItemids[j].initfullminusmoney +
                    this.allItemids[j].initfulldiscountmoney +
                    this.allItemids[j].birthdaydiscountmoney
                  /**销售单品销售价*数量 */
                  let itemmoney = this.allItemids[j].price * this.allItemids[j].num
                  /**循环遍历，在优惠券指定的一组商品中查找购买的商品id是否符合要求 */
                  this.loadcouponsCheck({
                    couponItem: this.couponlist[i],
                    item: this.allItemids[j],
                    callback: () => {
                      /**存在购买商品 */
                      hascount++
                      /**销售品参与活动折扣分摊金额减掉之后的商品金额 */
                      money =
                        money +
                        (itemmoney - itemdismoney) *
                          (this.allItemids[j].isdiscount == 1 ? this.currentdiscount : 1)
                      /**销售品参与活动折扣分摊金额减掉之后的商品金额·活动-用于匹配折扣券+优惠券与活动+优惠券之间的对比 */
                      money_act_vs =
                        money_act_vs +
                        (itemmoney - itemdismoney_act_vs) *
                          (this.allItemids[j].isdiscount == 1 ? this.currentdiscount : 1)
                    }
                  })
                }
                /**销售品·所有品-集合遍历 */
                for (let j = 0; j < this.allItemids.length; j++) {
                  /**销售单品分摊的活动折扣金额·折扣券-用于匹配折扣券+优惠券与活动+优惠券之间的对比 */
                  let itemdismoney_discount_vs =
                    this.allItemids[j].initdiscountcouponmoney +
                    this.allItemids[j].birthdaydiscountmoney

                  /**销售单品销售价*数量 */
                  let itemmoney = this.allItemids[j].price * this.allItemids[j].num
                  /**循环遍历，在优惠券指定的一组商品中查找购买的商品id是否符合要求 */
                  this.loadcouponsCheck({
                    couponItem: this.couponlist[i],
                    item: this.allItemids[j],
                    callback: () => {
                      /**存在购买商品 */
                      hascount++
                      /**销售品参与活动折扣分摊金额减掉之后的商品金额·折扣券-用于匹配折扣券+优惠券与活动+优惠券之间的对比 */
                      money_discount_vs =
                        money_discount_vs +
                        (itemmoney - itemdismoney_discount_vs) *
                          (this.allItemids[j].isdiscount == 1 ? this.currentdiscount : 1)
                    }
                  })
                }
                /**金币开关开启时，总金额减金币抵扣金额 */
                if (integral && integral.checked == true) {
                  money = money - parseFloat(integral.integermoney)
                  money_act_vs = money_act_vs - parseFloat(integral.integermoney)
                  money_discount_vs = money_discount_vs - parseFloat(integral.integermoney)
                }
                /**coupontype
                 * 1现金券
                 * 2满减券
                 * 3大额现金券（实付金额抵扣，列表排序在最前列）
                 *
                 * 1、2可用券的条件：
                 * --1.门槛金额不设置时，无需对比
                 * --2.门槛金额设置时，门槛金额小于等于可参与品减折扣后的总金额
                 * --3.可参与品减折扣后的总金额*券折扣比例 > 券折扣金额（与条件1||2关系并列）
                 * 3可用券的条件：
                 * --1.直接抵扣实付金额，无金额门槛，实付金额<=抵扣金额,实付金额为0
                 * --2.直接抵扣实付金额，无金额门槛，实付金额>抵扣金额,实付金额补差额
                 * */
                if (
                  (parseFloat(money) >= parseFloat(this.couponlist[i].fullprice) &&
                    money * this.couponlist[i].couponuserate >= this.couponlist[i].price) ||
                  (hascount > 0 && this.couponlist[i].coupontype == 3)
                ) {
                  /**符合使用条件 */
                  this.usecouponlist.push(this.couponlist[i])
                } else {
                  /**不符合使用条件 */
                  this.nousercouponlist.push(this.couponlist[i])
                }

                if (
                  (parseFloat(money_act_vs) >= parseFloat(this.couponlist[i].fullprice) &&
                    money_act_vs * this.couponlist[i].couponuserate >= this.couponlist[i].price) ||
                  (hascount > 0 && this.couponlist[i].coupontype == 3)
                ) {
                  /**符合使用条件 */
                  usecouponlist_act_vs.push(this.couponlist[i])
                }

                if (
                  (parseFloat(money_discount_vs) >= parseFloat(this.couponlist[i].fullprice) &&
                    money_discount_vs * this.couponlist[i].couponuserate >=
                      this.couponlist[i].price) ||
                  (hascount > 0 && this.couponlist[i].coupontype == 3)
                ) {
                  /**符合使用条件 */
                  usecouponlist_discount_vs.push(this.couponlist[i])
                }
              }
            }
            if (this.iszg != 1 && this.yl != 1 && this.ms != 1 && this.ylact != 1) {
              this.usablecount = this.usecouponlist.length >= 0 ? this.usecouponlist.length : 0
              /**可用现金券排序 */
              if (this.usecouponlist.length >= 1) {
                this.usecouponlist = this.xierSort(this.usecouponlist)
              }
              if (usecouponlist_act_vs.length) {
                if (usecouponlist_act_vs.length >= 1)
                  usecouponlist_act_vs = this.xierSort(usecouponlist_act_vs)
                this.choose_coupon_act_vs = usecouponlist_act_vs[0]
              }
              if (usecouponlist_discount_vs.length) {
                if (usecouponlist_discount_vs.length >= 1)
                  usecouponlist_discount_vs = this.xierSort(usecouponlist_discount_vs)
                this.choose_coupon_discount_vs = usecouponlist_discount_vs[0]
              }
              this.couponCheckedHandle()
            } else {
              this.usablecount = this.usecouponlist.length >= 0 ? this.usecouponlist.length : 0
            }
            this.totalMoney()
          }
        },
        { immediate: true }
      )
    },
    couponCheckedHandle: function () {
      let chooseCoupon
      if (sessionStorage.getItem('choose_coupon') && this.couponChecked) {
        chooseCoupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
      }
      let shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (this.iszg != 1 && this.yl != 1 && this.ms != 1 && this.ylact != 1) {
        this.usecouponlist.map((item) => {
          if (chooseCoupon) {
            if (item.couponid == chooseCoupon.couponid) {
              item.isChoose = true
            } else {
              item.isChoose = false
            }
          } else {
            item.isChoose = false
          }
          item.isShowDesc = false
        })
        this.nousercouponlist.forEach((item) => {
          item.isChoose = false
          item.isShowDesc = false
          if (sessionStorage.getItem('choose_coupon')) {
            let coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
            if (coupon.couponid == item.couponid) {
              this.couponstitle = ''
              this.couponsmoney = 0
              this.localCoupon = null
              sessionStorage.removeItem('choose_coupon')
              shopConfirmResult.init_coupon_data = 0
              localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
            }
          }
        })
        var choose_coupon = sessionStorage.getItem('choose_coupon')
          ? JSON.parse(sessionStorage.getItem('choose_coupon'))
          : {}
        this.isUseBigCoupon = choose_coupon && choose_coupon.coupontype == 3 ? 1 : 0
        if (
          this.usecouponFromDiscountcoupon == 0 &&
          shopConfirmResult.init_coupon_data == 1 &&
          this.discountCouponChecked
        ) {
          if (this.couponChecked) {
            this.discountCouponChecked = false
            this.discountCouponFn(0)
          }
          return
        } else if (
          this.isUseBigCoupon == 0 &&
          this.ispreferentialmutex == 1 &&
          this.integralChecked
        ) {
          if (this.couponChecked) {
            this.integralChecked = false
            this.switchIntegralFn(this.integralChecked, 0)
          }
          return
        }
        if (!shopConfirmResult.init_coupon_data) {
          sessionStorage.removeItem('choose_coupon')
        }
        if (
          !sessionStorage.getItem('choose_coupon') &&
          this.usecouponlist.length &&
          !shopConfirmResult.init_coupon_data
        ) {
          if (this.usecouponlist[0].isChoose) {
            this.usecouponlist[0].isChoose = false
            this.couponPrice = 0
            this.chooseUseCouponIndex = null
          } else {
            this.usecouponlist[0].isChoose = true
            this.couponPrice = parseFloat(this.usecouponlist[0].price).toFixed(2)
            this.chooseUseCouponIndex = 0
          }

          this.localCoupon = this.usecouponlist[0]
          if (
            this.usecouponFromDiscountcoupon == 1 ||
            (this.usecouponFromDiscountcoupon == 0 && !this.discountCouponChecked) ||
            !this.discountCouponChecked
          ) {
            this.couponChecked = true
          }
          this.localCoupon.checked = this.couponChecked
          sessionStorage.setItem('choose_coupon', JSON.stringify(this.usecouponlist[0]))
          this.usecouponFromDiscountcoupon = this.usecouponlist[0].useforDiscoutCoupon == 1 ? 1 : 0
        } else {
          var coupontemp =
            sessionStorage.getItem('choose_coupon') && this.couponChecked
              ? JSON.parse(sessionStorage.getItem('choose_coupon'))
              : null
          if (coupontemp != null) {
            this.couponPrice = parseFloat(coupontemp.price).toFixed(2)
          } else if (this.usecouponlist.length > 0 && !shopConfirmResult.init_coupon_data) {
            sessionStorage.setItem('choose_coupon', JSON.stringify(this.usecouponlist[0]))
            this.usecouponFromDiscountcoupon =
              this.usecouponlist[0].useforDiscoutCoupon == 1 ? 1 : 0
            this.usecouponlist[0].isChoose = true
            this.couponPrice = parseFloat(this.usecouponlist[0].price).toFixed(2)
            this.chooseUseCouponIndex = 0
            this.couponstitle = this.usecouponlist[0].couponname
            this.couponsmoney = parseFloat(this.usecouponlist[0].price)
          }
        }
        let choose_coupon = JSON.parse(sessionStorage.getItem('choose_coupon') || '{}')
        if (choose_coupon.couponid) {
          this.chooseUseCouponIndex = this.usecouponlist.findIndex(item => item.couponid === choose_coupon.couponid)
        } else {
          this.chooseUseCouponIndex = null
        }
      }
    },
    showCoupon: function () {
      if (!this.couponChecked) return
      var that = this
      if (
        (this.usecouponlist && this.usecouponlist.length > 0) ||
        (this.nousercouponlist && this.nousercouponlist.length > 0)
      ) {
        this.showcoupon = true
        var choose = sessionStorage.getItem('choose_coupon')
          ? JSON.parse(sessionStorage.getItem('choose_coupon'))
          : null
        if (choose) {
          that.usecouponlist.map(function (item) {
            if (choose) {
              if (item.couponid == choose.couponid) {
                item.isChoose = true
                that.couponPrice = choose.price
              } else {
                item.isChoose = false
              }
            } else {
              item.isChoose = false
            }
            item.isShowDesc = false
          })
        }
        setTimeout(function () {
          that.couponBtn = true
        }, 500)
      }
    },
    /**折扣券开关 */
    switchDiscountCouponFn: function (ismutex) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.init_discount_coupon_data = 1
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.discountCouponFn(ismutex)
    },
    discountCouponFn: function (ismutex) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.discountCouponChecked =
        this.discountCouponChecked /**无选择的现金券时按钮开关状态需缓存至shopConfirmResult */
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      if (this.localDiscountCoupon) {
        this.localDiscountCoupon.checked = this.discountCouponChecked
        if (this.discountCouponChecked) {
          this.discountcouponPrice = this.localDiscountCoupon.price
        } else {
          this.discountcouponPrice = 0
        }
        shopConfirmResult.choose_discount_coupon = this.localDiscountCoupon
        localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      }
      this.checkdiscountcouponsPKact()
      this.list.forEach((item) => {
        if (item.isgift != 1 && item.isgiftproduct != 1) {
          this.allItemIdsFunc({ item })
        }
      })
      if (
        ismutex != 0 &&
        ((this.useintegralFromDiscountcoupon == 0 && this.integralChecked) ||
          (this.usecouponFromDiscountcoupon == 0 && this.couponChecked))
      ) {
        if (this.usecouponFromDiscountcoupon == 0 && this.couponChecked) {
          this.couponChecked = false
          this.couponFn(0)
        }
        if (this.useintegralFromDiscountcoupon == 0 && this.integralChecked) {
          this.integralChecked = false
          this.switchIntegralFn(this.integralChecked, 0)
        }
      }
      this.count()
    },
    /**折扣券匹配 */
    loaddiscountcouponsCheck({ couponItem, item, success, error }) {
      if (
        (couponItem.items == '' &&
          couponItem.notitems.split(',').indexOf(item.id || item.skuid) <= -1) ||
        (couponItem.items != '' &&
          couponItem.notitems.split(',').indexOf(item.id || item.skuid) <= -1 &&
          couponItem.items.split(',').indexOf(item.id || item.skuid) > -1)
      ) {
        if (typeof success == 'function') success()
      } else {
        if (typeof error == 'function') error()
      }
    },
    loaddiscountcoupons() {
      this.usediscountcouponlist = []
      let shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      // /**折上折活动开启并且券开关关闭（针对全场）时，金额清零，不匹配券（不用考虑不参与折上折品是否可用券的情况） */
      // if (this.discountrule.discountenable == 1 && this.discountrule.couponsenable == 0) {
      //   this.discountcouponlist = []
      // }
      /**当获取的优惠券列表存在，进行逻辑处理 */
      if (this.discountcouponlist.length > 0) {
        if (this.discountcouponlist[0].price > 0) {
          /**符合使用条件 */
          this.usediscountcouponlist.push(this.discountcouponlist[0])
        }
      }
      this.usablecountdiscount =
        this.usediscountcouponlist.length >= 0 ? this.usediscountcouponlist.length : 0
      if (this.iszg != 1 && this.yl != 1 && this.ms != 1 && this.ylact != 1) {
        if (!shopConfirmResult.init_discount_coupon_data) {
          delete shopConfirmResult.choose_discount_coupon
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
        }
        if (
          !shopConfirmResult.choose_discount_coupon &&
          this.usediscountcouponlist.length &&
          !shopConfirmResult.init_discount_coupon_data
        ) {
          this.localDiscountCoupon = this.usediscountcouponlist[0]
          if (
            !(
              shopConfirmResult.choose_discount_coupon ||
              typeof shopConfirmResult.discountCouponChecked === 'boolean'
            )
          ) {
            const actTotalMoney =
              parseFloat(this.fullDiscountRule.initfullDiscountmoney || 0) +
              parseFloat(this.morediscounts.initmorediscountsmoney || 0) +
              parseFloat(this.fullMinusRules.initfullminusmoney || 0)
            //  +
            // parseFloat(this.halfprice.inithalfpricemoney || 0)
            const money_act_vs = parseFloat(this.choose_coupon_act_vs.price || 0)
            const money_discount_vs = parseFloat(this.choose_coupon_discount_vs.price || 0)
            if (
              actTotalMoney + money_act_vs >
              this.discountcouponlist[0].price +
                parseFloat(
                  this.usecouponFromDiscountcoupon == 1 &&
                    (this.isDiscountcouponMsgHandle == 0 || this.couponChecked)
                    ? money_discount_vs
                    : 0
                )
            ) {
              this.discountCouponChecked = false
              if (this.isDiscountcouponMsgHandle == 0) {
                this.discountCouponFn(this.discountCouponChecked)
              }
            } else {
              this.discountCouponChecked = true
              if (this.isDiscountcouponMsgHandle == 0) {
                this.discountCouponFn(this.discountCouponChecked)
              }
            }
          }
          this.localDiscountCoupon.checked = this.discountCouponChecked
          shopConfirmResult.choose_discount_coupon = this.usediscountcouponlist[0]
          localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
          this.discountcouponPrice = parseFloat(this.usediscountcouponlist[0].price).toFixed(2)
          this.chooseUseDiscountCouponIndex = 0
          this.discountcouponstitle = this.usediscountcouponlist[0].couponname
          this.discountcouponsmoney = ' -￥' + parseFloat(this.usediscountcouponlist[0].price)
        }
      }
      this.list.forEach((item) => {
        if (item.isgift != 1 && item.isgiftproduct != 1) {
          this.allItemIdsFunc({ item })
        }
      })
      this.totalMoney()
    },
    // 校验折扣券与活动匹配二选一
    checkdiscountcouponsPKact() {
      this.loaddiscountcoupons()
      let shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (shopConfirmResult.choose_discount_coupon) {
        const actTotalMoney =
          parseFloat(this.fullDiscountRule.initfullDiscountmoney || 0) +
          parseFloat(this.morediscounts.initmorediscountsmoney || 0) +
          parseFloat(this.fullMinusRules.initfullminusmoney || 0)
        //  +
        // parseFloat(this.halfprice.inithalfpricemoney || 0)
        if (this.isDiscountcouponMsgHandle == 0) {
          if (actTotalMoney > 0) {
            const discountcouponsmoney = parseFloat(
              String(this.discountcouponsmoney).replace(/[^\d.]/g, '')
            )
            const money_act_vs = parseFloat(this.choose_coupon_act_vs.price || 0)
            const money_discount_vs = parseFloat(this.choose_coupon_discount_vs.price || 0)
            if (
              actTotalMoney + money_act_vs >
              discountcouponsmoney +
                parseFloat(
                  this.usecouponFromDiscountcoupon == 1 && this.couponChecked
                    ? money_discount_vs
                    : 0
                )
            ) {
              this.discountcouponMsg = '折扣券不能与其他优惠共同使用，折扣优惠低于其他优惠合计'
            } else {
              this.discountcouponMsg = '折扣券不能与其他优惠共同使用，折扣优惠高于其他优惠合计'
            }
          } else {
            this.discountcouponMsg = ''
          }
        }
        if (parseFloat(this.fullDiscountRule.initfullDiscountmoney) > 0) {
          if (this.discountCouponChecked) {
            this.fullDiscountRule.fullDiscountmoney = 0
            this.fullDiscountRule.discountenable = 0
          } else {
            this.fullDiscountRule.fullDiscountmoney = this.fullDiscountRule.initfullDiscountmoney
            this.fullDiscountRule.discountenable = this.fullDiscountRule.initdiscountenable
          }
        }
        if (this.fullMinusRules.initactStatus == 1) {
          if (this.discountCouponChecked) {
            this.fullMinusRules.actStatus = -1
            this.fullminusmoney = 0
          } else {
            this.fullMinusRules.actStatus = this.fullMinusRules.initactStatus
            this.fullminusmoney = this.fullMinusRules.initfullminusmoney
          }
        }
        if (parseFloat(this.morediscounts.initmorediscountsmoney) > 0) {
          if (this.discountCouponChecked) {
            this.morediscounts = {
              ...this.morediscounts,
              discountlist: [],
              morediscountsmoney: 0
            }
            this.morediscountsmoney = 0
          } else {
            this.morediscounts = {
              ...this.morediscounts,
              discountlist: this.morediscounts.initdiscountlist,
              morediscountsmoney: this.morediscounts.initmorediscountsmoney
            }
            this.morediscountsmoney = parseFloat(this.morediscounts.morediscountsmoney)
          }
        }
      }
    },
    closeCoupon: function () {
      this.showcoupon = false
      this.couponBtn = false
    },
    handleShowsubscribegoodsOrder: function () {
      this.goNext()
      this.showsubscribegoodsmsg = false
    },
    handleCancelShowsubscribegoods: function () {
      this.showsubscribegoodsmsg = false
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.init_totalmoney_data = 0
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      window.location = `/static/wx/html/fullGift/index.html?type=addorder&is_subscribegoods=1`
    },
    handleAddFiveHundOrder: function () {
      this.goNext()
      this.showFiveHundmsg = false
    },
    handleCancelFiveHund: function () {
      this.showFiveHundmsg = false
      this.$router.replace({
        path: '/classification',
        query: {
          type: 'inside'
        }
      })
    },
    handleCancelEightHund: function () {
      this.showEightHundmsg = false
      this.$router.replace({
        path: '/classification',
        query: {
          type: 'inside'
        }
      })
    },
    handleAddEightHundOrder: function () {
      this.goNext()
      this.showEightHundmsg = false
    },
    handleAddress: function () {
      this.address()
      this.showaddress = false
    },
    handleEditorAddress: function () {
      this.editaddressFn()
      this.showaddress = false
    },
    handlePay: function () {
      this.goNext()
      this.showaddress = false
    },
    /**现金券-大额券下单前弹窗提示 */
    couponDialog(success) {
      let choose_coupon = sessionStorage.getItem('choose_coupon') ? JSON.parse(sessionStorage.getItem('choose_coupon')) : {}
      if (
        sessionStorage.getItem('choose_coupon') &&
        this.couponChecked &&
        choose_coupon.coupontype == 3 &&
        !this.showCouponDialog &&
        this.pay_money <= 0
      ) {
        this.$dialog
          .confirm({
            title: '',
            message: '订单金额小于优惠券金额，差额不做额外补偿，确认该订单使用此优惠券吗？',
            messageAlign: 'left',
            className: 'collect_button_alert',
            cancelButtonColor: '#FC0324',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            closeOnPopstate: true
          })
          .then(() => {
            if (typeof success == 'function') {
              this.showCouponDialog = true
              success()
            }
          })
          .catch(() => {
            this.showCouponDialog = false
          })
      } else {
        if (typeof success == 'function') {
          success()
        }
      }
    },
    goNext: function () {
      var that = this
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (!this.addressVal.id) {
        this.$toast('请添加收货地址再提交')
        return
      }
      if (!this.ischeckaddress) {
        this.isaddressFn()
          .then((res) => {
            that.ischeckaddress = true
            that.couponDialog(() => {
              Func()
            })
          })
          .catch((err) => {
            if (err.data.code == 2002) {
              this.$dialog
                .alert({
                  title: '温馨提示',
                  message: err.data.msg,
                  messageAlign: 'left',
                  className: 'percen_button_alert integral_button_alert',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '我知道了',
                  closeOnPopstate: false
                })
                .then(function () {})
            } else {
              this.$dialog
                .confirm({
                  title: '温馨提示',
                  message: err.data.msg,
                  messageAlign: 'left',
                  className: 'collect_button_alert',
                  cancelButtonColor: '#FC0324',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  closeOnPopstate: true
                })
                .then(function () {
                  that.ischeckaddress = true
                  that.couponDialog(() => {
                    Func()
                  })
                })
                .catch(function () {})
            }
          })
      } else {
        that.couponDialog(() => {
          Func()
        })
      }
      function Func() {
        if (that.is_50vipentrance == 1 && !that.ismobile) {
          that.ismobile = true
          that.$nextTick(function () {
            that.getCodeImg()
          })
          return
        }
        if (that.ismobile) {
          that.ismobile = false
          that.is_50vipentrance = 0
        }
        var url = that.$ajax.addOrder_URL
        if (that.$route.query.qtid) {
          url = that.$ajax.addQyGroupOrder_URL
        } else if (that.$route.query.np == 1) {
          url = that.$ajax.addOrderBySpike_URL
        } else if (that.$route.query.yl == 1 && that.$route.query.lb != 1) {
          if (that.$route.query.ylcc == 9) {
            url = that.$ajax.addLiveOrder_URL
          } else if (that.$route.query.ann == 1) {
            url = that.$ajax.addOrder_YearActivity_URL
          } else if (that.$route.query.anncc == 1) {
            url = that.$ajax.addOrderBySpecail_URL
          } else if (that.$route.query.mtact == 1) {
            url = that.$ajax.addChoiceItemOrder_URL
          } else if (that.$route.query.prize == 1) {
            url = that.$ajax.addOrderByPrizes_URL
          } else if (that.$route.query.defectivegood == 1) {
            url = that.$ajax.addOrderByWxp_URL
          } else if (that.$route.query.acttype == 'ck_group') {
            url = that.$ajax.submitCkGroupOrder_URL
          } else if (that.$route.query.acttype == 'vip35_welfare') {
            url = that.$ajax.addOrderVip35Welfare_URL
          } else if (
            that.$route.query.acttype == 'hc_welfare' ||
            that.$route.query.acttype == 'hc_welfare_private'
          ) {
            url = that.$ajax.addOrder_OfflineActivity_URL
          } else if (that.$route.query.ztpay == 1) {
            url = that.$ajax.addOrder_PrivateActivity_URL
            if (
              shopConfirmResult.ordertype == 'vipyl' ||
              shopConfirmResult.ordertype == '35vipact'
            ) {
              url = that.$ajax.addCkporder_URL
            }
          } else {
            url = that.$ajax.addActOrder_URL
          }
        } else if (that.$route.query.ms == 1) {
          /**秒杀 msindex */
          url = that.$ajax.addLimitActOrder_URL
          if (shopConfirmResult.ms_ad_v == 2) {
            url = that.$ajax.addLimitOrder_URL
          }
        } else if (that.$route.query.yl == 1 && that.$route.query.lb == 1) {
          url = that.$ajax.addJzGiftActOrder_URL
        } else if (that.$route.query.ylact == 1) {
          if (that.$route.query.newpersonact == 1) {
            url = that.$ajax.addNewUserOrder_URL
          } else {
            url = that.$ajax.addDrainageActivityOrder_URL
          }
        } else if (shopConfirmResult.isgiftbagbuy == 1) {
          /**线下会议礼包 exclusive-gift.html */
          url = that.$ajax.addOrder_InformalemplMeeting_URL
        }

        var skuids = [],
          recommendskuids = [],
          buynum = [],
          recommendbuynum = [],
          live_id = [],
          room_id = [],
          len = 0,
          isdiscount = 0,
          floditemnum = 0,
          data,
          couponsid,
          integernumber,
          integermoney,
          list = clone(that.list),
          recitemid = []
        if (that.exchangeitemlist.length) {
          that.exchangetotalnum = 0
          that.exchangeitemlist.map((item) => {
            if (!item.ishide) {
              item.changebuylist.map((goodsitem) => {
                if (goodsitem.ischoose == true || goodsitem.ischoose == 1) {
                  list.push(goodsitem)
                  that.exchangetotalnum += parseInt(goodsitem.num)
                }
              })
            }
          })
        }
        list.map(function (item) {
          if (item.isgift != 1 && item.is_subscribegoods != 1) {
            if (item.isoversea == 1) {
              len++
            }
            if (item.isdiscount == 1) {
              isdiscount = 1
              floditemnum += parseInt(item.num)
            }
            if (item.isgiftproduct != 1 && item.isintellrecommend != 1) {
              skuids.push(item.skuid)
              buynum.push(item.num)
              live_id.push(item.liveid)
            }
            if (item.isintellrecommend == 1) {
              let index = skuids.indexOf(item.skuid)
              if (index >= 0) {
                buynum[index] = buynum[index] + item.num
              } else {
                recommendskuids.push(item.skuid)
                recommendbuynum.push(item.num)
                recitemid.push(item.itemid)
              }
            }
          }
        })
        if (that.productgify != null) {
          ;[that.productgify.goodsinfo].map(function (item) {
            skuids.push(item.skuid)
            buynum.push(item.num)
            live_id.push(0)
          })
        }
        if (shopConfirmResult.roomId) room_id = shopConfirmResult.roomId

        that.currentdiscountIndex =
          that.currentdiscountIndex == -1 && that.discountrule.discountlist
            ? that.discountrule.discountlist.length
            : that.currentdiscountIndex
        if (that.subscribegoodsrule.tips && localStorage.getItem('showsubscribegoods') != 1) {
          localStorage.setItem('showsubscribegoods', 1)
          that.showsubscribegoodsmsg = true
          return
        }
        if (
          that.couponstips.showtips == 1 &&
          Number(localStorage.getItem('fivehundred')) != 1 &&
          parseFloat(that.totalprice) < parseFloat(that.couponstips.money) &&
          that.couponstips.tips
        ) {
          localStorage.setItem('fivehundred', 1)
          that.showFiveHundmsg = true
          return
        }
        if (
          that.drawprizetips.showtips == 1 &&
          Number(localStorage.getItem('eighthundred')) != 1 &&
          ((that.couponstips.showtips == 1 &&
            parseFloat(that.totalprice) >= parseFloat(that.couponstips.money)) ||
            that.couponstips.showtips == 0) &&
          parseFloat(that.totalprice) < parseFloat(that.drawprizetips.money) &&
          that.drawprizetips.tips
        ) {
          localStorage.setItem('eighthundred', 1)
          that.showEightHundmsg = true
          return
        }
        if (that.addressVal.mobile) {
          let str = that.addressVal.mobile
          if (/ /g.test(str) || !/^1[3456789]\d{9}$/.test(str)) {
            that.$toast('请检查收货人手机号码是否正确')
            return
          }
        }
        if (that.$route.query.qtid && that.qtDialogShow == 1) {
          that.$dialog
            .confirm({
              title: '',
              message: '请确认您的购买产品信息无误,提交后我们将为您核对团购信息.',
              messageAlign: 'left',
              className: 'collect_button_alert',
              cancelButtonColor: '#FC0324',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '我知道了',
              cancelButtonText: '取消',
              closeOnPopstate: true
            })
            .then(() => {
              that.qtDialogShow = 0
              that.goNext()
            })
            .catch(() => {
              that.qtDialogShow = 1
            })
          return
        } else if (!that.$route.query.qtid && !that.discountaddress) {
          that.showaddress = true
          that.discountaddress = 1
          return
        }
        if (sessionStorage.getItem('choose_coupon') && that.couponChecked) {
          if (sessionStorage.getItem('choose_integral')) {
            couponsid = JSON.parse(sessionStorage.getItem('choose_coupon')).couponid
            integernumber = JSON.parse(sessionStorage.getItem('choose_integral')).limitinteger
            integermoney = JSON.parse(sessionStorage.getItem('choose_integral')).integermoney
          } else {
            couponsid = JSON.parse(sessionStorage.getItem('choose_coupon')).couponid
            integernumber = ''
            integermoney = ''
          }
        } else {
          if (sessionStorage.getItem('choose_integral')) {
            couponsid = ''
            integernumber = JSON.parse(sessionStorage.getItem('choose_integral')).limitinteger
            integermoney = JSON.parse(sessionStorage.getItem('choose_integral')).integermoney
          } else {
            couponsid = ''
            integernumber = ''
            integermoney = ''
          }
        }
        /**Start智能推荐 */
        if (recommendskuids.length > 0) skuids = skuids.concat(recommendskuids)
        if (recommendbuynum.length > 0) buynum = buynum.concat(recommendbuynum)
        /**End */
        /**Start skuid去重处理 */
        let ids = skuids
        let num = buynum
        let repeatSkuids = that.$com.findDuplicateIndices(ids)
        for (const key in repeatSkuids) {
          let numTemp = 0
          for (let i = 0; i < repeatSkuids[key].length; i++) {
            numTemp += parseInt(num[repeatSkuids[key][i]] || 1)
            if (i > 0) {
              ids[repeatSkuids[key][i]] = num[repeatSkuids[key][i]] = null
            }
          }
          num[repeatSkuids[key][0]] = numTemp
        }
        skuids = ids.filter((item) => item !== null)
        buynum = num.filter((item) => item !== null)
        /**End */
        data = {
          remark: that.remark != null || that.remark != undefined ? that.remark : '',
          addressid: that.addressVal.id,
          skuids: skuids.join(),
          buynum: buynum.join(),
          live_id: live_id.join(),
          room_id: room_id.length ? room_id.join() : '',
          orderid: shopConfirmResult.orderid ? shopConfirmResult.orderid : '',
          ysorderid: shopConfirmResult.ysorderid ? shopConfirmResult.ysorderid : '',
          useintegralitemjson: that.useintegralitemjson || '',
          fullDiscountRuleNew: 1
        }

        if (shopConfirmResult.specialid) {
          data.specialid = shopConfirmResult.specialid
        }
        if (shopConfirmResult.orderfrom || shopConfirmResult.orderfrom == 0) {
          data.from = shopConfirmResult.orderfrom
        }
        if (shopConfirmResult.groupbuyid) {
          data.groupbuyid = shopConfirmResult.groupbuyid
        }
        if (shopConfirmResult.receivmethod) {
          data.receivmethod = shopConfirmResult.receivmethod
        }

        if (shopConfirmResult.enterprisecode) {
          data.enterprisecode = shopConfirmResult.enterprisecode
        }
        if (that.mobile.trim())
          data[shopConfirmResult.beauty != 1 ? 'upck50_mobile' : 'beauty_upck50_mobile'] =
            that.mobile
        if (shopConfirmResult.course_params) {
          data[shopConfirmResult.beauty != 1 ? 'course_params' : 'beauty_course_params'] =
            shopConfirmResult.course_params.join()
        }
        if (that.buygiftlist_submit && that.buygiftlist_submit.length > 0) {
          data.buygiftlist = JSON.stringify(that.buygiftlist_submit)
        }
        if (that.buygiftorigoods && that.buygiftorigoods.length > 0) {
          data.buygiftorigoods = JSON.stringify(that.buygiftorigoods)
        }
        if (shopConfirmResult.ordertype) {
          data.ordertype = shopConfirmResult.ordertype
        }
        if (that.$route.query.np == 1) {
          data.couponsid = couponsid
          data.integernumber = integernumber
          data.integermoney = integermoney
        } else if (
          that.$route.query.yl == 1 &&
          that.$route.query.actid != 1 &&
          that.$route.query.prize != 1 &&
          that.$route.query.mtact != 1 &&
          that.$route.query.ztpay != 1
        ) {
          data.skuid = skuids.join()
          if (that.$route.query.acttype == 'ck_group') {
            data.groupid =
              that.$route.query.groupid ||
              (shopConfirmResult && shopConfirmResult.groupid) ||
              ''
            if (sessionStorage.getItem('ck_utoken')) {
              data.ck_utoken = sessionStorage.getItem('ck_utoken')
            }
          } else if (
            that.$route.query.acttype == 'hc_welfare' ||
            that.$route.query.acttype == 'vip35_welfare' ||
            (that.$route.query.acttype == 'hc_welfare_private' &&
              sessionStorage.getItem('ck_utoken'))
          ) {
            data.ck_utoken = sessionStorage.getItem('ck_utoken')
          }
        } else if (that.$route.query.yl == 1 && that.$route.query.actid) {
          data.actid = that.$route.query.actid
          if (shopConfirmResult.chooseFreely)
            data.chooseFreely = JSON.stringify(shopConfirmResult.chooseFreely)
        } else if (that.$route.query.ylact == 1) {
          data.skuid = skuids.join()
          data.activityid = shopConfirmResult.activityid ? shopConfirmResult.activityid : ''
        } else if (that.$route.query.ms == 1) {
          data.skuid = skuids.join()
          data.limitid = shopConfirmResult.limitid
        } else if (that.$route.query.prize == 1) {
          if (shopConfirmResult.actprizeid) {
            data.actprizeid = shopConfirmResult.actprizeid
          } else {
            data.prizeids = shopConfirmResult.prizeidArr ? shopConfirmResult.prizeidArr.join() : ''
          }
        } else {
          data.couponsid = couponsid
          data.integernumber = integernumber
          data.integermoney = integermoney
          data.communityid =
            shopConfirmResult.communityid != undefined ? shopConfirmResult.communityid : ''
          data.giftactid = that.giftactid
          data.addgiftid = that.addgiftid
          data.giftitem = that.giftitem
          data.giftnum = that.giftnum
          if (that.$route.query.isexchange == 1 || shopConfirmResult.act_class == 'exchangebuy') {
            data.exchangeorderid = data.orderid
            delete data.orderid
          } else if (shopConfirmResult.act_class == 'allchangebuy') {
            data.allorderid = data.orderid
            delete data.orderid
          }
          if (shopConfirmResult.choose_discount_coupon && that.discountCouponChecked) {
            data.discountcouponid = shopConfirmResult.choose_discount_coupon.couponid
          } else {
            data.discountcouponid = ''
          }
        }
        data.prodcouponid = that.productgify != null ? that.productgify.id : ''
        if (shopConfirmResult.beautityitemid) {
          data.beautityitemid = shopConfirmResult.beautityitemid
        }
        if (that.$route.query.qtid) {
          data.qtid = that.$route.query.qtid
          data.qt_token = sessionStorage.getItem('qt_token')
        }
        if (len == 0 || (len == list.length && that.addressVal.cardno != '')) {
          that.$toast.loading({
            mask: false,
            message: '正在提交',
            forbidClick: true,
            duration: 0
          })

          let shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
          if (shopConfirmResult.shareOpenid) {
            data.shareOpenid = shopConfirmResult.shareOpenid
          }
          if (shopConfirmResult.acttype) {
            data.acttype = shopConfirmResult.acttype
          }
          if (shopConfirmResult.recommendId) {
            data.fastcartid = shopConfirmResult.recommendId
            if (shopConfirmResult.source) {
              data.source = shopConfirmResult.source
            }
          }
          if (shopConfirmResult) {
            shopConfirmResult.skuidArr = skuids
            shopConfirmResult.itemNum = buynum
          }
          if (shopConfirmResult.actgroupid) {
            data.actgroupid = shopConfirmResult.actgroupid
          }
          that.appendCollagenOrderParamsHandle(data)
          console.log('下单提交的数据', data)
          that.$customRequestAjax
            .post(url, data)
            .then(function (res) {
              if (
                res.data.code == 200 ||
                (that.$route.query.acttype == 'vip35_welfare' && (res.data.code == 300 || res.data.code == 501))
              ) {
                try {
                  if (shopConfirmResult && shopConfirmResult.coudan_activity_id) {
                    sessionStorage.removeItem(
                      'coudan_act_sel_' + shopConfirmResult.coudan_activity_id
                    )
                  }
                } catch (e) {}
                /**埋点增加接口 */
                if (typeof that.$route.query.metro !== 'undefined') {
                  that.$clickburiedPoint({
                    data: {
                      actcode: that.$route.query.metro,
                      behavior: res.data.orderid,
                      userfrom: 0
                    },
                    url: 'ckysdatacenter/activity/save'
                  })
                }
                if (that.$route.query.acttype == 'ck_group') {
                  that.$toast.clear()
                  var ckmsg = res.data.msg
                  if (!ckmsg) {
                    ckmsg =
                      res.data.submitstatus == 1
                        ? '自提成功，请前往创客APP查看订单'
                        : '自提失败，您的产品库库存不足，需要前往创客APP进行充值'
                  }
                  that.$dialog
                    .alert({
                      message: ckmsg,
                      className: 'percen_button_alert',
                      confirmButtonColor: '#FFFCFC',
                      confirmButtonText: '我知道了',
                      closeOnPopstate: false
                    })
                    .then(function () {
                      that.$app.goIndex()
                    })
                  return
                }
                if (
                  that.$route.query.acttype == 'hc_welfare' ||
                  that.$route.query.acttype == 'hc_welfare_private' ||
                  that.$route.query.acttype == 'vip35_welfare'
                ) {
                  that.$toast.clear()
                  if (
                    res.data.submitstatus == 1 ||
                    (that.$route.query.acttype == 'vip35_welfare' && (res.data.code == 200 || res.data.code == 300))
                  ) {
                    that.$dialog
                      .confirm({
                        message: res.data.msg,
                        className: 'collect_button_alert',
                        cancelButtonColor: '#FC0324',
                        confirmButtonColor: '#FFFCFC',
                        confirmButtonText: '去看看',
                        cancelButtonText: '进入首页',
                        closeOnPopstate: true
                      })
                      .then(function () {
                        window.location.href = downloadpath
                      })
                      .catch(() => {
                        that.$router.replace('/')
                      })
                  } else {
                    that.$dialog
                      .alert({
                        message: res.data.msg,
                        className: 'percen_button_alert',
                        confirmButtonColor: '#FFFCFC',
                        confirmButtonText: '去进货',
                        closeOnPopstate: false
                      })
                      .then(function () {
                        window.location.href = downloadpath
                      })
                  }
                  return
                } else if (shopConfirmResult.isgiftbagbuy == 1) {
                  that.$toast.clear()
                  that.$dialog
                    .alert({
                      message: res.data.msg,
                      className: 'percen_button_alert',
                      confirmButtonColor: '#FFFCFC',
                      confirmButtonText: '返回购买',
                      closeOnPopstate: false
                    })
                    .then(function () {
                      history.go(-1)
                    })
                  return
                } else if (that.$route.query.newpersonact == 1) {
                  that.$toast.clear()
                  that.$router.replace({
                    path: '/orderdetails',
                    query: that.groupQuery({
                      id: res.data.orderid
                    })
                  })
                  return
                }
                localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
                that.orderid = res.data.orderid
                that.jumplink = res.data.jumplink ? res.data.jumplink : ''

                let saveParams = {
                  orderid: that.orderid,
                  recitemid: recitemid.join()
                }
                if (shopConfirmResult.save_course_params) {
                  saveParams.course_params = shopConfirmResult.save_course_params.join()
                }
                that.$commonburiedPoint({
                  data: saveParams
                })
                that.dataCollection('submitProductSuccess')
                that.dataCollection('submitOrderSuccess')
                if (that.$route.query.qtid) {
                  sessionStorage.removeItem('enterprise_group_itemsel_' + that.$route.query.qtid + '_' + sessionStorage.getItem('qt_token'))
                  window.location.replace('/static/wx/html/enterprise-group-buy/audit-pending.html?m=' + (res.data.mobile ? encodeURIComponent(res.data.mobile) : ''))
                  return
                }
                var url = that.$ajax.getPayInfo_URL
                that.$customRequestAjax(url).then(function (res) {
                  if (res.data.code === 200) {
                    that.isSwitch = res.data
                    that.$toast({
                      message: '提交成功',
                      icon: require('../../assets/images/succ.png')
                    })
                    if (isWeixin()) {
                      /* 支付风控 */
                      // let money = !isNaN(parseFloat(that.paymoney)) ? that.paymoney : 0
                      // if (money >= 0) {
                      //   that.showPayTemp = true
                      //   return
                      // }
                      if (
                        (res.data.web_swiftwxpay == 1 || res.data.web_wxpay == 1) &&
                        res.data.web_unionpay != 1
                      ) {
                        that.to_cash()
                      } else {
                        sessionStorage.setItem('pay_switch', JSON.stringify(res.data))
                        localStorage.removeItem('skuids')
                        localStorage.removeItem('buynum')
                        localStorage.removeItem('itemid')
                        that.$router.replace({
                          path: '/pay',
                          query: that.groupQuery({
                            id: that.orderid,
                            money: !isNaN(parseFloat(that.pay_money)) ? that.pay_money : 0,
                            yl: that.$route.query.yl || 0,
                            ms: that.$route.query.ms || 0,
                            lb: that.$route.query.lb || 0,
                            ylcc: that.$route.query.ylcc || 0,
                            ann: that.$route.query.ann || 0,
                            anncc: that.$route.query.anncc || 0,
                            ylact: that.$route.query.ylact || 0
                          })
                        })
                      }
                    } else {
                      sessionStorage.setItem('pay_switch', JSON.stringify(res.data))
                      localStorage.removeItem('skuids')
                      localStorage.removeItem('buynum')
                      localStorage.removeItem('itemid')
                      var arg = isApp()
                      if (arg == '') {
                        that.$router.replace({
                          path: '/pay',
                          query: that.groupQuery({
                            id: that.orderid,
                            money: !isNaN(parseFloat(that.pay_money)) ? that.pay_money : 0,
                            yl: that.$route.query.yl || 0,
                            ms: that.$route.query.ms || 0,
                            lb: that.$route.query.lb || 0,
                            ylcc: that.$route.query.ylcc || 0,
                            ann: that.$route.query.ann || 0,
                            anncc: that.$route.query.anncc || 0,
                            ylact: that.$route.query.ylact || 0
                          })
                        })
                      } else {
                        var shopConfirmResult = JSON.parse(
                          localStorage.getItem('shopConfirmResult')
                        )
                        if (that.$route.query.yl == 1 || that.$route.query.ylact == 1) {
                          var obj = {
                            type: 'ylGoBuy',
                            itemid: shopConfirmResult.itemidArr.join(),
                            orderid: that.orderid,
                            ordermoney: !isNaN(parseFloat(that.pay_money)) ? that.pay_money : 0
                          }
                          window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                        } else if (that.$route.query.ms == 1) {
                          var obj = {
                            type: 'msGoBuy',
                            orderid: that.orderid,
                            ordermoney: !isNaN(parseFloat(that.pay_money)) ? that.pay_money : 0
                          }
                          window.ReactNativeWebView.postMessage(JSON.stringify(obj))
                        }
                      }
                    }
                  }
                })
              } else if (res.data.code == 201) {
                that.$toast.clear()
                that.$dialog
                  .confirm({
                    message: res.data.msg,
                    className: 'collect_button_alert',
                    cancelButtonColor: '#FC0324',
                    cancelButtonText: '取消',
                    confirmButtonColor: '#FFFCFC',
                    confirmButtonText: '去查看'
                  })
                  .then(() => {
                    // on close
                    that.$app.argLink({ path: '/vipcenter' })
                  })
              } else if (res.data.code == 300) {
                that.$router.replace({
                  path: '/orderdetails',
                  query: that.groupQuery({
                    router: 'replace',
                    id: res.data.orderid
                  })
                })
              } else if (res.data.code == 6001) {
                that.is_50vipentrance = 1
                that.mobile = ''
                that.code = ''
                that.sms = ''
              } else {
                that.$toast(res.data.msg)
              }
            })
            .catch(function (err) {
              that.$toast.fail('提交失败，请稍后重试')
            })
        } else if (len == list.length && that.addressVal.cardno == '') {
          that.$dialog
            .confirm({
              title: '完善信息',
              message: '您购买的商品为海外商品，需要实名认证后才可以购买',
              className: 'collect_button_alert',
              cancelButtonColor: '#FC0324',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '修改实名',
              cancelButtonText: '取消',
              closeOnPopstate: true
            })
            .then(function () {
              sessionStorage.setItem('oversea_List', JSON.stringify(list))
              var query = that.$route.query
              query.addressid = that.addressVal.id
              that.$router.replace({
                path: '/identity',
                query: query
              })
            })
        } else if (len < list.length && len > 0) {
          that.$toast('正常商品不可与海外商品同时购买')
        }
      }
    },
    isaddressFn: function () {
      var that = this,
        url =
          this.$ajax.checkAddress_URL +
          '?addressid=' +
          this.addressVal.id +
          '&payMoney=' +
          this.pay_money
      if (this.$route.query.qtid) {
        if (!sessionStorage.getItem('qt_token')) {
          this.$toast('请先登录')
          setTimeout(() => {
            this.$app.argStaticLink('/static/wx/html/enterprise-group-buy/login.html?qtid=' + encodeURIComponent(this.$route.query.qtid))
          }, 600)
          return
        }
        url += '&qt_token=' + encodeURIComponent(sessionStorage.getItem('qt_token'))
      }
      return new Promise(function (resolve, reject) {
        that
          .$customRequestAjax(url)
          .then(function (res) {
            that.isareacode =
              res.data.isareacode == 0 || res.data.isareacode == 1 ? res.data.isareacode : -1
            if (res.data.code == 200) {
              resolve(res)
            } else {
              reject(res)
            }
          })
          .catch(function (err) {
            resolve(err)
          })
      })
    },
    dataCollection(type) {
      let params
      if (type == 'submitOrderSuccess' || type == 'orderPaySuccess') {
        /**订单提交成功&订单支付成功 */
        let coupon = JSON.parse(sessionStorage.getItem('choose_coupon')),
          couponName = ''
        if (coupon && coupon.couponname) {
          couponName = coupon.couponname
        }
        params = {
          orderId_var: this.orderid /**订单id */,
          actualPayment_var: this.pay_money /**实际支付金额 */,
          payMethod_var: '微信支付' /**支付方式 */,
          ifCouponUsed_var: this.couponsid ? '是' : '否' /**是否使用现金券 */,
          couponType_var: '' /**现金券类型 */,
          couponName_var: couponName /**现金券名称 */,
          orderAddress_var: this.addressVal.area /**订单收货城市 */
        }

        if (type == 'submitOrderSuccess') {
          delete params.payMethod_var
        }
        gio('track', type, params)
      } else {
        let list = this.list
        for (let i in list) {
          params = {
            orderId_var: this.orderid /**订单id */,
            productId_var: list[i].itemid /**商品id */,
            productName_var: list[i].name /**商品名称 */,
            firstCat_var: '' /**商品一级分类 */,
            productType_var: '' /**商品品类 */,
            productFormat_var: list[i].skuid /**商品规格 */,
            buyQuantity_var: list[i].num /**购买数量 */,
            payAmount_var: (list[i].price * list[i].num).toFixed(2) /**支付金额 */
          }

          gio('track', type, params)
        }
      }
    },
    address: function () {
      var query = this.$route.query
      query.addressid = this.addressVal.id
      query.type = 'submitorder'
      this.$router.push({
        path: '/addresschoose',
        query: query
      })
    },
    editaddressFn: function () {
      var query = this.$route.query
      query.type = 'addorder'
      query.ordertype = 'submitorder'
      query.id = this.addressVal.id
      this.$router.push({
        path: '/editadd',
        query: query
      })
    },
    addaddress: function () {
      var query = this.$route.query
      query.type = 'addorder'
      query.ordertype = 'submitorder'
      this.$router.push({
        path: '/addadd',
        query: query
      })
    },
    goChangebuy: function () {
      var skuids = [],
        itemnum = [],
        obj
      this.list.map((item) => {
        if (!item.ischangebuy) {
          skuids.push(item.skuid)
          itemnum.push(item.num)
        }
      })
      obj = {
        path: encryption(this.$route.fullPath),
        skuids: skuids.join(),
        itemnum: itemnum.join(),
        t: new Date().getTime()
      }
      this.$router.push({
        path: '/productList',
        query: obj
      })
    },
    /**券的选择按钮交互处理 */
    chooseCoupon: function (index) {
      var items = []
      var that = this
      that.usecouponlist.forEach(function (item, i) {
        if (i === index) {
          if (item.isChoose) {
            item.isChoose = false
            that.couponPrice = 0
            that.chooseUseCouponIndex = null
          } else {
            item.isChoose = true
            that.couponPrice = parseFloat(item.price).toFixed(2)
            that.chooseUseCouponIndex = i
          }
        } else {
          item.isChoose = false
        }
        items.push(item)
      })
      that.usecouponlist = items
    },
    showCouponDesc: function (index, type) {
      var couponShowList = []
      var nocouponShowList = []
      if (type == 'coupon') {
        this.usecouponlist.map(function (item, i) {
          if (index == i) {
            item.isShowDesc = !item.isShowDesc
          }
          couponShowList.push(item)
        })
        this.usecouponlist = couponShowList
      } else if (type == 'nocoupon') {
        this.nousercouponlist.map(function (item, i) {
          if (index == i) {
            item.isShowDesc = !item.isShowDesc
          }
          nocouponShowList.push(item)
        })
        this.nousercouponlist = nocouponShowList
      }
    },
    comfrimCoupon: function () {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.init_coupon_data = 1 /**自动匹配可用现金券数据 0用户未选择，需匹配； 1用户主动已选择，不匹配 */
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      this.showcoupon = false
      var coupon = this.usecouponlist[this.chooseUseCouponIndex]
      if (coupon != undefined && coupon != '' && coupon != null) {
        this.localCoupon = coupon
        this.localCoupon.checked = this.couponChecked
        this.couponPrice = this.localCoupon.price
        sessionStorage.setItem('choose_coupon', JSON.stringify(this.localCoupon))
        this.usecouponFromDiscountcoupon = this.localCoupon.useforDiscoutCoupon == 1 ? 1 : 0
      } else {
        this.couponstitle = ''
        this.couponsmoney = 0
        this.localCoupon = null
        sessionStorage.removeItem('choose_coupon')
      }
      this.totalMoney()
      this.exchangeRuleItemids()
      this.getjifen()
      this.loadcoupons()
      this.checkProduct()
    },
    /**实付金额计算 */
    totalMoney: function () {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      if (
        sessionStorage.getItem('choose_coupon') &&
        this.couponChecked &&
        sessionStorage.getItem('choose_integral')
      ) {
        var coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
        var integral = JSON.parse(sessionStorage.getItem('choose_integral'))
        this.integralmoney = parseFloat(integral.integermoney)
        this.couponstitle = coupon.couponname
        this.couponsmoney = this.couponmoney = parseFloat(coupon.price)
        this.totalprice =
          parseFloat(this.totalmoney) -
          this.couponsmoney -
          parseFloat(integral.checked ? this.integralmoney : 0)
      } else if (sessionStorage.getItem('choose_integral')) {
        var integral = JSON.parse(sessionStorage.getItem('choose_integral'))
        this.integralmoney = parseFloat(integral.integermoney)
        this.couponmoney = 0
        this.totalprice =
          parseFloat(this.totalmoney) - parseFloat(integral.checked ? this.integralmoney : 0)
      } else if (sessionStorage.getItem('choose_coupon') && this.couponChecked) {
        var coupon = JSON.parse(sessionStorage.getItem('choose_coupon'))
        this.integralmoney = 0
        this.couponstitle = coupon.couponname
        this.couponsmoney = this.couponmoney = parseFloat(coupon.price)
        this.totalprice = this.totalmoney - this.couponsmoney
      } else {
        this.couponmoney = 0
        this.integralmoney = 0
        this.totalprice = this.totalmoney
      }

      if (shopConfirmResult.choose_discount_coupon && this.discountCouponChecked) {
        var coupon = shopConfirmResult.choose_discount_coupon
        this.discountcouponmoney = parseFloat(coupon.price)
        this.discountcouponstitle = coupon.couponname
        this.discountcouponsmoney = ' -￥' + parseFloat(coupon.price)
        this.totalprice -= parseFloat(coupon.price)
      } else {
        this.discountcouponmoney = 0
      }
      this.giftruleCalculate()
      /**
       * activity: 38预约活动商品
       * cteatetime: 20230216
       * creater: gao en hui
       * scene：现金券场景~参与活动的商品一定参与现金券抵扣
       * */
      if (this.subscribegoodsrule && Object.keys(this.subscribegoodsrule).length > 0) {
        this.subscribegoodsRule()
      }
    },
    /**优惠金额计算 */
    totalPrice: function (total, coupon, other) {
      var money = parseFloat(total) + parseFloat(coupon || 0) - parseFloat(other || 0)
      return parseFloat(money)
    },
    subscribegoodsRule() {
      var coupon_money =
        sessionStorage.getItem('choose_coupon') && this.couponChecked
          ? parseFloat(JSON.parse(sessionStorage.getItem('choose_coupon')).price)
          : 0
      var integral_money = sessionStorage.getItem('choose_integral')
        ? parseFloat(JSON.parse(sessionStorage.getItem('choose_integral')).integermoney)
        : 0

      this.subscribegoodsrule.tips = ''
      if (
        this.subscribegoods_totalmoney - coupon_money - integral_money >=
        parseFloat(this.subscribegoodsrule.paymoney)
      ) {
        this.subscribegoodslist = Object.keys(this.subscribegoodsrule.goods).length
          ? [this.subscribegoodsrule.goods]
          : []
      } else {
        let m = parseFloat(
          parseFloat(this.subscribegoodsrule.paymoney) -
            (this.subscribegoods_totalmoney - coupon_money - integral_money)
        ).toFixed(2)
        if (m < parseFloat(this.subscribegoodsrule.paymoney)) {
          this.subscribegoodsrule.tips = '还差' + m + '元可带走已预约的<br/>保龄霜5g哦'
        }
        this.subscribegoodslist = []
      }
    },
    /**微信支付 */
    to_cash: function () {
      var url = this.$ajax.check_order_status_URL
      var data = {
        oid: this.orderid
      }
      var that = this
      that.$customRequestAjax.post(url, data).then(function (res) {
        if (res.data && res.data.code == 200) {
          if (res.data.order_status == 1 || res.data.order_status == 2) {
            var phpUrl
            if (that.isSwitch.web_wxpay == '1' && that.isSwitch.web_swiftwxpay == '1') {
              phpUrl = that.$ajax.weixin_wxpay2_URL
              if (that.isSwitch.wx_paytype == 1) {
                phpUrl = that.$ajax.weixinnet_wxpay2_URL
              }
            } else if (that.isSwitch.web_wxpay == '1') {
              phpUrl = that.$ajax.weixin_wxpay2_URL
              if (that.isSwitch.wx_paytype == 1) {
                phpUrl = that.$ajax.weixinnet_wxpay2_URL
              }
            } else if (that.isSwitch.web_swiftwxpay == '1') {
              phpUrl = that.$ajax.swiftpass_pay_URL
            }
            var phpData = {
              openid: appid,
              orderId: that.orderid
            }
            that.$customRequestAjax.post(phpUrl, phpData).then(function (res) {
              if (res.data && res.data.code == 200) {
                that.$toast.clear()
                if (that.isSwitch.web_wxpay == '1' && that.isSwitch.web_swiftwxpay == '1') {
                  that.callpay(JSON.parse(res.data.jsApiParameters))
                } else if (that.isSwitch.web_wxpay == '1') {
                  that.callpay(JSON.parse(res.data.jsApiParameters))
                } else if (that.isSwitch.web_swiftwxpay == '1') {
                  that.callpay(JSON.parse(res.data.codeinfo))
                }
              } else {
                that.$toast(res.data.codeinfo)
              }
            })
          } else {
            that.$toast(res.data.codeinfo)
            setTimeout(function () {
              that.$router.push('/')
            }, 1000)
          }
        }
      })
    },
    /**微信支付调用 */
    callpay: function (d) {
      if (typeof WeixinJSBridge === 'undefined') {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', this.jsApiCall, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', this.jsApiCall)
          document.attachEvent('onWeixinJSBridgeReady', this.jsApiCall)
        }
      } else {
        this.jsApiCall(d)
      }
    },
    /**调用微信JS api 支付 */
    jsApiCall: function (d) {
      var that = this,
        shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult')),
        skuids = ['1718', '1721', '2271', '2570']
      WeixinJSBridge.invoke('getBrandWCPayRequest', d, function (res) {
        WeixinJSBridge.log(res.err_msg)
        if (res.err_msg == 'get_brand_wcpay_request:ok') {
          localStorage.removeItem('skuids')
          localStorage.removeItem('buynum')
          localStorage.removeItem('itemid')
          setTimeout(function () {
            for (let i = 0; i < skuids.length; i++) {
              if (shopConfirmResult.skuidArr.indexOf(skuids[i]) > -1) {
                that.isSwitch.jumplink = ''
                break
              }
            }
            if (that.isSwitch.jumplink) {
              window.location = that.isSwitch.jumplink
              return
            }
            if (that.jumplink) {
              //   window.location = that.jumplink
              that.$app.argStaticLink(
                that.jumplink +
                  (that.jumplink.indexOf('?') >= 0 ? '&' : '?' + 'orderid=' + that.orderid)
              )
              return
            }
            that.$router.replace({
              path: '/payResult',
              query: that.groupQuery({
                id: that.orderid,
                money: !isNaN(parseFloat(that.pay_money)) ? that.pay_money : 0,
                payresult: encodeURIComponent('success'),
                yl: that.$route.query.yl || 0,
                ylact: that.$route.query.ylact || 0,
                ms: that.$route.query.ms || 0,
                lb: that.$route.query.lb || 0,
                ylcc: that.$route.query.ylcc || 0,
                ann: that.$route.query.ann || 0,
                anncc: that.$route.query.anncc || 0,
                ztpay: that.$route.query.ztpay || 0
              })
            })
          }, 1000)
        } else if (
          res.err_msg == 'get_brand_wcpay_request:cancel' ||
          res.err_msg == 'get_brand_wcpay_request:fail'
        ) {
          localStorage.removeItem('skuids')
          localStorage.removeItem('buynum')
          localStorage.removeItem('itemid')
          that.$router.replace({
            path: '/payResult',
            query: that.groupQuery({
              id: that.orderid,
              payresult: encodeURIComponent('failure'),
              yl: that.$route.query.yl || 0,
              ylact: that.$route.query.ylact || 0,
              ms: that.$route.query.ms || 0,
              lb: that.$route.query.lb || 0,
              ylcc: that.$route.query.ylcc || 0,
              ann: that.$route.query.ann || 0,
              anncc: that.$route.query.anncc || 0,
              ztpay: that.$route.query.ztpay || 0
            })
          })
        }
      })
    },
    /**个人中心进入返回上一级，支付后进入返回首页 */
    goBack: function () {
      if (this.$route.query.route) {
        this.$router.replace({ path: '/' })
      } else {
        history.go(-1)
      }
    },
    goflod: function (type) {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.init_totalmoney_data = 0
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      var temp = this.$route.fullPath.split('?')
      var url =
        '/static/wx/html/20190820/Flod/flodlist.html?type=addorder&acttype=' +
        type +
        '&goodsnum=' +
        this.discountGoodsnum
      if (temp.length >= 2) {
        url += '&pathdata=' + encryption(this.$route.fullPath.split('?')[1])
      }
      window.location = url
    },
    gofullgift: function () {
      var shopConfirmResult = JSON.parse(localStorage.getItem('shopConfirmResult'))
      shopConfirmResult.init_totalmoney_data = 0
      localStorage.setItem('shopConfirmResult', JSON.stringify(shopConfirmResult))
      var temp = this.$route.fullPath.split('?')
      var url =
        '/static/wx/html/fullGift/index.html?type=addorder&currentdiscount=' + this.currentdiscount
      var skuids = [],
        nums = []
      this.list.map((item) => {
        if (item.isgift != 1 && item.isbuygift != 1 && item.isgiftproduct != 1) {
          skuids.push(item.skuid)
          nums.push(item.num)
        }
      })
      url += '&skuids=' + skuids.join() + '&nums=' + nums.join()
      if (temp.length >= 2) {
        url += '&pathdata=' + encryption(this.$route.fullPath.split('?')[1])
      }
      const discouponswitch = this.discountCouponChecked ? 1 : 0
      url += '&discouponswitch=' + discouponswitch
      window.location = url
    },
    godetail(items, type) {
      var query = {
        itemid: items.itemid
      }
      if (type != 'recommend') {
        query.type = 'changebuyproductdetail'
      } else {
        this.$commonburiedPoint({
          data: {
            itemid: items.skuid,
            skuid: items.skuid,
            recitemid: items.itemid ? items.itemid : ''
          }
        })
        query.recommend = 1
      }
      this.$router.push({
        path: '/productdetail',
        query: query
      })
    },
    /**获取图形验证码 */
    getCodeImg() {
      let width = this.$refs.codeImg.clientWidth
      let height = this.$refs.codeImg.clientHeight
      this.code = ''
      this.timeout = new Date().getTime() + '' + random_string(16)
      this.codeImg = this.$ajax.getValidateCode_URL(
        'sessionid=' + this.timeout + '&width=' + width + '&height=' + height
      )
    },
    Code() {
      let that,
        type,
        area_code = 86,
        url
      that = this
      type = 3
      url =
        that.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        that.mobile +
        '&code=' +
        that.code +
        '&sessionid=' +
        that.timeout +
        '&type=' +
        type +
        '&area_code=' +
        area_code
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.time = 60
          that.countdown()
        } else if (res.data.code == '10011') {
          layer.msg(res.data.msg)
          that.getCodeImg()
        }
      })
    },
    countdown: function () {
      var that = this
      var timer = setInterval(function () {
        that.time--
        if (that.time <= 0) {
          that.time = 0
          clearInterval(timer)
        }
      }, 1000)
    },
    sendAgain: function () {
      if (this.check('sms')) this.Code()
    },
    check: function (type) {
      if (!this.mobile) {
        this.$toast('请先输入手机号')
        return false
      } else if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        this.$toast('请输入正确的手机号')
        return false
      } else if (!this.code) {
        this.$toast('请输入图片验证码')
        return false
      } else if (!this.sms) {
        if (type == 'sms') {
          return true
        } else {
          this.$toast('请先输入短信验证码')
          return false
        }
      } else {
        return true
      }
    },
    confirm: function () {
      if (this.check()) {
        var url = this.$ajax.smsCodeVerify_URL + '?mobile=' + this.mobile + '&code=' + this.sms
        this.$customRequestAjax(url).then((res) => {
          if (res.data.code == 200) {
            this.goNext()
          } else {
            this.$toast('验证码有误')
            this.sms = ''
          }
        })
      }
    },
    cancel: function () {
      this.mobile = ''
      this.code = ''
      this.sms = ''
      this.goNext()
    },
    launch: function (e) {
      setTimeout(function () {
        window.location = downloadshoppath
      }, 500)
    },
    error: function () {
      window.location = downloadshoppath
    },
    checkAddress() {
      return new Promise((resolve, reject) => {
        this.getAddress()
          .then(() => {
            resolve()
            this.discern(this.addressVal.address, (res) => {
              if (res != null) {
                let area = []
                if (this.addressVal.area.indexOf('\n') >= 0) {
                  area = this.addressVal.area.split('\n')
                } else {
                  area = this.addressVal.area.split(' ')
                }
                if (
                  (area.length == 3 &&
                    (area[0] != res.data.province || area[1] != res.data.city)) ||
                  (area.length == 1 && area[0].indexOf(res.data.province + res.data.city) < 0)
                ) {
                  this.areatemp = res.data.province + ' ' + res.data.city + ' ' + res.data.county
                  this.areaidtemp =
                    res.data.province_code + ',' + res.data.city_code + ',' + res.data.county_code
                  this.addresstemp = res.data.detail
                } else {
                  this.areatemp = ''
                  this.areaidtemp = ''
                  this.addresstemp = ''
                }
              }
            })
          })
          .catch(() => {
            reject()
          })
      })
    },
    getAddress() {
      var urlAddress1 = this.$ajax.getAddressById_URL + '?id=' + this.$route.query.addressid
      if (sessionStorage.getItem('qt_token')) {
        urlAddress1 += '&qt_token=' + sessionStorage.getItem('qt_token')
      }
      var urlAddress2 = this.$ajax.getDefaultAddress_URL
      if (sessionStorage.getItem('qt_token')) {
        urlAddress2 += '&qt_token=' + sessionStorage.getItem('qt_token')
      }
      return new Promise((resolve, reject) => {
        if (this.$route.query.addressid) {
          this.$customRequestAjax(urlAddress1)
            .then((res) => {
              if (res.data.code === 200) {
                this.addressVal = res.data.addressdata
                resolve()
              } else {
                reject()
              }
            })
            .catch(() => {
              reject()
            })
        } else {
          this.$customRequestAjax(urlAddress2)
            .then((res) => {
              if (res.data.code === 200) {
                this.addressVal = res.data.addressdata
                resolve()
              } else {
                reject()
                if (res.data.code == 10000) {
                  /**游客身份 跳转登录 */
                  if (!isWeixin()) {
                    if (
                      that.waptoken.waptoken &&
                      that.waptoken.waptoken == that.waptoken.tourists
                    ) {
                      that.$router.push('/myorder')
                      that.$store.commit('ORDERLIST_NAVID', 0)
                      that.$router.push({
                        path: '/login',
                        query: {
                          routeval: 'myorder'
                        }
                      })
                    }
                  }
                }
              }
            })
            .catch(() => {
              reject()
            })
        }
      })
    },
    discern(site, callback) {
      discernFunc(
        site,
        () => {
          let url = this.$ajax.initAddress_URL + '?text=' + site
          this.$customRequestAjax(url).then((res) => {
            if (res != null && res.data.code == 200) {
              if (typeof callback === 'function') callback(res)
            } else {
              if (typeof callback === 'function') callback(null)
            }
          })
        },
        () => {
          if (typeof callback === 'function') callback(null)
        }
      )
    },
    parseCkGroupAvatarList: function (data) {
      var that = this
      var list = data.head_img_list || data.headImgList || []
      var total = parseInt(data.group_num || data.groupNum || list.length || 3, 10)
      that.ck_group_leader_index = parseInt(
        data.group_leader_index || data.groupLeaderIndex || 0,
        10
      )
      that.ck_group_avatar_list = []
      list.forEach(function (item, index) {
        if (typeof item === 'string') {
          that.ck_group_avatar_list.push({
            img: item,
            is_leader: index === that.ck_group_leader_index ? 1 : 0
          })
        } else {
          that.ck_group_avatar_list.push({
            img: item.img || item.headimg || item.head_img || '',
            is_leader: item.is_leader || 0
          })
        }
      })
      while (that.ck_group_avatar_list.length < total) {
        that.ck_group_avatar_list.push({ img: '', is_leader: 0 })
      }
      that.ck_group_avatar_list = that.ck_group_avatar_list.slice(0, total)
    }
  }
}
</script>
<style scoped lang="scss">
@import './css/addOrder_scoped.scss';
</style>
<style lang="scss">
@import './css/addOrder.scss';
</style>



// WEBPACK FOOTER //
// src/components/shopcart/addOrder.vue